export const TRANSLATION_RUS = {
	about_projects: {
		title_1: 'О проекте',
		text_1:
			'<p>Портал трудовых ресурсов <strong>«hr.enbek.kz»</strong> — это ключевой элемент экосистемы <strong>«Электронная биржа труда»</strong>, созданный для автоматизации процессов, связанных с трудовыми договорами. Он обеспечивает удобное и прозрачное управление такими задачами, как заключение и прекращение трудовых договоров, внесение изменений и дополнений, а также учет социальных отпусков. </p>' +
			'<p>Портал способствует упрощению и автоматизации кадрового делопроизводства, помогает работодателям соблюдать трудовое законодательство, а также обеспечивает защиту прав работников. Полная синхронизация с Единой системой учета трудовых договоров (ЕСУТД) делает его эталонным источником достоверной информации о трудовых отношениях</p>' +
			'<p>Одним из преимуществ Портала является единая авторизация в рамках <strong>Единой цифровой платформы занятости</strong>, что позволяет пользователям работать без создания дополнительных учетных записей, используя другие порталы экосистемы. После авторизации пользователи могут взаимодействовать с Порталом как в роли Работодателя, так и в роли Работника</p>' +
			'<p>Портал <strong>«hr.enbek.kz»</strong> — это надежный помощник для всех участников трудовых отношений в современном цифровом Казахстане</p>',
		title_2: 'Возможности портала для предприятий',
		text_2:
			'<ul>' +
			'<li>Регистрация трудовых договоров с действующими работниками и их изменения;</li>' +
			'<li>Рассмотрение запросов по корректировке трудового договора от работника (рассмотрение запроса на расторжение, удаление, редактирование);</li>' +
			'<li>Удаленное заключение электронного трудового договора с работником с помощью ЭЦП или QR-подписи через приложения eGov Mobile Business;</li>' +
			'<li>Ведение штатного расписания (ведение структуры, штатного состава, численность работников, учет рабочих мест и другое);</li>' +
			'<li>Самопроверка на соблюдение  онлайн трудовой консультант (выявление нарушений деятельности работодателя);</li>' +
			'<li>Оформление проактивной услуги по назначению профессиональный выплаты работнику, занятого на вредных условиях труда, путем регистрации расторжения трудового договора или регистрации дополнительного соглашения;</li>' +
			'<li>Оформление проактивной услуги по беременности и родам, путем регистрации социального отпуска работника;</li>' +
			'<li>Запрос личного дела работника (электронный пакет документов, необходимый при трудоустройстве) с согласия работника;</li>' +
			'<li>Отзыв о работнике;</li>' +
			'<li>Создание первичного и локального профсоюза и ведение учета членов профсоюза;</li>' +
			'<li>Заключение электронного коллективного договора с согласованием инспекцией труда;</li>' +
			'<li>Доступ к Цифровой карте предприятий для просмотра информации о предприятий из информационных систем государственных органов, статусе и благосостоянии работников, нарушениях на предприятии;</li>' +
			'<li>Регистрация сообщения о несчастном случаи на производстве;</li>' +
			'<li>Получение уведомлений о трудовых договорах, обновлениях и статусов услуг в реальном времени;</li>' +
			'</ul>',
		title_3: 'Возможности портала для работников',
		text_3:
			'<ul>' +
			'<li>Просмотр зарегистрированных работодателями трудовых договоров;</li>' +
			'<li>Удаленное заключение электронного трудового договора с работодателем с помощью ЭЦП или QR-подписи через приложения eGov Mobile;</li>' +
			'<li>Запрос на корректировку трудового договора для актуализации сведений; </li>' +
			'<li>Скачивание электронной трудовой книжки;</li>' +
			'<li>Получение справки с места работы;</li>' +
			'<li>Предоставление согласия работодателю на сбор и обработку персональных данных; </li>' +
			'<li>Просмотр своего Личного дела;</li>' +
			'<li>Отзыв о работодателе;</li>' +
			'<li>Калькулятор специальной социальной выплаты для проверки наличия права на специальную социальную выплату и размера выплаты для работников, занятых во вредных условиях труда;</li>' +
			'<li>Просмотр электронных больничных листов и возможность направления работодателю;</li>' +
			'<li>Просмотр профсоюзов с возможностью вступления;</li>' +
			'<li>Получение уведомлений о трудовых договорах, обновлениях и статусов услуг в реальном времени;</li>' +
			'</ul>',
		text_4:
			'<p>Функционал для работника также доступен в мобильном приложении Enbek HR в App Store и Google Play</p>' +
			'<p>Мы стремимся постоянно совершенствовать наш портал, делая его более удобным и эффективным для пользователей. В ближайших планах — внедрение множества полезных обновлений и новых функций. Следите за нашими новостями в уведомлениях и на официальной странице в Instagram, чтобы первыми узнавать о новых возможностях!</p>',
	},
	join_prof_unions: 'Я даю согласие профсоюзу на сбор и обработку персональных данных',
	term_etd_requests: 'Запросы на расторжение ЭТД',
	voice_robot: '(скажите "портал трудовых ресурсов" на вопрос голосового робота)',
	has_error: 'Произошла ошибка, повторите попытку позже!',
	no_data: 'Данных согласно запросу не найдено',
	no_contract: 'Вы еще не зарегистрировали ни одного договора!',
	specification: 'Описание',
	every_employer_is_given_the_opportunity_to: 'Каждому работодателю предоставляется возможность',
	self_check_yourself: 'самостоятельно пройти самопроверку',
	compliance_requirements_labor_legislation: 'соблюдения требований трудового законодательства.',
	self_check_performs: 'Самопроверка выступает',
	auxiliary: 'вспомогательным',
	tool_and_provides: 'инструментом и оказывает',
	assistance_for_improvement: 'содействие по улучшению',
	working_conditions_due_introduction_digital_tools: 'условий труда за счет внедрения цифровых инструментов.',
	the_service_is: 'Сервис является',
	anonymous: 'анонимным',
	name_organization_personal_data_not_requested_no_pre_registration_required:
		'не запрашивается наименование организации, персональные данные и не требуется предварительная регистрация.',
	start_self_test_you_need_fill_out_preliminary_questionnaire:
		'Для начала самопроверки, необходимо заполнить предварительную анкету.',
	questionnaire: 'Анкета',
	how_service_works: 'Как работает сервис',
	find_topic_you_need_using_search_category: 'Найдите нужную тему, используя поиск или категорию',
	choose_topic_start_answering_questions:
		'Выберите тему и начните отвечать на вопросы, с учетом вашего текущего состояния в организации',
	complete_self_test: 'Завершить самопроверку',
	system_will_analyze_responses_form_conclusion:
		'Система проанализирует ответы и сформирует вывод, в котором будет указан перечень нарушений или их отсутствие, рекомендаций.',
	violations_are_detected_employer_will_offered_recommendations:
		'При выявлении нарушений, работодателю будут предложены рекомендации и конкретные действия, которые следует предпринять в целях их устранения',
	after_violations_eliminated_you_can_re_check_yourself:
		'После устранения нарушений можно пройти повторную самопроверку',
	category_entrepreneurship: 'Категория предпринимательства (выбрать нужное)',
	how_will_help: 'Чем поможет «Онлайн трудовой консультант»?',
	independently: 'Самостоятельно',
	independentlyUtil: 'Самостоятельно',
	sort_out: 'разобраться',
	irequirements_labor_legislation: 'в требованиях трудового законодательства',
	understand: 'Понять',
	estimate: 'оценить',
	preliminary_violations: 'предварительные нарушения',
	get: 'Получить',
	recommendations: 'рекомендации',
	methods: 'способы',
	eliminate_violations: 'по устранению нарушений',
	improve: 'Улучшить',
	working_conditions: 'условия труда',
	correct: 'устранить',
	violations: 'нарушения',
	avoid: 'Избежать',
	regulations_fines_real_check: 'предписаний и штрафов в случае реальной проверки',
	save_money: 'Сэкономить',
	time_means_real_verification: 'время и средства при реальной проверки',
	small: 'Малый',
	medium: 'Средний',
	large: 'Крупный',
	count_employee: 'Количество работников',
	yes: 'Да',
	no: 'Нет',
	you_employees_disabilities_groups: 'Имеются ли у вас работники с инвалидностью 1 и 2 группы?',
	people_under_age_eighteen_work: 'Работают ли у Вас лица младше восемнадцати лет?',
	pregnant_women_work_you: 'Работают ли у Вас беременные женщины?',
	shift_method_work: 'Применяется ли у Вас вахтовый метод работы?',
	harmful_dangerous_working_conditions: 'Имеются ли у вас вредные, опасные условия труда?',
	pass_self_test: 'Пройти самопроверку',
	be_tested: 'Пройти проверку',
	history_passing: 'История прохождения проверки',
	history_check: {
		check_date: 'Дата проверки',
		result: 'Результат',
		action: 'Действие',
		watch_action: 'Смотреть',
		no_data: 'У Вас нет истории прохождения проверки',
		has_error: 'Произошла ошибка, повторите попытку позже!',
		check_history: 'Скрыть фильтр',
		filter: 'Фильтр',
		total_checks: 'Всего проверок: ',
		check_subject: 'Тема проверки',
		loading: 'Загрузка',
		checklist: 'Проверочный лист',
		business_name: 'Наименование предприятия',
		answers_questions: 'Ответы на вопросы',
		replay: 'Перепройти',
	},
	choose_topic_self_test: 'Выберите тему',
	topic_not_selected: 'Тема не выбрана',
	service: 'Сервис ',
	online_labor: '“Трудовой консультант”',
	start_self_test: 'Для начала самопроверки,',
	must_select_topic: 'необходимо выбрать тему',
	next_question: 'Следующий вопрос',
	complete_self_test_button: 'Завершить самопроверку',
	result: ' Результат',
	service_online_labor_consultant_check:
		'Сервисом «Трудовой консультант» проверено соблюдение требований трудового законодательства.',
	self_test_date: 'Дата самопроверки:',
	chapter: 'Раздел: ',
	self_test_duration: 'Продолжительность самопроверки: ',
	following_violations_identified: 'Выявлены следующие нарушения:',
	no_violations_found: 'Нарушений не выявлено',
	recommendationsTest: 'Рекомендации',
	download_result: 'Скачать результат',
	transition: {
		process_button_title: 'Перейти',
		warning: 'Вы подтверждаете переход на новый лист?',
	},
	not_answered: 'Вы не ответили на все вопросы в текущем листе самопроверки',
	switch_another_sheet: 'При переходе на другой лист самопроверки все данные из текущего листа будут потеряны',
	question_number: 'Вопрос ',
	year: ' г.',
	reference_information_questions: {
		1: {
			question: 'Не могут зайти под ЭЦП, выходит ошибка?',
			answer: 'Необходимо проверить установку программы NCALayer и/или срок действия ЭЦП',
		},
		2: {
			question: 'У меня нет ЭЦП, как я могу зайти?',
			answer:
				'Для того, чтобы зайти на портал требуется наличие электронной цифровой подписи (ЭЦП). В настоящий момент ЭЦП можно получить удаленно на сайте электронного правительства',
		},
		3: {
			question: 'Я в первый раз захожу на Портал, что мне необходимо сделать?',
			answer:
				'Если у Вас нет аккаунта, Вам необходимо пройти регистрацию. Регистрация аккаунта проходит на Главной странице в окне ВХОД посредством ЭЦП. В дальнейшем при каждом входе на Портал необходимо производить авторизацию через БИН если Вы работодатель или ИИН если Вы работник.',
		},
		4: {
			question:
				'Я, работодатель могу я не вносить трудовые договора и прекращения с работником трудового договора на данный Портал?',
			answer:
				'Нет. В соответствии пп.27 п.2 ст.23 действующего Трудового кодекса РК, работодатель обязан вносить информацию о заключении и прекращении с работником трудового договора, вносимых в него изменениях и (или) дополнениях.',
		},
		5: {
			question: 'На данном Портале услуги предоставляются платно? если да, то какие?',
			answer: 'На Портале трудовых ресурсов (ehr24) все услуги оказываются бесплатно.',
		},
		6: {
			question:
				'Нужно ли удалять договор, если сотрудник уволился по собственному желанию и трудовой договор расторгнут? Расторгнутый договор считается при заполнении количества сотрудников на предприятии?',
			answer:
				'Нет необходимости удалять расторгнутые ТД. В количестве активных сотрудников учитываются только действующие трудовые договора',
		},
		7: {
			question: 'Как удалить ошибочно внесенные договоры?',
			answer:
				'Для того чтобы удалить договор необходимо в списке договоров выбрать договор, нажать на кнопку <b><<{{button}}>></b> напротив данного договора и из выпадающего меню выбрать действи <b><<{{action}}>></b>',
			suggestions: {
				actions: 'Действия',
				remove_contracts: 'Удалить договор',
			},
		},
		8: {
			question:
				'Есть работники, принятые в основную компанию, а отчисления от филиала. Как быть в данном случае? Отдельный БИН в филиале, как быть с работниками: уволить или как-то по другому?',
			answer:
				'Нет необходимости удалять расторгнутые ТД. В количестве активных сотрудников учитываются только действующие трудовые договора. Согласно подпункту 39) пункта 1 статьи 1 Кодекса работодатель это физическое или юридическое лицо, с которым работник состоит в трудовых отношениях.. Согласно статье 33 Гражданского кодекса РК (далее – ГК РК) юридическим лицом признается организация, которая имеет на праве собственности, хозяйственного ведения или оперативного управления обособленное имущество и отвечает этим имуществом по своим обязательствам, может от своего имени приобретать и осуществлять имущественные и личные неимущественные права, и обязанности, быть истцом и ответчиком в суде.. Вместе с тем, отмечаем, что филиалы и представительства не являются юридическими лицами. Они наделяются имуществом создавшим их юридическим лицом и действуют на основании утвержденных им положений (пункт 3 статьи 43 ГК РК).. Таким образом, трудовой договор с работником заключается с юридическим лицом, то есть с головным предприятием и сведения в ЕСУТД вносит головное предприятие',
		},
		9: {
			question:
				'Как быть с работниками, которые находятся в отпуске без сохранения зарплаты: по ним ОПВ не будут, а в ЕСУТД они будут указаны. Не будет ли это расхождением?',
			answer:
				'Нахождение работника в отпуске без содержания будет выходить как расхождение по ОПВ, но напоминаем что данное уведомление носит только информативный характер.',
		},
		10: {
			question:
				'Необходимо ли работодателю подписывать согласие на обработку персональных данных прежде, чем внести сведения по ТД работника?',
			answer: 'На усмотрение работодателя.',
		},
		11: {
			question: 'Для чего необходимо внесение сведений по трудовым договорам? Что это дает?',
			answer:
				'Внесение сведений по трудовым договорам позволит создать эталонную базу данных по трудовой деятельности всех Работников РК. Система будет формировать достоверную информацию о трудовой деятельности наемных работников и позволит подтверждать стаж, а также контролировать поступления в фонд. Работодатели будут получать достоверную информацию о трудовой деятельности кандидата, Работник будет застрахован от социальных рисков. ЕСУТД позволит использовать упрощенную и оптимизированную систему кадрового делопроизводства, сократит время на подтверждение процедуры трудового стажа, квалификации, места работы сотрудника путем интеграции с сервисом по получению сведений по электронному досье Работника. Работнику же это даст снижение издержек при трудоустройстве, заключении трудового договора, упрощение дистанционного сотрудничества.',
		},
		12: {
			question: 'Вносить ли сведения по ИП состоящим из 1 человека?',
			answer: 'Нет',
		},
		13: {
			question: 'Вносить ли сведения по нерезидентам?',
			answer: 'Да. Производится внесение сведений по трудовым договорам всех наемных работников.',
		},
		14: {
			question: 'Вносить ли сведения по государственным служащим?',
			answer: 'Нет, внесение сведений по трудовой деятельности государственных служащих Кодексом не предусмотрено.',
		},
		15: {
			question:
				'Что если трудовой договор не был заключен, так как до 2007 года трудовой кодекс Республики Казахстан не регламентировал обязательное наличие трудового договора?',
			answer:
				'Согласно действующему трудовому кодексу, трудовой договор должен быть заключен в обязательном порядке. Согласно этому, если его нет, то необходимо заключить трудовой договор и зарегистрировать его.',
		},
		16: {
			question: 'На кого должно быть оформлено ЭЦП предприятия при регистрации ТД?',
			answer:
				'При регистрации трудовых договоров используется ЭЦП работодателя, оформленное на руководителя юридического лица, либо на доверенное лицо руководителя. Это может быть работник кадровой службы',
		},
		17: {
			question:
				'Почему ЭТД не содержит информации об оплате труда и условиях труда необходимых для заключения трудовых договоров? Если я перехожу на ЭТД, значит ли это что мне не нужно заключать ТД на бумажном носителе?',
			answer:
				'ЭТД – это аббревиатура электронного трудового договора. Работодатель может заключить трудовой договор электронно или традиционным способом на бумажном носителе, и в обязательном порядке вносит сведения по нему в ЕСУТД посредством enbek.kz/других порталов или ИС кадрового учета предприятия.',
		},
		18: {
			question: 'Нужно ли регистрировать трудовые договоры по уволенным работникам?',
			answer:
				'Регистрация трудовых договоров производится только в отношении текущих работников. При этом если работник уволился, то в системе фиксируется расторжение.',
		},
		19: {
			question: 'Нужно ли вносить сведения работников, с кем заключен трудовой договор до 18.09.2020 года?',
			answer:
				'Необходимо внести все действующие трудовые договора. При этом, данные действующих работников, принятых до 18.09.2020 года можно вносить: для предприятий с численностью до 2000 человек в течение года со дня вступления в силу настоящих Правил; для предприятий с численностью свыше 2000 человек в течение двух лет со дня вступления в силу настоящих Правил.',
		},
		20: {
			question:
				'Предусмотрены ли какие-либо штрафы, уголовная или административная ответственность за невнесение сведений о трудовых договорах?',
			answer:
				'Уголовная и административная ответственность за невнесение сведений о трудовых договорах не предусмотрены.',
		},
		21: {
			question: 'Как обеспечивается защита персональных данных работников?',
			answer:
				'Единая система учета трудовых договоров находится в единой транспортной среде государственных органов, система прошла испытание на информационную безопасность, в соответствии со всеми требованиями Государственной технической службы. Все интеграции производятся только через внешний шлюз «электронного правительства». Система проверена на соответствие требованиям «информационной безопасности» РГП «Государственная техническая служба» КНБ РК, получен сертификат об информационной безопасности. Система находится в Единой транспортной среде государственных органов, и интеграция внешних систем осуществляется только через Внешний шлюз «электронного правительства». Доступ к данным системы осуществляется только в рамках следующих законов: «О доступе к информации» Закон Республики Казахстан от 16 ноября 2015 года № 401-V ЗРК. «О персональных данных и их защите» Закон Республики Казахстан от 21 мая 2013 года N 94-V. «Об утверждении единых требований в области информационно-коммуникационных технологий и обеспечения информационной безопасности» Постановление Правительства Республики Казахстан от 20 декабря 2016 года № 832.',
		},
		22: {
			question:
				'Если информация будет храниться в электронном виде, смогут ли работодатели в электронном варианте сдавать ЭТД в гос. архив. И прописаны ли эти нормы в законах?',
			answer: 'Данная норма не предусмотрена в текущей редакции Трудового кодекса РК и Правил.',
		},
		23: {
			question: 'Профессиональные навыки и личные качества обязательны к заполнению?',
			answer:
				'Работодатель вносит информации о заключении и прекращении с работником трудового договора, вносимых по нему изменениях и дополнениях, содержащих сведения, предусмотренные подпунктами 1), 2), 3), 4), 5) и 13) пункта 1 статьи 28 Кодекса в единую систему учета трудовых договоров. Следовательно, внесение дополнительных сведений, таких как «военная обязанность», «специальные умения и навыки», «общие и гибкие навыки» необязательно.',
		},
		24: {
			question:
				'Необходимо ли регистрировать допсоглашения о выходе на дистанционную работу? Изменится ли место работы? В случае необходимости регистрации будет неполный рабочий день? (Размер оплаты труда уменьшится в 0,5 раза.)',
			answer:
				'При внесении дополнительного соглашения необходимо заполнить обязательные поля, такие поля выделены звездочкой * («Номер дополнительного соглашения», «Дата заключения дополнительного соглашения», «Дата начала действия дополнительного соглашения»), также необходимо заполнить соответствующее поле, которое изменилось',
			answer_1: 'при смене должности, заполняются поля «Должность» и «Штатная должность»',
			answer_2: 'при смене места выполнения работы, заполняется поле «Место выполнение работы»',
			answer_3: 'при смене Режима рабочего времени, заполняется поле «Режим рабочего времени»',
			answer_4:
				'при пролонгации трудового договора, необходимо заполнить «Срок договора» и «Дата окончания действия трудового договора». В поле «Дата окончания действия трудового договора» необходимо указать дату, на которую продлевается трудовой договор.',
		},
		25: {
			question: 'Если ранее уволенный работник возвращается, трудовой договор не получается ввести снова. Как быть?',
			answer:
				'При возникновении технических вопросов по внесению сведений о ТД необходимо обратиться в Министерство или АО «Центр развития трудовых ресурсов».',
		},
		26: {
			question: 'Как изменить данные ИИН при смене гражданства?',
			answer:
				'Данный функционал не реализован в ЕСУТД. Для решения данного вопроса, нужно направить письмо в Министерство с просьбой изменить ИИН работника в ЕСУТД и на портале enbek.kz. В письме должны быть указаны ИИН и ФИО работника, БИН организации, номер и дату договора.',
		},
		27: {
			question:
				'Можем ли мы местом выполнения работы указать просто город, т.к у работника нет рабочего места, у него разъездной характер работы?',
			answer:
				'При разъездном характере работы, в поле место выполнения работы необходимо указывать адрес работодателя.',
		},
		28: {
			question: 'Сотрудник не был внесен в ЕСУТД, в октябре скончался, система не дает возможности внести его сейчас?',
			answer:
				'В ЕСУТД графа «ИИН» является обязательным полем, у умершего человека ИИН нет, то есть в данном случае не вносятся сведения по трудовым договорам.',
		},
		29: {
			question: 'Вопрос о практикантах. Оплачиваемая практика. Нужно регистрировать ИТД? Временный на 1 месяц?',
			answer:
				'Статьей 30 Кодекса регламентирован срок заключения трудового договора. Кодексом не предусмотрено заключение трудового договора сроком на месяц, если не время выполнения определенной работы. Таким образом, если работодатель заключил с практикантом трудовой договор, то он вносит информацию о трудовом договоре в ЕСУТД.',
		},
		30: {
			question: 'Надо ли вносить данные по работающим пенсионерам?',
			answer:
				'Работодатель вносит сведения о трудовых договорах в ЕСУТД по всем трудовым договорам, в том числе и по работникам пенсионерам.',
		},
	},
	the_service_is_designed_to_synchronize:
		'Сервис предназначен для синхронизации данных о трудовых договорах ИС клиента с данными Единой системы учета трудовых договоров',
	integration_unified_system_recording_fastening: 'Регистрация синхронизации',
	integration_unified_system_recording: 'Регистрация пакетной загрузки',
	worker_profile_details: 'Сведения о профиле работников',
	service_employer_package_employee:
		'Сервис предназначен для предоставления Работодателю пакета документов Работника, необходимых при трудоустройстве, в электронном формате',
	employee_personal_affairs: 'Личное дело работника',
	the_service_is_designed_to_send_employees_contracts:
		'Сервис предназначен для отправки ответа со сведениями о профиле работников и учете трудовых договоров на запрос',
	the_service_is_designed_batch_loading: 'Сервис предназначен для пакетной загрузки трудовых договоров',
	download_archive_service: 'Скачать архив с описанием сервиса (*rar)',
	service_description: 'Описание сервиса',
	link_service_smartbridge: 'Ссылка на сервис на платформе SmartBridge',
	service_assignment: 'Назначение сервиса',
	the_service_is_intended_registration:
		'Сервис предназначен для регистрации учетных данных трудовых договоров, дополнительных соглашений и расторжений',
	integration_unified_system: 'Регистрация трудовых договоров',
	link_to_rules: 'Ссылка на правила',
	file: 'Файл',
	rule: 'rule-rus.pdf',
	download_rules:
		'Скачать правила представления и получения сведений о трудовом договоре в единой системе учета трудовых договоров (*pdf)',
	download_rules_harmful:
		'Скачать правила осуществления, приостановления, возобновления и прекращения профессиональной выплаты за счет средств работодателя (*pdf)',
	download_methodology:
		'Скачать методику по выплатам по договору обязательного страхования работника от несчастных случаев (*docx)',
	download_instruct: 'Cкачать инструкцию (*.pdf)',
	enter_information:
		'вносить информацию о заключении и прекращении с работником трудового договора, вносимых в него изменениях и (или) дополнениях, в ',
	workforce_portal: 'Портал трудовых ресурсов упрощает процессы кадрового делопроизводства такие как:',
	providing_access:
		'•	Предоставление доступа к единым профилям и трудовой историй работников (осведомленность о параллельной занятости работника);',
	reducing_risks:
		'•	Сокращение рисков фальсификации данных (трудовой стаж, больничные листы, судимости, ограничения и запреты);',
	simplification_personal: '•	Упрощение ведения личных дел работников;',
	reducing_cost: '•	Снижение стоимости оформления трудовых договоров (путем отказа от бумажных договоров).',
	convenience:
		'Для удобства Работодателей на Портале будет реализован сервис по предоставлению Личного дела Работника.',
	when_hiring:
		'При приеме на работу Работодатель посредством Портала сможет осуществить запрос в Единую систему учета трудовых договоров (далее - ЕСУТД) на получение ',
	personal_file: 'Личного дела ',
	employee_electronic_format:
		'работника в электронном формате. С учетом сведений из Личного дела Работодатель принимает решение о принятии на работу сотрудника и заключении с ним трудового договора. Также Работодатель может сформировать проект электронного трудового договора. Данный сервис исключает риск подделки документов и позволяет ускорить трудоустройство, путем отказа от предоставления бумажных документов при заключении трудовых договоров.',
	part_of_service_providing:
		'В рамках сервиса по предоставлению Личного дела Работника ЕСУТД интегрирована с информационными системами государственных органов Министерства юстиции РК, Министерства науки и образования РК, Комитет по правовой статистике и специальным учетам Генеральной Прокуратуры РК (далее - КПСиСУ ГП РК), Министерство здравоохранения РК (далее-МЗ РК), Министерство труда и социальной защиты населения РК. ',
	the_employer_opportunity:
		'Таким образом Работодатель имеет возможность предварительно получить следующие, имеющиеся в Личном деле, сведения:',
	information_about: '•	Информацию о физическом лице из удостоверения личности;',
	photo_image: '•	Фотоизображение;',
	information_about_family: '•	Информацию о членах семьи;',
	information_about_education: '•	Информацию об образовании;',
	electronic_certificate: '•	Электронную справку об отсутствии/наличии судимости;',
	information_about_status: '•	Информацию о состоянии на учете в псих, нарко и туб. диспансерах;',
	electronic_medical: '•	Электронную медицинскую справку 0/75у;',
	electronic_certificate_disability: '•	Электронную справку об инвалидности;',
	information_from: '•	Информацию из ЕСУТД об опыте работы',
	availability_vaccinations: '•	Информацию о наличии вакцинации',
	employer_right:
		'Работодатель имеет право запросить любую информацию о потенциальном работнике на выбор, в рамках условий, описанных в Трудовом Кодексе. Предоставление Личного дела работника третьему лицу предоставляется только с согласия Работника на обработку персональных данных в соответствии с Законом Республики Казахстан от 21 мая 2013 года №94-V «О персональных данных и их защите и иными нормативно правовыми актами Республики Казахстан. Согласие обязательно должно содержать информацию об организации запрашивающей данные. ',
	service_will_be_available:
		'Сервис будет доступен на Портале трудовых ресурсов и для интеграции посредством ИС кадрового учета предприятия и других порталов. Работодатель может отправить запрос сразу с согласием или без.  В таком случае согласие запрашивает сама система ЕСУТД. Согласие работника сможет подписать на портале трудовых ресурсов, ИС кадрового учета и через смс. ЕСУТД ждет ответа работника 7 календарных дней. В случае отказа или отсутствия ответа, работодателю будет отказано в предоставлении данных. Согласие будет действовать на весь срок работы в организации, которая запросила сведения. Если же договор не будет заключен или будет расторгнут, согласие автоматически считается не легитимным.',
	addition_registering:
		'Помимо регистрации трудовых договоров и получения Личного дела, в дальнейшей перспективе развития Портала планируется реализация услуг для работодателя по:',
	conclusion_electronic: '- заключению электронных трудовых договоров',
	obtaining_electronic: '- получению электронных больничных листов для учета',
	submission_reports: '- по сдачи отчетности в инспекцию труда и другие ГО',
	order_minister:
		'Приказ Министра труда и социальной защиты населения Республики Казахстан от 3 сентября 2020 года № 353. Зарегистрирован в Министерстве юстиции Республики Казахстан 4 сентября 2020 года № 21173 Об утверждении Правил представления и получения сведений о трудовом договоре в единой системе учета трудовых договоров',
	order_minister_2:
		'Приказ Министра труда и социальной защиты населения Республики Казахстан от 26 декабря 2023 года № 526. Зарегистрирован в Министерстве юстиции Республики Казахстан 27 декабря 2023 года № 33811',
	on_the_basis:
		'На основе внесенных данных по трудовым договорам формируется электронная трудовая книжка работника. Это исключает необходимость ведения бумажной версии. Работник сможет подтвердить свою трудовую деятельность в любое время.',
	first_of_all:
		'В первую очередь работник имеет возможность просмотра зарегистрированных трудовых договоров в Единой системе учета трудовых договоров, и получения уведомлений о всех производимых действиях с его трудовыми договорами.',
	ESUTD_is_reference_base:
		'ЕСУТД является эталонной базой по трудовой деятельности работников и служит источником для кредитных организаций, а также для других коммерческих организаций и гос.органов для подтверждения трудовой деятельности работника в соответствии с Законом «О защите персональных данных».',
	main_effects: 'Основные эффекты для работников:',
	remote_and_easy:
		'•	Дистанционное и легкое подписание электронного трудового договора, соответствующего трудовому законодательству РК;',
	reducing_the_time:
		'•	Сокращение времени при трудоустройстве путем отказа от сбора документов и посещения организаций;',
	receive_proactive:
		'•	Получение проактивных услуг по регистрации в базе по безработным и получению выплаты по беременности и родам;',
	receipt_of_commercial:
		'•	Получение коммерческих услуг без необходимости подтверждения занятости работника (в части подтверждения места работы);',
	monitoring_compliance:
		'•	Мониторинг соблюдения трудового законодательства работодателем и защита от социальных и трудовых рисков.',
	in_the_near_future:
		'В ближайшей перспективе при приеме на работу Работодатель посредством Портала сможет осуществить запрос в Единую систему учета трудовых договоров (далее - ЕСУТД) на получение Личного дела работника в электронном формате. Работник также сможет подписать согласие на обработку персональных данных и просмотреть Личное дело, полученное работодателем, а также заполнить автобиографию. На основе этих данных работодатель создает проект трудового договора. Также на портале будет доступно дистанционное подписание электронного трудового договора с помощью ЭЦП.',
	description_help: 'Описание',
	rules_submitting:
		'Правила представления и получения сведений о трудовом договоре в единой системе учета трудовых договоров',
	rules_harmful:
		'Правила осуществления, приостановления, возобновления и прекращения профессиональной выплаты за счет средств работодателя',
	instruction_employers:
		'Инструкция для работодателей по регистрации трудовых договоров на портале трудовых ресурсов hr.enbek.kz',
	methodology: 'Методичка по  выплатам по договору обязательного страхования работника от несчастных случаев',
	instr: {
		ref_1: 'Инструкция регистрация и вход на Портал',
		ref_2: 'Инструкция по работе на Портале в роли Работника',
		ref_3: 'Инструкция по работе на портале в роли работодателя',
		ref_4: 'Инструкция по добавлению предприятия',
		ref_5: 'Инструкция по добавлению трудовых договоров',
		ref_6: 'Инструкция по добавлению дополнительного соглашения к трудовому договору',
		ref_7: 'Инструкция по добавлению социального отпуска',
		ref_8: 'Инструкция по Актуализации ИИН',
		ref_9: 'Инструкция по автоматической пролонгации ТД',
		ref_10: 'Инструкция по переводу работников между филиалами',
		ref_11: 'Инструкция по смене БИН в связи с реорганизацией',
		ref_12: 'Инструкция для Работника по получению справки с места работы',
		ref_13: 'Инструкция по корректировке трудового договора для физ. лица',
		ref_14: 'Инструкция по заключению электронного трудового договора',
		ref_15: 'Инструкция по внесению сведений по вредным условиям труда',
		ref_16:
			'Инструкция по регистрации дополнительного соглашения и расторжения трудового договора по вредным условиям труда',
		ref_17: 'Инструкция по расторжению электронного трудового договора',
		ref_18: 'Инструкция по регистрации несчастного случая',
		ref_19: 'Инструкция по внесению и изменению штатного расписания',
	},
	video_instruction: 'Видеоинструкция:',
	asked_questions: 'ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ',
	servicesTabs: 'СЕРВИСЫ',
	instructions: 'ИНСТРУКЦИИ',
	based_entered_data_employment:
		'На основе внесенных данных по трудовым договорам формируется электронная трудовая книжка работника это исключает необходимость ведения бумажной версии',
	government_unemployment_support: 'Получайте государственную поддержку по безработице',
	termination_employment:
		'В случае прекращения трудового договора и отсутствия новой регистрации трудовых отношений в системе, подайте заявку на участие в программах поддержки занятости без дополнительных документов',
	manage_personal_documents:
		'Управляйте персональными документами из личного кабинета.  Приступайте к работе быстрее, получайте справку с места работы без необходимости обращения к работодателю',
	receive_state_support: 'Получайте государственную поддержку по получению выплаты по беременности и родам',
	use_opportunity:
		'Воспользуйтесь возможностью назначения выплат по беременности и родам в проактивном (онлайн) режиме на основании данных работодателя о регистрации социальных отпусков по беременности и родам',
	control_hr_documents: 'Контролируйте кадровые документы онлайн',
	get_automated_services: 'Получайте автоматизированные услуги от частного рынка',
	confirm_your_employment:
		'Нет необходимости подтверждать свою занятость при получении кредита в Банках второго уровня и других услуг рынка, при условии наличия интеграции с Единой системой учета трудовых договоров',
	your_mail: 'Ваш e-mail',
	your_phone_number: 'Ваш телефон',
	invalid_mail_entered: 'Введен некорректный e-mail',
	invalid_phone_number_entered: 'Введен некорректный номер телефона',
	terms_use: 'Пользовательское соглашение',
	register_employment_contracts_online: 'Регистрируйте трудовые договоры онлайн',
	learn_about_integration_unified_accounting_system_employment_contracts:
		'Узнайте об интеграции с Единой системой учета трудовых договоров',
	find_job_title: 'Найдите работу',
	find_employee: 'Найдите работника',
	pass_self_assessment_compliance_labor_law_requirements:
		'Пройдите самопроверку на соблюдение требований трудового законодательства',
	frequently_asked_questions: 'Часто задаваемые вопросы',
	form_store_personal: 'Формируйте и храните в единой базе личные дела команды',
	manage_entire_package: 'Управляйте всем пакетом документов сотрудников из личного кабинета',
	use_template_contracts: 'Используйте шаблонные договоры',
	types_employment_contracts_agreements:
		'В личном кабинете доступны все виды трудовых договоров и соглашений для работы с командой',
	access_single_employee_profile: 'Получайте доступ к единому профилю сотрудников',
	informed_experience_employment_employee: 'Будьте информированы об опыте и параллельной занятости сотрудника',
	work_verified_documents: 'Работайте с проверенными документами',
	save_time_processing: 'Экономьте время на обработке справок и ограничений',
	save_time_collecting_documents: 'Экономьте время на сборе документов',
	started_faster: 'Приступайте к работе быстрее, управляя документами из личного кабинета',
	government_support: 'Получайте государственную поддержку',
	termination_employment_contract_contract:
		'В случае расторжения трудового договора и отсутствия новой регистрации, подайте заявку по разным программам без дополнительных документов',
	control_hr: 'Контролируйте кадровые документы онлайн',
	managing_documents_security:
		'Управляя документами на портале, вы повышаете уровень социальной и профессиональной защищенности',
	question46: 'Почему у меня не открывается раздел "Трудовые договоры"?',
	answer46:
		'Раздел "Трудовые договоры" доступен только для пользователей с ролью "Работодатель", у которых в профиле добавлено хотя бы одно предприятие, а также для пользователя с ролью "Работник", который прошел верификацию.',
	question48:
		'При добавлении нового трудового договора выходит сообщение об успешном сохранении, но не могу найти трудовой договор в списке для подписания, как найти?',
	answer48:
		'Для того чтобы найти сохраненные (локальных) ТД, в расширенном поисковике необходимо выбрать состояние «Ожидает подписи». По умолчанию, в списке ТД отображаются только зарегистрированные в ЕСУТД ТД(подписанные и отправленные в ЕСУТД).',
	question1: 'Как зарегистрироваться на портале hr.enbek.kz в качестве нового пользователя?',
	answer1:
		'Вход производится через единое окно авторизации на «enbek.kz». Для регистрации на портале как работодатель нужно нажать на кнопку «Войти» в правом верхнем углу главной страницы. В открывшемся окне необходимо нажать на кнопку «Регистрация». Далее откроется форма регистрации, в которой:',
	answer1_1:
		'1.\tЗаполните регистрационную форму. Пожалуйста, обратите внимание на информацию, указанную в подсказках.',
	answer1_2: '2.\tПосле заполнения формы регистрации нажмите на кнопку «Создать аккаунт».',
	answer1_3:
		'3.\tДалее на указанный адрес электронной почты будет отправлена ссылка для активации аккаунта. Необходимо проверить электронную почту, указанную при регистрации, и пройти по ссылке, указанной в письме, аккаунт будет успешно активирован.  Важно! Запомните адрес электронной почты и пароль, указанный при регистрации! Они нужны Вам для последующего входа на портал.',
	question2: 'Что делать, если  забыли пароль?',
	answer2:
		'Если Вы забыли пароль от своего аккаунта, воспользуйтесь функцией восстановления пароля. Ссылка на эту функцию доступна в форме авторизации и называется «Забыли пароль?».',
	question3:
		'Я работодатель, могу я не вносить трудовые договоры и прекращения с работником трудового договора на данный Портал?',
	answer3:
		'В соответствии пп.27 п.2 ст.23 действующего Трудового кодекса РК, работодатель обязан вносить информацию о заключении и прекращении с работником трудового договора, вносимых в него изменениях и (или) дополнениях.\n' +
		'Это можно сделать посредством данного портала или любой другой системы подключенной к Единой системе учета трудовых договоров.\n',
	question4: 'На данном Портале услуги предоставляются платно? Если да, то какие?',
	answer4: 'На Портале трудовых ресурсов (hr.enbek.kz) все текущие услуги оказываются бесплатно.',
	question5: 'Нужно ли удалять договор, если сотрудник уволился и трудовой договор расторгнут? ',
	answer5:
		'Согласно «Правил представления и получения сведений о трудовом договоре в единой системе учета трудовых договоров» (далее-Правила)  работодатель в случае необходимости в течение 30 календарных дней со дня внесения первоначальных сведений:',
	answer5_1: '1) исправляет ошибки при неправильном введении сведений, указанных в пунктах 3 и 6 настоящих Правил;',
	answer5_2: '2) удаляет сведения при неправильном введении реквизитов работника и (или) работодателя.',
	answer5_3:
		'В связи с этим удаление применяется только в случае ошибочно зарегистрированных договорах. В случае расторжения трудового договора, необходимо воспользоваться функционалом расторжения ТД. Согласно Правил расторжение вносится в течение 3 рабочих дней со дня расторжения.',
	question6: 'Как удалить ошибочно внесенный трудовой договор?',
	answer6:
		'Для того чтобы удалить трудовой договор необходимо в списке договоров выбрать договор, нажать на кнопку «Действие» напротив данного договора и из выпадающего меню выбрать действие «Удалить договор».',
	question7:
		'Есть работники, принятые в основную компанию, а отчисления производиться от филиала. Как быть в данном случае? Кто должен регистрировать трудовой договор?',
	answer7:
		'Согласно подпункту 39 пункта 1 статьи 1 Трудового кодекса работодатель это физическое или юридическое лицо, с которым работник состоит в трудовых отношениях.\n' +
		'Согласно статье 33 Гражданского кодекса РК (далее – ГК РК) юридическим лицом признается организация, которая имеет на праве собственности, хозяйственного ведения или оперативного управления обособленное имущество и отвечает этим имуществом по своим обязательствам, может от своего имени приобретать и осуществлять имущественные и личные неимущественные права, и обязанности, быть истцом и ответчиком в суде.\n' +
		'Вместе с тем, отмечаем, что филиалы и представительства не являются юридическими лицами. Они наделяются имуществом создавшим их юридическим лицом и действуют на основании утвержденных им положений (пункт 3 статьи 43 ГК РК).\n' +
		'Таким образом, трудовой договор с работником заключается с юридическим лицом, то есть с головным предприятием и сведения в ЕСУТД вносит головное предприятие.\n',
	question8:
		'В ЛК налогоплательщика ежемесячно приходит уведомление о расхождениях между зарегистрированными ТД и количеством работников, имеющих ОПВ и СО, предусмотрен ли штраф за это уведомление?',
	answer8:
		'Данное уведомление носит информативный характер (ответа не требует). Министерство труда и социальной защиты населения РК выполняет рассылку уведомления один раз в месяц, чтобы работодатели могли контролировать количество трудовых договоров в ЕСУТД и в случае расхождений со сведениями об ОПВ/СО привели все в соответствие.\n' +
		'Уголовная и административная ответственность за неисполнение рекомендаций в данном уведомлении не предусмотрена.\n',
	question9:
		'В случае, когда работник находится в отпуске без сохранения заработной платы, пенсионных взносов не будет, а трудовой договор по нему будет зарегистрирован в ЕСУТД, будет ли это расхождением?',
	answer9:
		'В случае, если нахождение работника в отпуске без содержания связано с беременностью и родами, усыновлением (удочерением) новорожденного ребенка (детей), то не будет передаваться в расхождение по ОПВ. \n' +
		'В других случаях будет передаваться в расхождение, но оно является обоснованной причиной и напоминаем что данное уведомление носит только информативный характер.\n',
	question10:
		'Необходимо ли работодателю подписывать согласие на обработку персональных данных прежде, чем внести сведения по ТД работника?',
	answer10: 'На усмотрение работодателя.',
	question11: 'Я являюсь индивидуальным предпринимателем. Нужно ли мне вносить сведения по самому себе?',
	answer11:
		'Сведения вносятся только по трудовым договорам. В случае с индивидуальным предпринимателем трудовой договор не заключается. Следовательно индивидуальные предприниматели по себе сведения не вносят.',
	question12: 'Вносить ли сведения по нерезидентам?',
	answer12: 'Да. Производится внесение сведений по трудовым договорам всех наемных работников.',
	question13: 'Что делать если у нерезидента нет ИИН (либо выходит ошибка по ИИН)?',
	answer13: 'Иностранные граждане, не имеющие вида на жительство в РК, должны получить ИИН в следующих случаях:',
	answer13_1:
		'- если нужно открыть счет в банке;\n' +
		'- если иностранец получает доходы из источников, расположенных в Казахстане;\n' +
		'- при приобретении имущества, облагаемого налогами (авто, недвижимость);\n' +
		'- при назначении руководителем юридического лица-резидента РК или руководителем филиала юридического лица –нерезидента.',
	answer13_2:
		'Прежде, чем получить ИИН, иностранцы обязаны получить временную регистрацию в миграционной полиции Казахстана. Затем уже следует обратиться в КГД МФ РК (налоговый орган) или в ЦОН.\n' +
		'В случае отсутствия ИИН при добавлении трудового договора (Данные по ИИН запрашиваются из государственной базы данных физических лиц), Вам необходимо обратиться в миграционную полицию вашего региона.\n',
	question14: 'Нужно ли вносить сведения по государственным служащим?',
	answer14: 'Внесение сведений по трудовой деятельности государственных служащих Трудовым Кодексом не предусмотрено.',
	question15:
		'Что делать, если трудовой договор не был заключен, так как до 2007 года трудовой кодекс Республики Казахстан не регламентировал обязательное наличие трудового договора?',
	answer15:
		'Согласно действующему трудовому кодексу, трудовой договор должен быть заключен в обязательном порядке. Согласно этому, если его нет, то необходимо заключить трудовой договор и внести сведения по нему в ЕСУТД.',
	question16: 'На кого должно быть оформлено ЭЦП предприятия при регистрации ТД?',
	answer16:
		'При внесении трудовых договоров используется ЭЦП работодателя, оформленное на руководителя юридического лица, либо на доверенное лицо руководителя. Это может быть работник кадровой службы.',
	question17: 'Нужно ли регистрировать трудовые договоры по уволенным работникам?',
	answer17:
		'Если работник уволился до 18.09.2020, то нет необходимости регистрировать ТД.\n' +
		'Если работник уволился после 18.09.2020, то регистрация ТД обязательна.\n',
	question18: 'Нужно ли вносить сведения работников, с кем заключен трудовой договор до 18.09.2020 года?',
	answer18:
		'Необходимо внести все действующие трудовые договоры. При этом, данные действующих работников, принятых до 18.09.2020 года можно вносить:',
	answer18_1:
		'-\tдля предприятий с численностью до 2000 человек - в течение года со дня вступления в силу настоящих Правил;\n' +
		'-\tдля предприятий с численностью свыше 2000 человек - в течение двух лет со дня вступления в силу настоящих Правил.\n',
	question19:
		'Предусмотрены ли какие-либо штрафы, уголовная или административная ответственность за невнесение сведений о трудовых договорах?',
	answer19:
		'Уголовная и административная ответственность за невнесение сведений о трудовых договорах в Трудовом кодексе Республики Казахстан не предусмотрены. \n' +
		'Однако в соответствии с п. 11 ст. 193 ТК РК (ст. 330 ТК РК, действующего до 01.01.2016 года) государственные инспекторы труда при осуществлении государственного надзора и контроля за соблюдением трудового законодательства имеют право направлять в соответствующие правоохранительные органы и суды информацию, исковые требования и иные материалы по фактам нарушений трудового законодательства Республики Казахстан, неисполнения работодателями актов государственных инспекторов труда.\n',
	question20: 'Как обеспечивается защита персональных данных работников?',
	answer20:
		'Данные по трудовым договорам хранятся в базе данных Единой системы учета трудовых договоров. ЕСУТД находится в единой транспортной среде государственных органов, cистема проверена на соответствие требованиям «Информационной безопасности» РГП «Государственная техническая служба» КНБ РК, получен сертификат об информационной безопасности. Все интеграции производятся только через внешний шлюз «Электронного правительства». Доступ к данным системы осуществляется только в рамках следующих законов:\n' +
		'«О доступе к информации» Закон Республики Казахстан от 16 ноября 2015 года № 401-V ЗРК. «О персональных данных и их защите» Закон Республики Казахстан от 21 мая 2013 года N 94-V. «Об утверждении единых требований в области информационно-коммуникационных технологий и обеспечения информационной безопасности» Постановление Правительства Республики Казахстан от 20 декабря 2016 года № 832.',
	answer20_1:
		'«О доступе к информации» Закон Республики Казахстан от 16 ноября 2015 года № 401-V ЗРК.\n' +
		'«О персональных данных и их защите» Закон Республики Казахстан от 21 мая 2013 года N 94-V.\n' +
		'«Об утверждении единых требований в области информационно-коммуникационных технологий и обеспечения информационной безопасности» Постановление Правительства Республики Казахстан от 20 декабря 2016 года № 832.\n',
	question21:
		'Если информация будет храниться в электронном виде, смогут ли работодатели в электронном варианте сдавать ЭТД в гос. архив. И прописаны ли эти нормы в законах?',
	answer21: 'На данный момент данная норма не предусмотрена в текущей редакции Трудового кодекса РК и Правил.',
	question22: 'Профессиональные навыки и личные качества обязательны к заполнению?',
	answer22:
		'Работодатель вносит информации о заключении и прекращении с работником трудового договора, вносимых по нему изменениях и дополнениях, содержащих сведения, предусмотренные подпунктами 1), 2), 3), 4), 5) и 13) пункта 1 статьи 28 Кодекса в единую систему учета трудовых договоров.\n' +
		'Следовательно, внесение дополнительных сведений, таких как «Профессиональные навыки» и «Личные качества» необязательно.\n',
	question23: 'Необходимо ли регистрировать доп.соглашения о выходе на дистанционную работу?',
	answer23:
		'В случае изменения режима работы на дистанционную работу необходимо внести ДС изменив при этом поле «Дистанционная работа». В данном случае адрес место выполнения работ становится необязательным для заполнения.',
	question24: 'Как изменить данные ИИН при смене гражданства?',
	answer24:
		'В карточке договора необходимо нажать на кнопку «Актуализация ИИН при смене гражданства» и заполнить необходимые поля. После чего необходимо подписать с помощью ЭЦП и отправить в ЕСУТД на регистрацию.',
	question25:
		'Можем ли мы местом выполнения работы указать город, т.к у работника нет рабочего места, у него разъездной характер работы?',
	answer25:
		'При разъездном характере работы, в поле место выполнения работы необходимо указывать страну, регион или город, населенный пункт и полный адрес работодателя (улица, номер дома, офис).',
	question26:
		'Что делать, если сотрудник скончался и ТД не был внесен в ЕСУТД? Система не дает возможности внести его сейчас. ',
	answer26: 'В случае смерти человека, нет необходимости вносить сведения по нему в ЕСУТД.',
	question27: 'Вопрос о практикантах. Нужно ли регистрировать временный ТД заключенный на время оплачиваемой практики?',
	answer27:
		'Статьей 30 Трудового Кодекса регламентирован срок заключения трудового договора.\n' +
		'Если работодатель заключил с практикантом трудовой договор, то он вносит информацию о трудовом договоре в ЕСУТД.\n',
	question28: 'Надо ли вносить данные по работающим пенсионерам?',
	answer28:
		'Работодатель вносит сведения о трудовых договорах в ЕСУТД по всем трудовым договорам, в том числе и по работающим пенсионерам.',
	question29: 'Обязательно ли внесение соц.отпуска по беременности и родам и по уходу за ребенком?',
	answer29: 'Согласно Правил в ЕСУТД работодатель направляет следующие дополнительные сведения:',
	answer29_1: '1) режим рабочего времени и отдыха;',
	answer29_2:
		'2) о выходе работника в отпуск в связи с беременностью и рождением ребенка (детей), усыновлением (удочерением) новорожденного ребенка (детей), и в отпуск без сохранения заработной платы по уходу за ребенком до достижения им возраста трех лет.',
	question30:
		'Куда обращаться работнику в случае обнаружения ошибки в трудовом договоре в ЕСУТД или в случае ошибочно зарегистрированном ТД?',
	answer30:
		'Ответственность за внесение сведений несет работодатель, в случае обнаружения ошибки или отсутствия трудового договора, необходимо обратиться к работодателю. В случае ошибочно зарегистрированного трудового договора, то есть если работник не работает и никогда не работал в указанном предприятии, необходимо обратиться в уполномоченный орган по труду.',
	about_project: 'О проекте',
	main_information: 'Нормативно-справочная-информация',
	regular_questions: 'Часто задаваемые вопросы',
	for_employer: 'Работодателю',
	for_employer_to: 'Работодателям',
	for_worker: 'Работнику',
	for_worker_to: 'Работникам',
	staffing: 'Штатное расписание',
	staffing_create: 'Создать новое штатное расписание',
	staffing_create_from_table: 'Создать из штатного расписания',
	position_create: 'Создать должность',
	send_appointment: 'Отправить назначения в ЕСУТД',
	import_file: 'Импорт из файла',
	search_input: 'Введите наименование штатной должности',
	position_filled: 'Замещаемая должность',
	positions_combination: 'Совмещение должности',
	count_staff_units_1: 'Кол-во штатных единиц ',
	count_staff_units_2: ' из них свободно ',
	count_staff_units_3: 'Количество добавленных единиц в проект штатного расписания ',
	add_position: 'Назначить на должность',
	staffing_table: {
		project: 'Проект',
		history: 'История',
		admin: 'Администрирование',
		code: 'Код',
		union_name: 'Структурное подразделение',
		name: 'Тип структуры',
		code_wp: 'Код',
		workplace_code_label: 'Код рабочего места',
		count_staff_units: 'Штатных ед.',
		salary: 'Оклад',
		supplement_surcharge: 'Надбавка/Доплата',
		sum: 'Оклад факт',
		action: 'Действие',
		iin: 'ИИН',
		fio: 'Ф.И.О.',
		birthDay: 'Дата рождения',
		position_name: 'Должность',
		rate: 'Ставка (всего/свободно)',
		contract_number: '№ договора',
		begin_date: 'Дата начала',
		end_date: 'Дата окончания',
		cause: 'Примечание',
		status: 'Статус отправки',
		status_assignment: 'Статус назначения',
		number_bets: 'Кол-во ставок',
		info_no_positions: 'В этом структурном подразделении не создано должностей',
		info_no_staff: 'Проект штатного расписания не создан',
		substitute_fio: 'Ф.И.О. замещаемого',
		rate_and_count: 'Тарифная ставка/Количество единиц',
		group_code: 'Код группы профессий',
		count_work_place: 'Количество рабочих мест',
	},
	staff_modal: {
		title: 'Вы удаляете с должности сотрудника. Вы уверены, что хотите удалить c должности сотрудника?',
		note_placeholder: 'Укажите основание для удаления с должности сотрудника',
		yes: 'Да',
		no: 'Нет',
		choose_from_handbook: 'Выберите значение',
		title_position: 'Назначение на должность',
		create_position: 'Создание рабочего места и должности',
		position_category: 'Категория должности',
		edit_position: 'Редактирование рабочего места',
		info_position: 'Информация по рабочему месту',
		workplace_code: 'Код рабочего места',
		workplace_code_hint:
			'Произвольный, уникальный (неповторяющийся) код рабочего места (РМ), необходим для переноса рабочих мест и идентификации',
		workplace_placeholder: 'Введите код рабочего места',
		salary_placeholder: 'Введите оклад',
		supplement_surcharge_placeholder: 'Введите надбавку',
		cause_placeholder: 'Введите примечание',
		freelancer: 'Внештатный сотрудник',
		freelancer_position: 'Внештатная должность',
		position_kz: 'Должность на казахском языке',
		position_ru: 'Должность на русском языке',
		position_placeholder: 'Введите штатную должность',
		title_staffing_first: 'Штатное расписание',
		order_number: 'Номер приказа',
		order_date: 'Дата приказа',
		code: 'Код структуры',
		code_placeholder: 'Введите код структуры',
		order_number_placeholder: 'Введите номер приказа',
		comment: 'Комментарий',
		comment_placeholder: 'Введите комментарий',
		staff_information: 'Информация о структуре',
		subsidiary: 'Добавить дочернюю организацию (филиал)',
		bin: 'БИН/ИИН дочерней организации',
		bin_placeholder: 'Введите БИН/ИИН',
		structure_name: 'Наименование структуры на русском языке',
		structure_name_kz: 'Наименование структуры на казахском языке',
		structure_name_placeholder: 'Введите наименование структуры на русском языке',
		structure_name_placeholder_kz: 'Введите наименование структуры на казахском языке',
		structure_type: 'Тип структуры',
		structure_type_placeholder: 'Выберите тип структуры',
		structure_add: 'Добавить структуру',
		number_bets_placeholder: 'Введите количество ставок',
		info_workPlace: 'Информация по группе профессий',
	},
	workplace: {
		title: 'Информация о рабочем месте',
		create_date: 'Дата создания рабочего места',
		tariff_rate: 'Количество единиц',
		tariff_rate_required: 'Тарифная ставка *',
		count_tariff_rate: 'Количество единиц *',
		manual_input: 'Ручной ввод должности *',
		directory: 'Должность из справочника *',
		accept_position: 'Назначенные на должность',
		edit_position: 'Редактирование:',
		information_prescribing: 'Информация о назначении',
		staff_unit: 'Штатная единица',
	},
	copy: 'Центр развития трудовых ресурсов',
	our_socials: 'Мы в соцсетях',
	our_phone: 'Наш телефон',
	more_details: 'Подробнее',
	useful_information: 'Полезная информация',
	documents_bank: 'Банк типовых документов',
	government_demand: 'Требования трудового законодательства',
	single_system: 'О единой системе учета трудовых договоров',
	service_integration_data_transmission: 'Об интеграции с сервисом актуализации справочников ЕСУТД',
	service_integration_sync: 'Об интеграции с сервисом синхронизации трудовых договоров',
	service_integration_packages: 'Об интеграции с сервисом пакетной загрузки трудовых договоров',
	service_integration_registry: 'Об интеграции с сервисом регистрации трудовых договоров',
	have_question: 'Есть вопрос',
	ask_your_question: 'Задайте его через форму ниже',
	your_name: 'Как Вас зовут?',
	select_region: 'Выберите регион из справочника',
	question_topic: 'Тема вашего вопроса',
	question: 'Ваш вопрос',
	fill_in_full_data: 'Заполните все данные',
	attache_file: 'Прикрепить файл',
	send: 'Отправить',
	remove: 'Удалить',
	remove_contract: 'Удалить ошибочный договор',
	donwload_reference: 'Скачать справку',
	call_to_us: 'Или позвоните сами',
	call_within_kz: 'для звонков по Казахстану',
	refer_to_regional_inspection: 'Обратитесь в региональную инспекцию труда',
	chose_area: 'Выберите область',
	choose_city: 'Выберите город или район',
	find: 'Найти',
	inspector: 'Инспeктор',
	director: 'Директор',
	difficulties: 'Возникли трудности?',
	contact_technical_support: 'Обратитесь к нам в службу техподдержки,\n' + 'так мы сможем решить вашу проблему.',
	send_message: 'Отправить сообщение',
	digital_ecosystem: 'Цифровая экосистема возможностей',
	tone_button: 'доп.5',
	conversations_kz: 'Для звонков по Казахстану',
	main: 'ГЛАВНОЕ',
	portal: 'ПОРТАЛ',
	consultant: 'Трудовой консультант',
	checksTab: 'ПРОВЕРКИ',
	historyChecksTab: 'ИСТОРИЯ ПРОВЕРОК',
	services: 'Сервисы',
	questions: 'Вопросы',
	helpTab: 'НПА',
	crtr: ' АО «Центр развития трудовых ресурсов»',
	rus: 'Қазақша',
	language: 'RU',
	error_change_lng: 'Ошибка при изменении языка',
	feedback: 'Обратная связь',
	ask_feedback: 'Задайте вопрос через форму ниже:',
	company_name: 'Коммунальное государственное учреждение «Центр занятости населения акимата города Нур-Султан»',
	rate_worker_detect:
		'Оценка уровня социальной защищенности работника в Казахстане остается на слабом уровне. Трудовые договоры часто не заключаются, обязательства по ним не исполняются, трудовые книжки теряются, и работнику приходится обойти все места работы и поднимать архивы.',
	you_are_under_detect: 'На портале трудовых ресурсов вы полностью защищены',
	registration: 'Регистрация',
	registration_as: 'Зарегистрироваться в качестве',
	registration_as_worker: 'работника',
	registration_as_employer: 'работодателя',
	reduction_time: 'Сокращение сроков трудоустройства путем отказа от сбора документов и посещения организаций',
	proactive_base:
		'Проактивная регистрация в базе по безработным в случае расторжения трудового договора и отсутствия регистрации нового трудового договора',
	get_proactive_service: 'Возможность получения проактивных услуг',
	social_defend: 'Защита от социальных рисков',
	search_qualified_workers:
		'Вносите сведения по трудовым договорам и соблюдайте законодательство путем получения уведомлений Портала о необходимости своевременной актуализации данных',
	source_portal: 'Портал трудовых ресурсов упрощает процессы кадрового делопроизводства',
	reduction_cost_employment_contracts: 'Снижение стоимости оформления трудовых договоров',
	simplification_touch_contracts: 'Упрощение ведения личных дел',
	risk_reduction:
		'Сокращение рисков фальсификации данных (трудовой стаж, больничные, судимости, ограничения и запреты)',
	get_full_access:
		'Предоставление доступа к единым профилям и трудовой истории работников (осведомленность о параллельной занятости работника)',
	electronic_employment_contract: 'Электронный трудовой договор (ЭТД)',
	electronic_hint_contract:
		'Галочка проставляется если договор был заключен в электронном формате (подписан ЭЦП работодателя и работника). Если договор был заключен в бумажном формате, то галочка не проставляется.',
	electronic_contract_title: 'Электронный трудовой договор',
	download_pdf_eec: 'Скачать ЭТД',
	download_pdf_eds: 'Скачать ЭДС',
	download_pdf_ekd: 'Скачать ЭКД',
	date_created: 'Дата создания',
	send_to_rework: 'Отправить на доработку',
	revoke:
		'Вы действительно хотите отозвать подписание электронного трудового договора? В этом случае процесс заключения электронного трудового договора прекратится',
	revoke_eds:
		'Вы действительно хотите отозвать подписание электронного дополнительного соглашения? В Этом случае процесс заключения электронного дополнительного соглашения прекратится',
	decline: 'Отклонить',
	el_cause:
		'Укажите причину, по которой Вы отправляете проект электронного трудового договора на доработку Работодателю',
	el_cause_eds:
		'Укажите причину, по которой Вы отправляете проект электронного дополнительного соглашения на доработку Работодателю',
	el_cause_short: 'Укажите причину',
	sure_sign:
		'Вы заключаете электронное дополнительное соглашение с работником!  После подписания данные договора будут автоматически направлены в Единую систему учета трудовых договоров в соответствии с п.2 ст. 27 Трудового кодекса и любые изменения можно будет произвести только заключив дополнительное соглашение к договору.',
	sure_sign_employee: 'Я согласен с условиями договора и подписываю электронное дополнительное соглашение.',
	sure_decline:
		'Вы отклоняете подписание договора. Вы уверены, что хотите прекратить заключение электронного трудового договора?',
	sure_decline_eds:
		'Вы отклоняете подписание дополнительного соглашения. Вы уверены что хотите прекратить заключение электронного дополнительного соглашения?',
	employment_contracts: 'Трудовые договоры',
	collective_contract: 'Коллективный договор',
	employment_contract_1: 'Трудовой договор',
	worker_transfer_requests: 'Запросы на перевод работников',
	molding_personal_business: 'Формирование личного дела',
	registration_employment_contracts: 'Регистрация трудовых договоров',
	electronic_employment_contracts: 'Электронные трудовые договоры',
	employment_navigator: 'Трудовой навигатор',
	portal_employment_source: 'Портал трудовых ресурсов',
	reference_information: 'Справочная информация',
	entrance: 'Вход',
	i_employer: 'Я - работодатель',
	i_employee: 'Я - работник',
	registry: 'Регистрация',
	actual_resumes_vacancies: 'Актуальные резюме, вакансии и онлайн услуги в сфере занятости',
	learning_skills: 'Обучение  новым навыкам и возможность развития карьеры',
	support_business: 'Поддержка для запуска или расширения бизнеса',
	career_road: 'Построение своего карьерного пути',
	migration_description: 'Управление миграционными потоками в Казахстане',
	mansap_description: 'Выбор профессии и управление карьерной траекторией',
	digital_ecosystem_employment: 'Цифровая экосистема занятости',
	electronic_labor_exchange: 'Электронная биржа труда',
	app_download_link: 'Чтобы скачать мобильное приложение, наведите камеру телефона на данный QR',
	intro_sub_title: 'Организовывайте процесс трудоустройства онлайн',
	count_employment_contracts: 'договоров',
	count_employers: 'работодателей',
	count_workers: 'работников',
	contracts: 'договоров',
	contract_1: 'договор',
	intro_second_slider: 'Единое хранилише трудовых',
	intro_second_sub_title_first_part: 'Регистрируйте договоры и управляйте ресурсами команды',
	intro_third_title: 'Экономьте время на сборе',
	intro_third_title_second: 'документов - заключайте договоры онлайн',
	to_registration: 'Зарегистрироваться',
	max_file_size: 'Max file size is 15MB',
	phone: 'Телефон',
	email: 'Email',
	bin: 'БИН',
	yin: 'ИИН',
	me: 'Я',
	who_worker: 'работник',
	who_employer: 'работодатель',
	entered_wrong: 'Введен некорректный',
	enter_in: 'Введите',
	digital: 'цифр',
	make_up_password: 'Придумайте пароль',
	enter_password: 'Введите свой пароль',
	password_error: 'Пароль должен содержать не менее 8 символов и состоять из строчных, заглавных букв и цифр.',
	repeat_password: 'Повторите пароль',
	agree_for: 'Согласен/на',
	with_user_agreement: 'с пользовательским соглашением',
	and_you_can_keep_my_data: 'и даю согласие на сбор и обработку своих персональных данных',
	sign_ecp_and_continue: 'Подписать ЭЦП и продолжить',
	back: 'Назад',
	show: 'Показать',
	hide: 'Скрыть',
	forgot_password: 'Забыли пароль',
	enter_in_cabinet: 'Войти в кабинет',
	your_password_from_ecp: 'Введите пароль к ЭЦП',
	required_field: 'Обязательное поле',
	cancel: 'Отмена',
	close: 'Закрыть',
	close_message: 'Закрыть сообщение',
	next: 'Далее',
	company_id: 'ID предприятия',
	password_restoration: 'Восстановления пароля',
	make_up_new_password: 'Придумайте новый пароль',
	by: 'По',
	ecp_data: 'ЭЦП',
	sms_data: 'СМС',
	qr_data: 'QR',
	etd: 'ЭТД',
	code_from: 'Код из',
	continue: 'Продолжить',
	send_verification_code: 'Выслать код подтверждения',
	have_not_account: 'Еще нет аккаунта',
	similar_password_error: 'Пароль должен совпадать с тем, что вы задали',
	save_and_enter_in: 'Сохранить и войти',
	send_code_again: 'Отправить код повторно',
	in_time: 'через',
	second_in_short: 'с',
	your_email_label: 'E-mail, указанный при регистрации',
	incorrect_password: 'Введен некорректный пароль',
	incorrect_verification_code: 'Введен не верный код',
	incorrect_email: 'Введен некорректный Email',
	required_email_field: 'Поле Email не может быть пустым',
	required_password_field: 'Поле ввода пароля не может быть пустым',
	enter_verification_code: 'Введите код из 4 цифр',
	transfer_request_btn: 'Запросить перевод из другого филиала',
	transfer_request_title: 'Запрос на перевод работника(-ов) из другого филиала',
	transfer_request_date: 'Дата запроса',
	transfer_request_bin: 'БИН филиала, откуда переводится работник',
	transfer_branch_name: 'Наименование филиала',
	transfer_employeers_data: 'Данные работника (ов)',
	transfer_request_sended: 'Запрос отправлен',
	transfer_wait_for_confirmation: 'Ожидайте подтверждения от',
	transfer_watch_status: 'Вы можете отслеживать статус запроса в разделе “Запросы на перевод сотрудников”',
	transfer_go_to_list: 'Перейти к списку запросов',
	transfer_request_form_date: 'Дата формирования запроса',
	transfer_bin_to: 'БИН работодателя, куда переводятся работники',
	transfer_bin_from: 'БИН работодателя, откуда переводятся работники',
	transfer_name_to: 'Наименование работодателя, куда переводятся работники',
	transfer_name_from: 'Наименование работодателя, откуда переводятся работники',
	transfer_status_request: 'Статус запроса',
	transfer_status: 'Статус перевода',
	branch_info: 'Данные о работниках',
	employer_from: 'Работодатель, откуда переводятся работники',
	employer_to: 'Работодатель, куда переводятся работники',
	send_contract: 'Передать ТД',
	reject_transfer: 'Отказать в переводе',
	create_additional_agreement: 'Создать доп.соглашение',
	transfer_list_empty_message: 'Вы не подали ни одного запроса на перевод работников из другого филиала.',
	transfer_request_outgoing: 'Исходящие',
	transfer_request_incoming: 'Входящие',
	add_id: 'Добавить ИИН',
	send_request: 'Отправить запрос',
	choose: 'Выбрать',
	save: 'Сохранить',
	save_and_sign: 'Сохранить и подписать ЭЦП',
	refuse_for_selected: 'Отказать для выбранных',
	reset_all: 'Сбросить все',
	give_selected: 'Передать выбранные ТД',
	sign_and_send: 'Подписать ЭЦП и отправить',
	sign_and_prolong: 'Подписать ЭЦП и продлить',
	sign_and_save: 'Подписать ЭЦП и сохранить',
	sign_ecp: 'Подписать ЭЦП',
	sign_ecp_rsa: 'Выбрать ЭЦП (RSA)',
	and: 'и',
	restore: 'восстановить',
	terminate: 'расторгнуть',
	send_to_sign_worker: 'Отправить на подпись',
	sign_to_sign_employer: 'Подписать и отправить Работодателю',
	add: 'Добавить',
	save_as_template: 'Сохранить как шаблон',
	open_contract_text: 'Открыть текст договора',
	contract_text: 'Текст договора',
	attach_etd_pdf: 'Вложить PDF-файл проекта ЭТД',
	draft_etd: 'Проект электронного трудового договора (ЭТД)',
	contract_info: 'Информация о договоре',
	termination_info: 'Информация о прекращении/расторжении',
	cancel_changes: 'Отменить внесенные изменения',
	//About us
	registration_working_contract: 'Регистрация трудового договора в электронном формате',
	electronic_molding: 'Формирование электронного Личного дела Работника из ИС ГО',
	conclusion_contract: 'Заключение электронного трудового договора',
	automation_checking: 'Автоматическая проверка договора на соответствие Трудового кодекса РК',
	provide_information: 'Предоставление кадровой отчетности в ИС ГО',
	worker_professional_history: 'Ведение истории трудоустройства работника (электронная трудовая книжка)',
	edit_confirm_contract: 'Внесение изменений в действующий ЭТД',
	employee_comment: 'Комментарий работника',
	about_us: {
		introduce:
			'Портал трудовых ресурсов Республики Казахстан (ehr24) предназначен для автоматизации процесса учета трудовых договоров и взаимодействия государственных органов и работодателей',
		resolve_problems: 'Портал нацелен решать следующие задачи в отношениях работника и работодателя',
		full_zip_information:
			'Все сведения о трудовой деятельности работника (сведения о прежних местах работы) сосредоточены на Портале, с предоставлением возможности получения сведений в режиме онлайн, а также реализованы технические решения по получению обратной связи в мессенджерах',
	},
	//Employer page
	for_employer_page: {
		introduce:
			'Поиск качественных кадров требует затрат ресурсов от работодателя. Законодательство со своей стороны требует от работодателя вносить сведения по трудовым договорам',
		resolve_problems:
			'Портал трудовых ресурсов решает сразу все проблемы в процессе кадрового делопроизводства такие как',
		services: {
			provide_access:
				'Предоставление доступа к единым профилям и трудовой историй работников (осведомленность о параллельной занятости работника)',
			shorting_of_risks:
				'Сокращение рисков фальсификации данных (трудовой стаж, больничные листы, судимости, ограничения и запреты)',
			simplify_personal_data: 'Упрощение ведения личных дел',
			reduce_price: 'Снижение стоимости оформления трудовых договоров',
		},
		full_zip_information:
			'Для удобства Работодателей на Портале реализован сервис по предоставлению Личного дела Работника, где проведены интеграционные взаимодействия с Государственной базой физических лиц Министерства юстиции РК в части получения паспортных данных, с ИС НОБД Министерства науки и образования РК в части получения сведений о дипломе/образовании, с Комитетом по правовой статистике и специальным учета Генеральной Прокуратуры РК в части получения справки об отсутствии/наличии судимости для формирования Личного дела Работника, с Министерством здравоохранения РК в части получения справки из псих, нарко и туб. Диспансеров и в части получения справки 0/75у, АИС ЦБДИ Министерства труда и социальной защиты населения РК в части получения справки о наличии инвалидности, что в свою очередь обеспечивает удобство пользованием Порталом',
		effects_for_employers_list: {
			transfer_to_electronic_documents: 'Переход на электронные трудовые договора',
			keeping_electronic_book: 'Ведение электронной трудовой книжки',
			accessibility_for_employers: 'Доступ для работодателей к единым профилям работников',
			shorting_tome_for_iteration: 'Сокращение времени по интеграции',
		},
	},
	//Worker page
	for_worker_page: {
		introduce:
			'Оценка уровня социальной защищенности работника в Казахстане остается на слабом уровне. Трудовые договоры часто не заключаются, обязательства по ним не исполняются, трудовые книжки теряются, и работнику приходится обойти все места работы и поднимать архивы',
		resolve_problems: 'На портале трудовых ресурсов вы полностью защищены',
		services: {
			shorting_terms_of_employment:
				'Сокращение сроков трудоустройства путем отказа от сбора документов и посещения организаций',
			proactive_registration:
				'Проактивная регистрация в базе по безработным в случае расторжения трудового договора и отсутствия регистрации нового трудового договора',
			opportunity_of_getting_services: 'Возможность получения проактивных услуг',
			protect_from_socials_risks: 'Защита от социальных рисков',
		},
		full_zip_information: 'Реализованы технические решения по получению обратной связи в мессенджере',
		portal_is_providing:
			'Для упрощения трудоустройства работника Портал предоставляет возможность запроса работодателем документов для трудоустройства в электронном виде',
		portal_is_providing_2: 'На данный момент Портал предоставляет возможность сбора необходимой информации',
		portal_is_providing_2_0: 'Telegram-Bot с часто-задаваемыми вопросами',
		portal_is_providing_2_1: 'с согласия работника',
		portal_is_providing_2_2:
			'из информационных систем государственных органов посредством интеграционного взаимодействия с Министерством юстиции',
		portal_is_providing_2_3: 'адрес регистрации, удостоверение личности, место рождения',
		portal_is_providing_2_4: 'Министерством образования',
		portal_is_providing_2_5: 'информация об образовании',
		portal_is_providing_2_6: 'Комитетом по правовой статистике и специальным учета Генеральной Прокуратуры РК',
		portal_is_providing_2_7: 'информация отсутствия либо наличия судимости',
		portal_is_providing_2_8: 'Министерством здравоохранения',
		portal_is_providing_2_9: 'справки из псих, нарко и туб. диспансеров',
		portal_is_providing_2_10: 'Министерством труда и социальной защиты населения',
		portal_is_providing_2_11: 'сведения об инвалидности',
		portal_is_providing_2_12: 'Министерством юстиции',
		portal_is_providing_2_13: 'фотоизображение',
		effects_for_workers: 'Эффекты для работодателей',
		effects_for_workers_list: {
			order_has_power: 'Сделки имеют силу в суде (так как все действия подкреплены ЭЦП)',
			easy_assign: 'Легкое подписание трудового договора',
			discipline_of_interaction: 'Дистанционное взаимодействие с работодателем',
			shorting_time_within_employment: 'Сокращение времени при трудоустройстве',
		},
	},
	//Contracts
	contract: {
		see_full_text: 'Смотреть полный текст ЭТД',
		contract_info: 'Информация о договоре',
		info: {
			job_address: 'Место выполнения работы',
			remote_job: 'Форма занятости',
			number: 'Номер договора',
			td_number: 'Номер договора',
			type: 'Тип договора',
			registration_date: 'Дата заключения',
			start_date: 'Дата начала',
			expiration_date: 'Дата окончания',
			contract_term: 'Срок договора',
			termination_date: 'Дата расторжения',
			note: 'Примечание',
			note_body:
				'Договор расторгнут по желанию работника согласно заявлению о прекращении трудовой деятельности на работах с вредными условиями труда',
			note_body_additional:
				'Договор изменен по желанию работника согласно заявлению работника об изменении условий труда с вредных на нормальные',
			validity: 'Период действия',
			work_type: 'Вид работы',
			position: 'Должность',
			nkz_position: 'Должность на основе НКЗ',
			working_condition: 'Условия труда',
			established_position: 'Штатная должность',
			address: 'Адрес',
			country_code: 'Код страны',
			KATO_code: 'Код КАТО',
			time_mode: 'Режим рабочего времени',
			tariff_rate: 'Тарифная ставка',
			work_country: 'Страна места работы',
			work_region: 'Регион и район места работы',
			work_locality: 'Населенный пункт',
			work_address: 'Адрес места работы',
			conditions1: 'Тип работ по списку 1',
			conditions2: 'Тип работ по списку 2',
			conditions3: 'Тип работ по списку ОППВ',
			employeeRequest: 'Наличие заявления работника',
			employeeConsent: 'Согласие работника на обработку персональных данных',
			employerApprove: 'Согласие работодателя на осуществление профессиональной выплаты в размере 1 ПМ',
		},
		tariff_rate_tooltip: 'Только для неполного рабочего времени. Введите значение от 0 до 1 (например 0.5, 0.7 и т.д.)',
		error_get_contract: 'Произошла ошибка при открытии ТД. Попробуйте позже. ',
		placeholder_phone: 'Введите номер телефона +7',
	},
	update: 'Обновить',
	my_profile: 'Мой профиль',
	worker_data: 'Данные работника',
	full_bin_name: 'Полное наименование',
	change_password: 'Сменить пароль',
	update_data: 'Обновить данные',
	last_update_date: 'Дата последнего обновления',
	logo: 'Логотип',
	actualisation_data: 'Актуализация ИИН',
	during_change_citizenship: 'при смене гражданства',
	document_approve_personality: 'Документ, удостоверяющий личность',
	document_type: 'Тип документа',
	document_number: 'Номер документа',
	issue_date: 'Дата выдачи',
	issued_by: 'Кем выдан',
	contact_data: 'Контактные данные',
	phone_number: 'Номер телефона',
	registration_address: 'Адрес регистрации',
	not_approved: 'Не подтверждён',
	your_phone: 'Введите телефон',
	enter_address: 'Введите адрес',
	approve: 'Подтвердить',
	save_changes: 'Сохранить изменения',
	move_file_or: 'Перетащите файл в эту область или',
	upload_file_from_your_pc: 'Загрузите его со своего ПК',
	upload: 'Загрузить',
	file_formats: 'Формат файлов',
	to: 'до',
	kb: 'Кб',
	document_name: 'Наименование документа',
	id_identification: 'Удостоверение личности',
	enter_document_number: 'Введите номер документа',
	wrong_document_number: 'Некорректный номер документа',
	enter_issued_by: 'Укажите орган, выдавший документ',
	old_password: 'Старый пароль',
	enter_old_password: 'Введите старый пароль',
	come_up_new_password: 'Придумайте новый пароль',
	repeat_new_password: 'Повторите новый пароль',
	worker_iin: 'ИИН работника',
	entered_incorrect_bin_iin: 'Введен некорректный БИН/ИИН',
	personal_short_information: 'ФИО работника',
	filled_automate: 'Заполняется автоматически',
	reorganisation: 'Реорганизация',
	registration_number: 'Номер регистрации',
	registration_date: 'Дата регистрации',
	kind_activity: 'Вид деятельности',
	type_ownership: 'Форма собственности',
	state_registration_of_person: 'Государственная регистрация юридического лица',
	approved: 'Подверджён',
	only_for_not_full_work_day:
		'Только для неполного рабочего времени. Введите значение от 0 до 1 (например 0.5, 0.7 и т.д.)',
	change_bin_during_registration: 'Изменение БИН при реорганизации',
	new_bin: 'Новый БИН',
	name: 'Наименование',
	not_indicated: 'Не указано',
	already_exist_email: 'Пользователь с таким email уже существует',
	employer_doesnt_found: 'Юр.лицо не найдено',
	worker_doesnt_found: 'Физ.лицо не найдено в БД ГБДФЛ',
	bad_credentials: 'Неверный БИН/ИИН или пароль',
	termination_employment_contract:
		'Прекращение/расторжение трудового договора № {{contractNumber}} от {{registerDate}}',
	terminate_confirm: 'Понятно, все равно расторгнуть',
	terminate_delete_warning:
		'После прекращения/расторжения трудовой договор защищен от удаления, редактирования и создания дополнительных соглашений',
	terminate_cancelation_warning:
		'Для отмены ошибочного расторжения необходимо обратиться с официальным письмом в МТСЗН РК',
	terminate_edit_warning:
		'После прекращения/расторжения трудовой договор защищен от удаления, редактирования и создания дополнительных соглашений',
	confirm_edit_termination_data: 'Понятно, изменить данные о расторжении',
	register_soc_vacation: 'Регистрация социального отпуска к договору',
	soc_vacation: 'Социальный отпуск к договору',
	soc_vacation_delete: 'Социальный отпуск будет удален из вашего кабинета',
	soc_vacation_edit: 'Редактирование социального отпуска к договору',
	soc_vacation_type: 'Тип социального отпуска',
	vacation_date_start: 'Не работал(а) с',
	vacation_date_end: 'Не работал(а) по',
	vacation_date_work_start: 'Дата первого рабочего дня',
	incapacity_days: 'Выходные дни за период нетрудоспособности',
	set_weekends_count: 'Укажите количество выходных дней',
	timesheet_number: 'Номер табеля',
	set_timesheet_number: 'Укажите номер табеля',
	subdivision_ru: 'Наименование подразделения (рус)',
	subdivision_kz: 'Наименование подразделения (каз)',
	set_department_name: 'Укажите наименование подразделения',
	confirm_delete: 'Вы уверены, что хотите удалить',
	no_restore: 'без возможности восстановления?',
	yes_sign_and_delete: 'Да, подписать ЭЦП и удалить',
	yes_sign: 'Да, подписать ЭЦП',
	no_cancel: 'Нет, отмена',
	delete_yes: 'Да, удалить',
	vacation_info: 'Информация об отпуске',
	set_new_template_name: 'Укажите название нового шаблона',
	choose_template: 'Выберите шаблон',
	additional_contract_delete: 'Дополнительное соглашение будет удалено из вашего кабинета',
	additional_contract_number: 'Номер дополнительного соглашения',
	set_additional_contract_number: 'Укажите номер доп.соглашения',
	reg_date_additional_contract: 'Дата заключения доп.соглашения',
	start_date_additional_contract: 'Дата начала действия доп.соглашения',
	end_date_additional_contract: 'Дата окончания доп.соглашения',
	terminate_date: 'Дата прекращения/расторжения договора ',
	terminate_date_contract: 'Дата расторжения',
	contract_status: 'Статус договора',
	government_type_restore: 'Тип органа, вынесшего решение о восстановлении',
	restore_order_number: 'Номер приказа о восстановлении',
	government_name_restore: 'Наименование органа вынесшего решение о восстановлении',
	choose_from_directory: 'Выберите из справочника',
	position_placeholder: 'Укажите штатную должность или выберите из справочника',
	change_contract_term: 'Изменения срока трудового договора',
	change_contract_other: 'Изменение размера заработной платы и/или иных условий труда',
	change_contract_position: 'Изменение должности и/или условий труда',
	change_working_hours: 'Изменение режима рабочего времени',
	change_work_type: 'Изменение вида работ',
	change_work_country: 'Изменение места выполнения работы',
	change_iin_bin: 'Смена БИН/ИИН работодателя при переводе внутри филиальной сети или в случае реорганизации',
	change_term: 'Изменение срока трудового договора',
	change_other: 'Иные условия',
	enter_other_working_conditions: 'Введите иные условия труда, которые были изменены в доп.соглашении',
	edit_additional_contract: 'Редактирование дополнительного соглашения к договору',
	contract_validity: 'Срок действия трудового договора',

	//Create Additional Contract
	create_additional_contract: 'Создание дополнительного соглашения к договору',
	additional_contract_info: 'Информация о дополнительном соглашении',
	new_conditions: 'Новые условия договора',
	choose_conditions_to_change: 'Выберите условия договора, подлежащие изменению',
	password: 'Пароль',
	code_has_been_sent_successful: 'Код был успешно отправлен на вашу почту',
	code_has_been_verified_successful: 'Почта была успешно подтверждена',
	user_profile_updated_successfully: 'Информация о пользователе обновлена успешно',
	max_size_photo_error: 'Максимальный размер изображения 200 КБ',
	wrong_type_photo_error: 'Неверный формат файла',
	current_password_is_wrong: 'Неверный текущий пароль',
	password_has_been_changed: 'Пароль был изменён успешно',
	already_exist_bin: 'Пользователь с таким БИН уже существует',
	already_exist_iin: 'Пользователь с таким ИИН уже существует',
	user_with_the_same_email_doesnt_exist: 'Пользователя с такой почтой не существует',
	profile: 'Профиль',
	online_consultant: 'Трудовой консультант',
	employment_contract: 'Договоры',
	personal_records: 'Личное дело',
	notifications: 'Уведомления',
	events: 'События',
	nonotif: 'Уведомления отсутствуют!',
	noevent: 'События отсутствуют!',
	nodata: 'Нет данных (Ошибка при получении данных)',
	exit: 'Выйти',

	organisation_data: 'Данные организации',
	edit: 'Редактирование',
	account_settings: 'Настройка аккаунта',
	account_details: 'Реквизиты',
	contact_information: 'Контактная информация',
	experience_working_title: 'Предварительный расчет предпенсионных выплат',
	photo: 'Фото',
	required: 'Обязательное поле',
	invalid_email: 'Неверный формат почты',
	verification: 'Верификация',
	verification_type: 'Выберите способ верификации',
	verification_info: 'Необходимо пройти верификацию с помощью ЭЦП (RSA), СМС либо QR',
	select: 'Выбрать',
	min_12_length: 'Минимальная длина 12 символов',
	max_12_length: 'Максимальная длина 12 символов',
	contracts_tab: {
		export_text: 'Выберите какой список договоров Вы хотите выгрузить',
		not_correct_bin: 'Введен некорректный БИН',
		min_12_length: 'Минимальная длина 12 цифр',
		max_12_length: 'Максимальная длина 12 цифр',
		warning_info: 'Дата перевода работника в связи с реорганизацией не должна быть раньше даты заключения договора',
		contract_term: 'Срок договора',
		deleteAdditionalContract: 'Дополнительное соглашение будет удалено из вашего кабинета',
		deleteAdditionalContractText:
			'Вы уверены, что хотите удалить <div><strong>{{additionalContent}}</strong></div> без возможности восстановления?',
		deleteAdditionalContractNumber:
			'Доп. соглашение № {{additionalContractNumber}} к договору № {{contractNumber}} от {{registerDate}}',
		searchInput: 'Введите ИИН, имя контрагента или штатную должность',
		advancedSearch: 'Расширенный поиск',
		advancedSearchHide: 'Скрыть расширенный поиск',
		contract_number: 'Номер договора',
		contract_employer_number: 'Номер договора',
		indicate_contract_employer_number: 'Укажите номер трудового договора',
		contractor: 'Контрагент',
		position: 'Должность',
		status: 'Статус',
		expired_date: 'Дата окончания',
		conclusion_date: 'Дата заключения',
		registration_date: 'Дата регистрации',
		type: 'Тип',
		type_is_electronic: 'электронный',
		type_is_not_electronic: 'бумажный',
		state: 'Состояние',
		action: 'Действие',
		number: 'Номер',
		begin_date: 'Дата начала действия',
		signed: 'Подписано',
		vacation_type: 'Тип отпуска',
		not_worked_from: 'Не работал с',
		not_worket_till: 'Не работал по',
		registration_employer_contract: 'Зарегистрировать ТД',
		registration_collective_contract: 'Зарегистрировать коллективный договор',
		registration_employer_electronic_contract: 'Заключить ЭТД',
		registration_new_employer_contract: 'Регистрация нового трудового договора',
		registration_new_collective_contract: 'Регистрация коллективного договора',
		edit_collective_contract: 'Редактирование коллективного договора',
		change_contract_bin: 'Смена БИН в договорах правопредшественника в связи с реорганизацией',
		registration_employer_el_contract: 'Заключить электронный договор',
		information_about_contract: 'Информация о договоре',
		validity_term: 'Срок действия трудового договора',
		validity_term_hint: 'Срок действия трудового договора должен соответствовать со сроком действия разрешения',
		date_of_contract_signing: 'Дата подписания договора',
		start_contract_date: 'Дата начала работы',
		end_contract_date: 'Дата окончания действия договора',
		position_by_knz: 'Должность на основе НКЗ',
		indicate_position_or_select_from_handbook: 'Укажите штатную должность или выберите из справочника',
		job_type: 'Вид работы',
		working_time_mode: 'Режим рабочего времени',
		tarrif_rate: 'Тарифная ставка',
		country_work: 'Страна места работы',
		region_work: 'Регион места работы',
		distrcit_work: 'Район места работы',
		address_work: 'Адрес места работы',
		populated_area: 'Населённый пункт',
		indicate_address_work: 'Укажите адрес, выполнения работ',
		remote_work: 'Форма занятости',
		additional_information: 'Дополнительные сведения',
		professionals_skills: 'Профессиональные навыки',
		indicate_professionals_skills: 'Укажите профессиональные навыки',
		personal_qualities: 'Личные качества',
		indicate_personal_qualities: 'Укажите личные качества',
		contract_short_information: 'Договор № {{contractNumber}} от {{registerDate}}',
		contract_recover_information: 'Восстановить трудовой договор № {{contractNumber}} от {{registerDate}}',
		you_havnt_registered_any_contract: 'Вы не зарегистрировали ни одного договора',
		update_iin: 'Актуализировать ИИН',
		termination_reason: 'Основание прекращения/расторжения ТД',
		export: 'Выгрузить',
		current_list_treaties: 'Текущий список договоров',
		all_contracts: 'Все договора',
		current_contracts: 'Действующие договоры',
		terminate_contracts: 'Расторгнутые договоры',
		overdue_contracts: 'Просроченные договоры',
		error_irs: 'У данного работника нет разрешения для трудового иммигранта',
		error_immigrant:
			'У данного работника нет разрешения для иностранной рабочей силы(иностранцу или лицу без гражданства)',
		terminate: {
			process_button_title: 'Понятно, все равно расторгнуть',
			warning:
				'После прекращения/расторжения трудовой договор защищен от удаления, редактирования и создания дополнительных соглашений',
		},
		remove: {
			title: 'Договор будет удален из вашего кабинета',
			are_you_sure_no_recovery:
				'Вы уверены, что хотите удалить <div><strong>Договор №{{contractNumber}} от {{registerDate}}</strong></div> без возможности восстановления?',
			process_button_title: 'Да, подписать ЭЦП и удалить',
		},
		remove_contract: {
			title: 'Внимание!!!',
			are_you_sure_no_recovery:
				'Вы пытаетесь удалить трудовой договор. Удалённый трудовой договор невозможно восстановить.\n' +
				'Вы уверены, что хотите продолжить?',
		},
		confirm_contract: {
			title: 'Внимание!!!',
			are_you_sure_confirm:
				'Вы подтверждаете, что выбрали корректное разрешение по нерезиденту. В случае некорректности заполненных данных ответственность несёт работодатель.',
		},
		change_bin_because_of_reorganization: 'Смена БИН в связи с реорганизацией',
		predecessor_bin: 'БИН правопредшественника',
		date_employee_transfer: 'Дата перевода работника',
		check: 'Проверить',
		employees_data: 'Данные о работниках',
		employee_fio: 'Фамилия, имя и отчество сотрудника',
		enter_predecessor_bin: 'Введите БИН правопредшественника',
		not_found_in_ESUTD: 'не найдены в ЕСУТД',
		sign_and_send: 'Подписать и отправить выделенные',
		sign_and_send_all: 'Подписать и отправить все ТД',
		recover: {
			text: 'Для отмены ошибочного расторжения необходимо обратиться с официальным письмом в МТСЗН РК',
			confirm_button: 'Восстановить договор',
			cancel_text: 'Отменить',
			worker_iin: 'ИИН работника',
			worker_fio: 'ФИО работника',
			contract_info: 'Информация о договоре',
			recover_date: 'Дата восстановления договора',
			drestoreOrgTypeCode: 'Выберите причину восстановления',
			restoreOrder: 'Номер приказа о восстановлении',
			dcourtCode: 'Наименование органа вынесшего решение о восстановлении',
			select_from_dict: 'Выберите из справочника',
			put_order_number: 'Укажите номер приказа',
			select_from_dict_or_input: 'Введите наименование или выберите из справочника',
			sign_and_recover: 'Подписать ЭЦП и восстановить',
			reject_text:
				'Невозможно выполнить, по данному ТД/ДС/Расторжению направлен запрос на специальную социальную выплату',
			note: 'Комментарий',
			note_placeholder: 'Напишите комментарий о восстановлении трудового договора',
		},
		collective_agreement_conclude: 'Заключить коллективный договор',
		conclude_collective_contract: 'Заключение электронного коллективного договора',
		edit_conclude_collective_contract: 'Редактирование электронного коллективного договора',
	},
	modal_info: {
		cancel_text: 'ok',
		title:
			'В связи с истечением срока действия SSL-сертификата для NCALayer НУЦ РК провел обновление приложения 01.06.2022 года.',
		body: 'В случае возникновения ошибок при аутентификации и подписании посредством ключей ЭЦП НУЦ РК необходимо перезапустить NCALayer (произвести выход и запустить приложение), если ошибка повторится необходимо переустановить NCALayer по следующей ссылке',
	},
	modal_info_employer: {
		cancel_text: 'ok',
		title: 'Уважаемый работодатель!',
		body: 'В связи с техническими работами, запрос справки «Сведения о совершении лицом коррупционного преступления» временно недоступен. ',
		body_second: 'Приносим извинения за предоставленные неудобства!',
		additional_info: 'Пройти опрос',
		checkbox_text: 'Больше не показывать уведомление',
	},
	modal_general: {
		cancel_text: 'ok',
		title: 'Уважаемые работодатели!',
		body: 'Уведомляем Вас, что для заключения договора обязательного страхования работника от несчастных случаев (ОСНС), можете воспользоваться услугой АО «КСЖ «Государственная аннуитетная компания» Министерства труда и социальной защиты населения Республики Казахстан ',
		additional_info: 'Приносим извинения за предоставленные неудобства. Мы уже принимаем меры по устранению проблемы.',
	},
	modal_home: {
		cancel_text: 'ok',
		title: 'Уважаемые пользователи Портала трудовых ресурсов!',
		body: 'В связи с проведением провайдером технических работ по сети, с 30.03.2024 - 01.04.2024 Портал был недоступен. 02.04.2024 работа портала была восстановлена, однако на текущий момент продолжаются технические работы по устранению нестабильной работы Портала и проблем с подписанием договоров посредством ЭЦП.',
		body_second: 'Приносим извинения за неудобства. Работоспособность возобновится в ближайшее время.',
		checkbox_text: 'Больше не показывать уведомление',
	},
	search: 'Поиск',
	select_from_list: 'Выберите из списка',
	apply: 'Применить',
	employer_data: 'Данные работодателя',
	add_employer_data: 'Добавить работодателя',
	union_data: 'Данные профсоюза',
	employee_data: 'Данные работника',
	representative_data: 'Данные представителя',
	enterprise_name: 'Наименование',
	employee_yin: 'ИИН работника',
	representative_yin: 'ИИН представителя',
	representative_fio: 'ФИО представителя',

	employee_initials: 'Фамилия, имя и отчество',
	enter_count_digitals: 'Введите {{count}} цифр',
	choose_from_handbook: 'Выберите из справочника',
	value_from_to: 'Введите от {{from}} до {{to}}',
	no_data_find: 'Данные не найдены',
	//
	not_correct_iin: 'Введен некорректный ИИН',
	date_in_empty: 'Не указана дата вступления ',
	validation: {
		date: {
			min: 'Дата должна быть не позже {{ minDate }}',
			can_not_be_after_now: 'Дата не может быть позже текущей даты',
			can_not_be_before_sub: 'Дата подписания договора не может быть позже даты начала работы',
			end_before_start: 'Дата окончания действия договора не может быть раньше даты начала работы',
			end_date_before_start: 'Дата окончания не может быть раньше даты заключения',
		},
		invalid_email: 'Неверный формат почты',
		required: 'Это поле является обязательным',
		required_nc: 'Выберите разрешение из списка',
		required_permit_ti: 'У Вас нет разрешений для трудоустройства трудового иммигранта',
		required_permit_irs: 'У Вас нет разрешений для трудоустройства иностранной рабочей силы',
		required_date_from: 'Некорректная дата',
		required_date_to: 'Некорректная дата',
		required_nkz: 'Выберите должность из справочника',
		requiredList1:
			'Должно быть заполнено хотя бы одно значение из полей "Тип работ из списка 1" и "Тип работ из списка 2"',
		min_length: 'Минимальная длина: {{value}}',
		max_length: 'Максимальная длина: {{value}}',
		min_length_20: 'Минимальная длина: 20',
		wrong_symbol: 'Недопустимый символ(ы)',
		labor: {
			date: {
				min: 'не должно быть ранее 50 лет от текущей даты',
				min_contract: 'не должно быть раньше даты заключения контракта',
				max: 'не должно быть позднее текущей даты',
				max_contract: 'не должно быть позднее значения поля "Не работал по"',
				max_work_date: 'не должно быть позднее значения поля "Дата первого рабочего дня"',
				min_end_date: '"Не работал по" не должно быть раньше значения поля "Не работал с"',
			},
			number: {
				weekend: 'введите положительное число',
			},
		},
		staff: {
			greater: 'Должно быть больше 0',
			less_1000: 'Должно быть меньше или равно 1000',
			less_2_75: 'Должно быть меньше или равно 2.75',
			enter_integer: 'Введите целое число',
			min_value: 'Минимальное количество 1',
			max_value: 'Максимальное количество 300',
		},
		min_12_length: 'Минимальная длина 12 символов',
		max_12_length: 'Максимальная длина 12 символов',
		iin_bin_error_employer: 'ИИН работника не должен совпадать с БИН/ИИН работодателя'
	},
	company_titles: {
		add_new_company: 'Добавление новой организации',
	},
	update_ecp: 'Обновить ЭЦП',
	information_about_company: 'Информация о предприятии',
	add_company: 'Добавить предприятие',
	add_fl_employer: 'Добавить Работодателя ФЛ',
	add_fl_employer_text: 'Вы добавляете в предприятия Работодателя физическое лицо.',
	choose_company: 'Выберите предприятие',
	activity_type: 'Вид деятельности',
	ownership_type: 'Форма собственности',
	city: 'Город',
	region: 'Регион',
	populated_area: 'Населённый пункт',
	address: 'Адрес',
	house: 'Дом',
	office: 'Офис',
	worker_count: 'Количество работников',
	website: 'Адрес сайта',
	enter_website: 'Введите веб-сайт',
	mobilePhone: 'Мобильный телефон',
	phoneMobile: 'Телефон (мобильный)',
	internal: 'Внутренний',
	officePhone: 'Рабочий телефон',
	phoneOffice: 'Телефон (рабочий)',
	if_has: 'если есть',
	lastname: 'Фамилия',
	firstname: 'Имя',
	middlename: 'Отчество',
	contract_information: 'Контактная информация',
	details_about_company: 'Сведения о предприятии',
	write_what_you_want: 'Напишите, что считаете нужным',
	choose_ecp: 'Выбрать ЭЦП',
	select_ecp: 'Выбрерите ЭЦП',
	district: 'Район',
	notification: 'Уведомление',
	notifications_all: 'Все',
	notifications_read: 'Прочитанные',
	notifications_unread: 'Непрочитанные',
	notification_open: 'Открыть',
	notification_close: 'Закрыть',
	notification_go_back: 'Назад',
	notification_go_forward: 'Вперед',
	notification_show_per_page: 'Отображать по',
	notification_showed_per_page: 'Показано',
	notification_open_all: 'Смотреть все уведомления',
	notification_open_contract: 'Открыть договор',
	notification_open_etd: 'Открыть ЭТД',
	notification_open_addition_contract: 'Открыть доп.соглашение',
	notification_no_notifications: 'У вас пока нет уведомлений',
	pagination: {
		next: 'Вперед >',
		previous: '< Назад',
		show_per_page_text: 'Отображать по',
		show_all: 'Все',
		showed: 'Показано',
		from: 'из',
	},
	// My profile
	managers: 'Менеджеры',
	company: 'Предприятие',
	bin_iin: 'БИН/ИИН',
	iin: 'ИИН',
	certificate_expiry_date: 'Срок действия сертификата',
	electronic_mail: 'Электронная почта',
	city_district: 'Город или район',
	locality: 'Населенный пункт',
	web_address: 'Адрес сайта',
	employee_number: 'Количество работников',
	go_to_profile: 'Перейти в профиль',
	notification_centre: 'Центр уведомлений',
	logout: 'Выйти',
	edit_btn: 'Изменить',
	drag_file: 'Перетащите файл в эту область или',
	fio: 'ФИО',
	not_equal_bin: 'БИН/ИИН в ЭЦП не совпадает с БИН/ИИН предприятия',
	contract_termination_reason: 'Основание прекращения/расторжения трудового договора',
	contract_termination_checkbox:
		'Прекращение/расторжение ТД в связи с  внедрением новых технологий (цифровизации), приводящих к повышению производительности',
	contract_termination_without_employees_consent:
		'Расторжение ЭТД без согласия работника в связи с отсутствием взаимодействия с работником',
	contract_term: 'Срок договора',
	contract_end_date: 'Дата окончания договора',
	wait: 'Пожалуйста, подождите!',
	loading_from_esutd: 'Идет загрузка данных с ЕСУТД...',
	prolongation_title: 'Пролонгация трудового договора № {{contractNumber}} от {{registerDate}}',
	worker_fullname: 'ФИО работника',
	additional_contract_creation_title:
		'Создание дополнительного соглашения к договору № {{contractNumber}} от {{registerDate}}',
	select_all: 'Выбрать все',
	contract_work_district: 'Регион места работы',
	contract_work_region: 'Район места работы',
	contract_work_locality: 'Населенный пункт',
	work_address_placeholder: 'Укажите адрес, выполнения работ',
	esutd_reg_date: 'Дата регистрации в ЕСУТД',
	electronic_contract_number: 'Электронный договор №{{contractNumber}} от {{registerDate}}',
	contract_number: 'Электронный договор №{{contractNumber}} ',
	unknown_error: 'Неизвестная ошибка',
	sign_button: 'Подписать',
	sign_button_all: 'Подписать все',
	sign_button_ecp: 'Подписать ЭЦП',
	sign_button_qr: 'Подписать QR',
	error_qr: 'Ошибка при формировании QR-кода. Попробуйте пожалуйста позже.',
	error_was_signed: 'Ошибка при формировании QR-кода. Данный документ подписан.',
	time_out: 'Время ожидания истекло',
	text_edt_sign_employee: 'Я согласен с условиями договора и хочу подписать электронный трудовой договор',
	text_qr_sign_employee1: '1. Скачайте и установите приложение eGOV Mobile',
	text_qr_sign_employee1_biz: '1. Скачайте и установите приложение eGOV Business',
	text_qr_sign_employee2: '2. Откройте сканер QR в правом верхнем углу главной страницы приложения',
	text_qr_sign_employee3: '3. Наведите телефон на этот экран, чтобы считать код и подписать',
	text_edt_sign:
		'Вы заключаете электронный трудовой договор с работником!  После подписания данные договора будут автоматически направлены в Единую систему учета трудовых договоров в соответствии с п.2 ст. 27 Трудового кодекса и любые изменения можно будет произвести только заключив дополнительное соглашение к договору.',
	open_etd: 'Открыть ЭТД',
	open_eds: 'Открыть ЭДС',
	open_ecd: 'Открыть ЭКД',
	recall_etd:
		'Вы действительно хотите отозвать запрос расторжения электронного трудового договора? В этом случае договор останется действующим.',
	decline_etd:
		'Вы действительно хотите отклонить запрос расторжения электронного трудового договора? В этом случае договор останется действующим.',
	edit_button: 'Редактировать',
	recover_button: 'Восстановить',
	close_additional_contract: 'Закрыть доп.соглашение',
	add_contract_num: 'Номер доп.соглашения',
	work_address: 'Адрес места выполнения работ',
	create_add_contract: 'Создать допсоглашение',
	create_add_e_contract: 'Создать ЭДС',
	create_social_leave: 'Добавить соцотпуск',
	terminate_button: 'Расторгнуть',
	terminate_application: 'Заявление на расторжение',
	terminate_application_sended: 'Заявление на расторжение отправлено работодателю',
	parties_requisites: 'Реквизиты сторон',
	additional_contracts: 'Дополнительные соглашения',
	social_leaves: 'Социальные отпуска',
	auto_prolongation: 'Информация об автоматической пролонгации',
	close_contract: 'Закрыть трудовой договор',
	select_pls: 'Выберите',
	employee: 'Работник',
	iin_bin: 'ИИН/БИН',
	employer: 'Работодатель',
	view_add_contr_title:
		'Дополнительное соглашение № {{additionalContractNumber}} к договору № {{contractNumber}} от {{registerDate}}',
	edit_contr_title: 'Редактирование дополнительного соглашения к договору № {{contractNumber}}',
	default_date_value: 'дд.мм.гггг',
	edit_action: 'Редактировать',
	delete_action: 'Удалить',
	success_alert: 'Операция успешно выполнена!',
	error_reorganization_date:
		'Дата реорганизации из запроса отсутствует либо не должна быть раньше даты реорганизации из ГБД ЮЛ',
	social_leave: {
		form: {
			text: 'По сотруднику имеются сведения о нетрудоспособности. Выберите для предзаполнения:',
			oundata: 'Без предзаполнения',
			noworkstart: 'Сведения о нетрудоспособности с',
			noworkteel: 'по',
			noworkfinish: 'дата выхода',
		},
		registration_title: 'Регистрация социального отпуска к договору № {{contractNumber}} от {{registerDate}}',
		edit_title: 'Редактирование социального отпуска к договору № {{contractNumber}} от {{registerDate}}',
		view_title: 'Социальный отпуск к договору № {{contractNumber}} от {{entryDate}}',
		info: 'Информация о об отпуске',
		type: 'Тип социального отпуска',
		temporary_disability_title: 'Лист временной нетрудоспособности',
		leave_type_code_label: 'Код типа социального отпуска',
		leave_type_name_label: 'Наименование типа социального отпуска',
		begin_date_label: 'Не работал(а) с',
		end_date_label: 'Не работал(а) по',
		days_off_label: 'Выходные дни за период нетрудоспособности',
		days_off_placeholder: 'Укажите количество выходных дней',
		sheet_num_label: 'Номер табеля',
		sheet_num_placeholder: 'Укажите номер табеля',
		department: 'Наименование подразделения',
		department_ru: 'Наименование подразделения (рус)',
		department_kz: 'Наименование подразделения (Қаз)',
		department_placeholder: 'Укажите наименование подразделения',
		first_date_label: 'Дата первого рабочего дня',
		entryDate: 'Дата регистрации в ЕСУТД',
		close: 'Закрыть соц.отпуск',
		delete_title: 'Социальный отпуск будет удален из вашего кабинета',
		delete_confirm:
			'Вы уверены, что хотите удалить Соц.отпуск № {{leaveNumber}} к договору № {{contractNumber}} от {{entryDate}} без возможности восстановления?',
		no_data: {
			type_001: 'В системе Министерства внутренних дел Республики Казахстан сведения отсутствуют',
			type_002: 'В системе Министерства науки и высшего образования Республики Казахстан сведения отсутствуют',
			type_004: 'В системе Министерства здравоохранения Республики Казахстан сведения отсутствуют',
			type_005: 'В системе Министерства здравоохранения Республики Казахстан сведения отсутствуют',
			type_006: 'В системе Министерства здравоохранения Республики Казахстан сведения отсутствуют',
			type_007: 'В системе Министерства труда и социальной защиты населения Республики Казахстан сведения отсутствуют',
			type_009: 'В системе Министерства здравоохранения Республики Казахстан сведения отсутствуют',
			type_010: 'В системе Министерства внутренних дел Республики Казахстан сведения отсутствуют',
			type_014: 'В системе Министерства труда и социальной защиты населения Республики Казахстан сведения отсутствуют',
			type_016:
				'В системе Комитета по правовой статистике и специальным учётам Генеральной Прокуратуры Республики Казахстан сведения отсутствуют',
			review_empty: 'Данные по отзывам отсутствуют',
		},
	},
	signed_status: 'Подписан',
	pending_sign: 'Ожидает подписи',
	sign_and_terminate: 'Подписать ЭЦП и расторгнуть',
	date_error_min: 'Дата не может быть раньше {{minDate}}',
	date_error_max: 'Дата не может быть позже {{maxDate}}',
	update_iin: 'Актуализация ИИН работника (при смене гражданства)',
	enter_12_digits: 'Введите 12 цифр',
	new_epmloyee_iin: 'Новый ИИН Работника',
	auto_filled: 'Заполняется автоматически',
	employee_fio: 'ФИО Работника',
	enter_number: 'Введите номер',
	enter_fio: 'Введите Ф.И.О.',
	enter_position: 'Введите должность',
	actions: {
		view: 'Смотреть',
		edit: 'Редактировать',
		createAdditionalAgreement: 'Создать доп.соглашение',
		createSocialLeave: 'Добавить соц.отпуск',
		terminate: 'Расторгнуть',
		remove: 'Удалить',
		sign: 'Подписать',
		recover: 'Восстановить',
		revoke: 'Отозвать',
		prolongation: 'Пролонгировать',
		edit_termination: 'Редактировать расторжение',
		reject: 'Отклонить',
		sendEmployee: 'Отправить работнику',
		sendEmployer: 'Отправить работодателю',
		decline: 'Отказать',
		create: 'Добавить дочернюю',
		appoint: 'Назначить на должность',
		approve: 'Подтвердить',
		exclude: 'Исключить',
		join: 'Вступить',
		revision: 'На доработку',
		excludeFromTradeUnions: 'Выйти из профсоюза',
	},
	errors: {
		required: 'Это поле обязательно к заполнению',
		unknown_error: 'Неизвестная ошибка',
		econtract: {
			xml: 'Ошибка получения xml',
			send: 'Ошибка отправки',
		},
	},
	hint_position_knz:
		'Начните вводить первые 3 буквы должности для получения вариантов доступных должностей из справочника на основе Национального классификатора занятий',
	hint_position:
		'Заполните свое наименование должности, либо выберите из справочника (для Медико-социальных учреждений)',
	hint_working_condition: 'Выберите из справочника условия труда',
	hint_tarrif: 'Только для неполного рабочего времени. Введите значение от 0 до 1 (например, 0.5, 0.7 и т.д.)',
	session_expired: 'Сессия ескірген, қайта кіру қажет',
	delete_sign: 'Удалить верификацию',
	attention: 'Внимание!',
	delete_sign_title:
		'Работник будет удален из учетной записи. Повторную верификацию возможно провести с помощью ЭЦП, QR или СМС-подтверждения.',
	employeeProfile: {
		transfer: 'Перенести',
		moveToConfirm: 'Для переноса на текущего пользователя необходимо использовать перенос организации на себя',
		alreadyRegisteredOnMe: 'Данное предприятие уже зарегистрировано в Вашем личном кабинете',
		alreadyRegisteredOnPortal: {
			title: 'Данное предприятие уже зарегистрировано на портале!',
			description:
				'Предприятие уже зарегистрировано на портале. Вы можете перенести данное предприятие в свой личный кабинет на портале enbek.kz используя ЭЦП. После переноса, необходимо будет обновить список предприятий',
			action: 'Перейти на enbek.kz для переноса',
		},
	},
	personal_affairs: {
		medical_card: 'Личная медицинская книжка',
		worker: 'Работники',
		title: 'Личные дела',
		requests_title: 'Запросы на личные дела',
		request_electronic_affair: 'Запросить электронное личное дело',
		checking_social_payments: 'Проверить право работника на спец.соц.выплату',
		title_checking_social_payments: 'Проверка на право спец.соц.выплаты',
		accepted_payments: 'Имеет право на специальную социальную выплату',
		not_accepted_payments: 'Не имеет права на специальную социальную выплату',
		empty_status: 'Запрос можно отправить только по вашим действующим работникам',
		status: 'Статус: ',
		request_proactive: 'ЗАЯВКИ НА ПРОАКТИВ',
		search_placeholder: 'Введите ИИН или фамилию сотрудника',
		total_count: 'Всего дел',
		total_count_request: 'Всего запросов',
		table: {
			certificate_count: 'Количество справок',
			watch_action: 'Смотреть личное дело',
			field_number: '№',
			employer_name: 'Наименование работодателя',
			iin: 'ИИН работника',
			employee_fio: 'ФИО работника',
			request_date: 'Дата запроса',
			consent_date: 'Дата подписания ЭЦП работника',
			request_status: 'Статус запроса',
		},
		born_place: 'Место рождения',
		documents: 'Документы, удостоверяющие личность',
		document_name: 'Наименование документа',
		address_full_registration: 'Адрес постоянной регистрации',
		ou_name: 'Наименование ОУ',
		receipt_date: 'Дата поступления',
		certificate_issue_date: 'Дата выдачи аттестата',
		certificate_number: 'Номер аттестата',
		certificate_series: 'Серия аттестата',
		diploma_number: 'Серия диплома',
		course: 'Курс',
		language: 'Язык',
		release: 'Выпуск',
		class: 'Класс',
		education_form: 'Форма обучения',
		diploma_type: 'Тип диплома',
		education_category: 'Категория образования',
		tipo_cause: 'Причина выбытия ТИПО',
		vuz_cause: 'Причина выбытия ВУЗ',
		spec_tipo_1: 'Специальность и классификатор 1 (основной) ТИПО',
		spec_tipo_2: 'Специальность и классификатор 2 ТИПО',
		spec_tipo_3: 'Специальность и классификатор 3 ТИПО',
		spec_vuz_1: 'Специальность и классификатор 1 (основной) ВУЗ',
		spec_vuz_2: 'Специальность и классификатор 2 ВУЗ',
		spec_vuz_3: 'Специальность и классификатор 3 ВУЗ',
		end_date: 'Срок окончания',
		nkz_position: 'Должность НКЗ',
		med_organization_address: 'Наименование медицинского учреждения',
		work_education_address: 'Место работы/учебы/детского учреждения',
		last_examination: 'Дата последнего медицинского обследования',
		last_examination_diseases: 'Заболевания, выявленные с момента последнего медосмотра наименование',
		doctor_fio: 'ФИО врача',
		therap_conclusion: 'Заключение терапевта',
		therap_fio: 'ФИО терапевта',
		date: 'Дата',
		name_code: 'Наименование код',
		narco_conclusion: 'Заключение нарколога',
		narco_fio: 'Заключение нарколога',
		narco_date: 'Дата обращения к наркологу',
		liquid_examination: 'Исследования жидких биологических сред на наличие психоактивных веществ',
		psycho_conclusion: 'Заключение психиатра',
		x_ray_data: 'Данные рентгенологического обследования',
		doctor_conclusion: 'Врачебное заключение о профессиональной пригодности с указанием условий',
		lab_data: 'Данные лабораторных исследований',
		filling_fio: 'ФИО заполнявшего справку',
		head_fio: 'ФИО руководителя медицинской организации',
		sign_date: 'Дата подписи',
		error: 'Ошибка',
		go_to_personal_affair: 'Перейти к личному делу',
		requested_information: 'Запрашиваемые справки',

		no_data: 'У Вас нет сформированных личных дел',
		has_error: 'Произошла ошибка, повторите попытку позже!',
		request: {
			title: 'Запрос личного дела физического лица из Государственных баз данных',
			form: {
				choose_data_label: 'Выберите необходимые данные',
				id_label: 'Документ, удостоверяющий личность',
				photo_label: 'Фото с документа, удостоверяющего личность',
				education_label: 'Документ об образовании',
				employment_label: 'Трудовая книжка',
				medicine_label: 'Медицинская справка 075/у',
				medicine_drug_label: 'Учёт в псих/нарко/туб организациях',
				status_candas: 'Удостоверение Қандаса',
				committing_corruption_crime: 'Сведения о совершении лицом коррупционного преступления',
				military_service: 'Сведения о прохождении воинской службы',
				reviews: 'Отзывы о работнике (оставленные работодателями)',
				action: 'Подписать ЭЦП и отправить запрос',
			},
		},
		card: {
			title: 'Личные данные',
			info: {
				gender: 'Пол',
				birthday: 'Дата рождения',
				nationality: 'Национальность',
				citizenship: 'Гражданство',
				label: 'Личное дело',
			},
			table: {
				title: 'Полученные справки',
				headers: {
					name: 'Наименование справки',
					request_data: 'Дата запроса',
					sign_data: 'Дата подписания',
					result: 'Результат',
					download: 'Скачать',
				},
			},
		},
		terminal_date: 'Дата прекращения/расторжения: ',
		termination_reason: 'Основание прекращения/расторжения: ',
		loading_status: 'Ожидается проверка на право получения выплаты',
	},
	employee_affairs: {
		tabs: {
			first: {
				title: 'Личное дело',
				action: 'Открыть личное дело',
			},
			second: {
				title: 'Запросы на личное дело',
				action: 'Запросить электронное личное дело',
			},
		},
	},
	qandas: {
		place_of_birth: 'Место рождения',
		assignment_date: 'Дата присвоения статуса',
		expiration_date: 'Срок действия статуса',
		name_of_mio: 'Наименование МИО',
	},
	military: {
		local_authority: 'Наименование местного органа',
		status: 'Статус',
		comment: 'Комментарий',
		code_movu: 'Код местного органа',
		rank: 'Звание военнослужащего',
		rank_code: 'Код звания военнослужащего',
		is_assigned_bin: 'Юридическое лицо',
		booking_number_bin: 'Номер брони юридического лица',
		specialty: 'Воинская учетная специальность',
		specialty_code: 'Код воинской учетной специальности',
		period: 'Период прохождения воинской службы',
		begin: 'Начало',
		end: 'Конец',
	},
	corruption: {
		type: {
			unjudged: 'Коррупционных преступлений не выявлено',
			judged: 'Выявлено коррупционное преступление',
			uncertain: 'Выявлено коррупционное преступление неопределенное решением суда',
		},
		more_info_uncertain: 'Дополнительная информация о совершении коррупционного преступления:',
		answer_code: 'Код промежуточного ответа',
		cause: 'Причина',
		more_info_judged: 'Дополнительная информация о совершении коррупционного преступления',
		as_an_accused:
			'По сведениям на осужденного, привлеченного в качестве обвиняемого, арестованного, тип, описывающий одну запись',

		number: 'Номер',
		article_attraction: 'Статья привлечения',
		court: 'Суд',
		court_date: 'Дата суда',
		article_of_condemnation: 'Статья осуждения',
		main_penalties: 'Основные меры наказания',
		final_sentence: 'Окончательный срок наказания',
		additional_penalties: 'Дополнительные меры наказания',
		guilty_verdict: 'Обвинительный приговор',
		corruption_crime: 'Преступление коррупционное',
		mode_type: 'Вид режима',
		conditional_punishment: 'Применение условного наказания',
		trial_period: 'На испытательный срок',
		deferred_execution: 'Применение отсрочки исполнения',
		grace_period: 'Срок отсрочки',
		medical_nature: 'Применение принудительных мед медицинского характера',
		medical_measures: 'Вид принудительных мер медицинского характера',
		date_of_judgment: 'Дата вступления приговора',
		date_of_sentencing: 'Дата исчисления срока наказания',
		formal_conviction: 'Формальный срок погашения судимости',
		criminal_case1: 'Основание прекращения уголовного дела',
		criminal_case2: 'Основание прекращения уголовного дела',
		organ: 'Орган, прекративший уголовное дело',
		termination_by_amnesties: 'Прекращение по амнистий',
		exonerating_grounds: 'Прекращение по реабилитирующим основаниям',
		force_of_the_judgment: 'Дата вступления приговора в законную силу',
		instance: 'Инстанция',
		court_body: 'Орган суда',
		judgment_date: 'Дата вынесения судебного решения',
		decision: 'Принятое решение',
		condemnation_decriminalized: 'Статья осуждения декриминализирована',
		criminal_record: 'Снятие, погашение судимости',
		date_of_removal: 'Дата снятия, погашения судимости',
		court_body2: 'Орган суда',
		release_data: 'Данные об освобождении',
		date_release: 'Дата освобождения',
		reason_for_release: 'Причина освобождения',
		court_body3: 'Орган суда',
		court_order: 'Дата вынесения постановления суда',
		person_released: 'Лицо условно-досрочно освобождено на испытательный срок',
		order_on_parole: 'Дата вынесения постановления суда об УДО',
		released_on_parole: 'Кем освобожден УДО',
		actual_release: 'Дата фактического освобождения условно-досрочно',
		release_period: 'Срок освобождения',
		deregistration_date: 'Дата снятия с учета',
		additional_marks: 'Дополнительные отметки',
		organ2: 'Орган',
		preventive_measure: 'Мера пресечения',
		date_of_arrest: 'Дата ареста',
		criminal_case: 'Номер уголовного дела',
		initiation_criminal: 'Дата возбуждения уголовного дела',
		archiving_number: 'Номер архивного дела',
		fingerprint_formula: 'Дактилоскопическая формула',
		article_attraction2: 'Статья привлечения',
		nature_crime: 'Характер преступления',
		about_the_previous: 'Информация о предыдущем приговоре',
		relapse: 'Рецидив',
		movement_convict: 'Данные о движении осужденного',

		convicted_persons: 'По арестованным задержании и осужденным лицам',
		number2: 'Номер',
		criminal_case_number: 'Номер уголовного дела',
		date_sentencing: 'Дата вынесения приговора',
		condemned_the_person: 'Орган, осудивший лицо',
		article_condemnation: 'Статья осуждения',
		term: 'Срок',
		additional_marks2: 'Дополнительные отметки',
		entry_into_force: 'Вступление приговора в законную силу',
		fingerprint_formula2: 'Дактилоскопическая формула',
		engagement_date: 'Дата привлечения',
		organ3: 'Орган',
		preventive_measure2: 'Мера пресечения',
		criminal_code: 'Статья УК',
		other_marks: 'Другие отметки',
		additional_penalties2: 'Дополнительные меры наказания',
	},
	package_loading: {
		error_text:
			'Имеется(ются) ошибка(и) при подписании документов. Чтобы увидеть текст ошибки, необходимо открыть карточку договора',
		warning_text: 'Имеются неподписанные документы',
		contract_error_text: ' Не зарегистрован по причине: {{errorText}} (Код ошибки: {{errorNumber}})',
		warning_text_additional:
			'Имеется ошибка при подписании доп.соглашения. Чтобы увидеть текст ошибки, необходимо открыть карточку доп.соглашения',
		warning_text_leave:
			'Имеется ошибка при подписании соц.отпуска. Чтобы увидеть текст ошибки, необходимо открыть карточку соц.отпуска',
	},
	terms_page: {
		terms_title: 'Пользовательское соглашение об использовании портала трудовых ресурсов',
		title_1: '1. ОБЩИЕ ПОЛОЖЕНИЯ',
		chapter_chapter_1:
			'1.1. Настоящее Пользовательское соглашение об использовании Портала трудовых ресурсов (далее – Соглашение) регулирует отношения по использованию Портала трудовых ресурсов (',
		chapter_chapter_2: ') физическими или юридическими лицами, зарегистрировавшимся на Портале трудовых ресурсов (',
		chapter_chapter_3: ').',
		chapter_2: '1.2. В настоящем Соглашении используются следующие понятия:',
		chapter_3:
			'1) Портал трудовых ресурсов (далее – Портал) – система, расположенная на доменном имени www.hr.enbek.kz, предназначена для автоматизации учета трудовых договоров, взаимодействия государственных органов и работодателей.',
		chapter_4: '2) Пользователь –физическое или юридическое лицо, принявшее условия настоящего Соглашения.',
		chapter_5:
			'3) Администратор Портала (далее – Администратор) – работники акционерного общества «Центр развития трудовых ресурсов», осуществляющие сопровождение и системно-техническое обслуживание Портала;',
		chapter_6:
			'4) Учетная запись (аккаунт) - набор данных, хранящихся в программном обеспечении и (или) системе Портала, содержащих сведения, необходимые для идентификации Пользователя в целях предоставления ему доступа. Учетная запись создается Администратором Портала при регистрации на Портале Пользователем;',
		chapter_7: '5) собственник Портала – акционерное общество «Центр развития трудовых ресурсов»;',
		chapter_8:
			'6) Инструкция по работе на Портале - документ, содержащий правила, указания или руководства, устанавливающие порядок и способ выполнения или осуществления на Портале.',
		title_2: '2. ПРЕДМЕТ СОГЛАШЕНИЯ',
		chapter_9:
			'2.1. Предметом настоящего Соглашения является предоставление Пользователю доступа к содержащимся на Портале информации и урегулирование взаимоотношений по оказанию следующих услуг и сервисов Портала:',
		chapter_10: '1) заключение электронного трудового договора;',
		chapter_11: '2) регистрация трудовых договоров;',
		chapter_12: '3) трудовой консультант;',
		chapter_13: '4) формирование личного дела;',
		chapter_14: '5) справочная информация.',
		chapter_15:
			'2.2. Настоящее Соглашение является публичным договором-офертой (предложением) согласно пункту 5 статьи 395 Гражданского Кодекса Республики Казахстан и регулирует отношения, возникающие при пользовании Портала.',
		chapter_16:
			'2.3. Администратор оставляет за собой право в любое время изменять, добавлять или удалять пункты настоящего Соглашения без уведомления Пользователя.',
		chapter_17: 'Новая редакция настоящего Соглашения вступает в силу с момента ее опубликования на Портале.',
		chapter_18:
			'2.4. Пользователь подтверждает, что безусловно согласен со всеми условиями настоящего Соглашения в полном объеме, без всяких оговорок и исключений, и в полной мере осознает их значение, а также возможные последствия нарушения этих условий, и принимает настоящее Соглашение. Принимая условие настоящего Соглашения, Пользователь обязуется выполнять условия настоящего Соглашения.',
		chapter_19:
			'2.5. Настоящее Соглашение вступает в силу с момента принятия Пользователем его условий (акцепт) путем прохождения процедуры регистрации на Портале, что по смыслу пункта 3 статьи 396 Гражданского кодекса Республики Казахстан является принятием (акцептом) оферты Администратора.',
		chapter_20: 'Настоящее Соглашение действует на неопределенный срок.',
		chapter_21:
			'2.6. Принимая условия настоящего Соглашения, Пользователь дает согласие на сбор, обработку и хранение его персональных данных исключительно для целей реализации условий настоящего Соглашения.',
		chapter_22:
			'2.7. Использование материалов и сервисов Портала регулируется нормами действующего законодательства Республики Казахстан.',
		title_3: '3. ПРАВА И ОБЯЗАННОСТИ СТОРОН',
		chapter_23: '3.1. Пользователь вправе:',
		chapter_24: '3.1.1. получать доступ к использованию Портала при условии соблюдения условий настоящего Соглашения;',
		chapter_25:
			'3.1.2. пользоваться Порталом для получения услуг, описанных в пункте 2.1. раздела 2 настоящего Соглашения;',
		chapter_26: '3.1.3. прекратить пользование Учетной записью и расторгнуть настоящее Соглашение;',
		chapter_27: '3.1.4. менять логин и (или) пароль для доступа к Учетной записи;',
		chapter_28: '3.1.5. осуществлять иные права, не запрещенные законодательством Республики Казахстан.',
		chapter_29: '3.2. Пользователь обязуется:',
		chapter_30:
			'3.2.1. предоставить Администратору достоверную, точную и полную информацию по пунктам, предлагаемым в форме регистрации на Портале. Любые сомнения Администратора о недостоверности информации, предоставленной Пользователем, влекут за собой отказ в регистрации, временную блокировку и (или) удаление Учетной записи Пользователя;',
		chapter_31: '3.2.2. не выдавать себя за другое физическое или юридическое лицо;',
		chapter_32:
			'3.2.3. сохранить в тайне уникальный логин и пароль, используемые для доступа в Учетную запись. Логин и пароль Учетной записи, являются конфиденциальной информацией и не подлежат разглашению, за исключением случаев, предусмотренных действующим законодательством Республики Казахстан. Любые риски, связанные с утерей Пользователем пароля и логина собственной Учетной записи, Пользователь несет самостоятельно;',
		chapter_33:
			'3.2.4. периодически знакомиться на Портале с содержанием настоящего Соглашения в целях ознакомления с изменениями, внесенными согласно пункту 2.3. раздела 2 настоящего Соглашения;',
		chapter_34: '3.2.5.  не размещать на Портале:',
		chapter_35: '3.2.2. не выдавать себя за другое физическое или юридическое лицо;',
		chapter_36:
			'1) информацию, которую Пользователь не имеет права делать публичной по закону или согласно каким-либо договорным отношениям;',
		chapter_37:
			'2) информацию, нарушающую действующее законодательство, честь и достоинство, права и охраняемые законом интересы третьих лиц;',
		chapter_38:
			'3) информацию оскорбительного содержания, а также пропагандирующую дискриминацию людей по какому-либо признаку, насилие, ненависть;',
		chapter_39:
			'3.2.6. соблюдать иные требования и выполнять иные обязательства, предусмотренные настоящим Соглашением и утвержденными Правилами предоставления и получения сведений о трудовом договоре в единой системе учета трудовых договоров (далее – Правила).',
		chapter_40: '3.2.7. не использовать сервисы Портала с целью:',
		chapter_41:
			'3.2.7.1. загрузки контента, который является незаконным, нарушает любые права третьих лиц; пропагандирует насилие, жестокость, ненависть и (или) дискриминацию по расовому, национальному, половому, религиозному, социальному признакам; содержит недостоверные сведения и (или) оскорбления в адрес конкретных лиц, организаций, органов власти;',
		chapter_42:
			'3.2.7.2. побуждения к совершению противоправных действий, а также содействия лицам, действия которых направлены на нарушение ограничений и запретов, действующих на территории Республики Казахстан;',
		chapter_43: '3.2.7.3. нарушения прав несовершеннолетних лиц и (или) причинение им вреда в любой форме;',
		chapter_44:
			'3.2.7.4. представления себя за другого человека или представителя организации и (или) сообщества без достаточных на то прав, в том числе за работников Портала;',
		chapter_45:
			'3.2.7.5. сознательного введения в заблуждение относительно информации и данных, размещенных на Портале.',
		chapter_46: '3.3. Пользователю запрещается:',
		chapter_47:
			'3.3.1. использовать любые устройства, программы, процедуры, алгоритмы и методы, автоматические устройства или эквивалентные ручные процессы для доступа, приобретения, копирования или отслеживания содержания Портала;',
		chapter_48: '3.3.2. нарушать надлежащее функционирование Портала;',
		chapter_49:
			'3.3.3. любым способом обходить навигационную структуру Портала для получения или попытки получения любой информации, документов или материалов любыми средствами, которые специально не представлены сервисами данного Портала;',
		chapter_50:
			'3.3.4. несанкционированный доступ к функциям Портала, любым другим системам или сетям, относящимся к Порталу, а также к любым услугам, предлагаемым на Портале;',
		chapter_51:
			'3.3.5. нарушать систему безопасности или аутентификации на Портале или в любой сети, относящейся к Порталу;',
		chapter_52:
			'3.3.6. выполнять обратный поиск, отслеживать или пытаться отслеживать любую информацию о любом другом Пользователе Портала;',
		chapter_53:
			'3.3.7. использовать Портал и его содержание в любых целях, запрещенных законодательством Республики Казахстан, а также подстрекать к любой незаконной деятельности или другой деятельности, нарушающей права собственника Портала или других лиц.',
		chapter_54: '3.4. Администратор вправе:',
		chapter_55:
			'3.4.1. в случае нарушения Пользователем условий настоящего Соглашения отказать в регистрации Пользователю, удалить или блокировать Учетную запись Пользователя;',
		chapter_56:
			'3.4.2. запрашивать и получать необходимую информацию от Пользователя в порядке, определенном законодательством Республики Казахстан;',
		chapter_57: '3.4.3. проверять достоверность информации, представленной Пользователем на Портале;',
		chapter_58:
			'3.4.4. в любое время изменять оформление и пользовательский интерфейс Портала, его содержание, содержание предоставляемых функций, изменять или дополнять используемые скрипты, программное обеспечение, контент и другие объекты, используемые или хранящиеся на Портале и любые Приложения, без уведомления Пользователя;',
		chapter_59:
			'3.4.5. изменять правила пользования Порталом, а также изменять содержание данного Портала. Изменения вступают в силу с момента публикации новой редакции Соглашения на Портале.',
		title_4: '4. ВСТУПЛЕНИЕ СОГЛАШЕНИЯ В СИЛУ',
		chapter_60: '4.1. Настоящее Соглашение вступает в силу после регистрации Пользователя на Портале.',
		chapter_61:
			'4.2. Регистрация выполняется путем заполнения формы регистрации Пользователя, выражения Пользователем согласия со всеми условиями настоящего Соглашения, и отправки данных формы регистрации на Портал согласно инструкции по работе на Портале.',
		title_5: '5. ОТВЕТСТВЕННОСТЬ',
		chapter_62:
			'5.1. При размещении на Портале любой информации, сведений и материалов Пользователь несет персональную ответственность за содержание размещаемых им материалов, сведений и данных, правомерность их размещения и использования в соответствии с законодательством Республики Казахстан.',
		chapter_63:
			'5.2. Пользователь несет персональную ответственность за безопасное хранение своего пароля, а также за последствия, которые могут произойти при его компрометации.',
		chapter_64:
			'5.3. Пользователь несет персональную ответственность за своевременное размещение на Портале материалов, информации и сведений, подлежащих обязательному размещению на Портале.',
		chapter_65:
			'5.4. Администратор не несет ответственности за содержание информации, сведений, материалов, размещаемых Пользователем на Портале, их соответствие требованиям законодательства Республики Казахстан, за неправомерные действия Пользователя по использованию информации, сведений и материалов, размещенных на Портале, за нарушение Пользователем любых других прав третьих лиц.',
		chapter_66:
			'5.5. Администратор не несет ответственности за технические временные сбои и перерывы в работе Портала, возникшие по независящим от Администратора причинам или в случае проведения плановых или внеплановых мероприятий по обслуживанию Портала.',
		chapter_67:
			'5.6. Администратор не несет ответственности за временные сбои и обстоятельства непреодолимой силы, в том числе перебои в работе электрических сетей, сети Интернет и другие обстоятельства, возникшие независимо от Администратора и которые препятствуют выполнению условий настоящего Соглашения.',
		chapter_68:
			'5.7. Администратор не несет ответственности перед Пользователем за действия других Пользователей и (или) любых других участников Портала.',
		chapter_69:
			'5.8. Администратор не несет ответственности за любой прямой, косвенный ущерб, включая упущенную выгоду, ущерб от использования, потерю данных или какие-либо другие нематериальные потери, ущерб репутации и иной ущерб, возникающий вследствие:',
		chapter_70: '5.8.1. пользования или невозможности пользования Порталом;',
		chapter_71: '5.8.2. изменения условий настоящего Соглашения;',
		chapter_72:
			'5.8.3. неуполномоченного доступа к данным Пользователя или изменения передаваемых Пользователем или хранящихся на сервере данных;',
		chapter_73: '5.8.4. любого другого случая, имеющего отношение к оказываемым на Портале услугам.',
		title_6: '6. ПРОЧИЕ УСЛОВИЯ',
		chapter_74:
			'6.1. Пользователь не возражает в получении и публикации Администратором дополнительных сведений о себе, содержащихся в государственных и (или) негосударственных информационных системах (базах данных).',
		chapter_75:
			'6.2. Все претензии, запросы, вопросы, любая иная корреспонденция касательно технической работы Портала должны направляться по адресу электронной почты, указанной на главной странице Портала.',
		chapter_76:
			'6.3. В случае поступления претензий от третьих лиц, связанных с размещением и (или) использованием материалов, информации и сведений Пользователем, Пользователь самостоятельно и за свой счет урегулирует указанные претензии.',
		chapter_77:
			'6.4. Согласно пункту 13 Правил после внесения работодателем в единой системе учета трудовых договоров информации о прекращении трудового договора изменение и дополнение сведений в единой системе учета трудовых договоров осуществляется уполномоченным государственным органом по труду на основании обращения работодателя или работника в соответствии с Административным процедурно-процессуальным кодексом Республики Казахстан.',
		title_7: '7. РАЗРЕШЕНИЕ СПОРОВ',
		chapter_78:
			'7.1. В случае возникновения любых разногласий или споров между Сторонами настоящего Соглашения обязательным условием до обращения в суд является предварительным предъявлением претензии (письменного предложения о добровольном урегулировании спора).',
		chapter_79:
			'7.2. Получатель претензии в течение 15 календарных дней со дня ее получения, письменно уведомляет заявителя претензии о результатах рассмотрения претензии.',
		chapter_80:
			'7.3. При невозможности разрешить спор в добровольном порядке любая из Сторон вправе обратиться в суд за защитой своих прав, которые предоставлены им действующим законодательством Республики Казахстан.',
		chapter_81:
			'7.4. Любой иск в отношении условий использования Портала должен быть предъявлен согласно нормам Гражданского кодекса Республики Казахстан. ',
		title_8: '8. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ',
		chapter_82:
			'8.1. Администратор не принимает встречные предложения от Пользователя относительно изменений настоящего Соглашения.',
		chapter_83:
			'8.2. Отзывы Пользователя, размещенные на Портале, не являются конфиденциальной информацией и могут быть использованы Администратором без ограничений.',
	},
	edit_contract: 'Редактирование трудового договора №{{contractNumber}} от {{registerDate}}',
	contract_id: 'ID договора',
	forms: {
		modal: {
			title: 'Вы подтверждаете переход на новый лист?',
			bodyPart_1: 'Вы не ответили на все вопросы в текущем листе самопроверки.',
			bodyPart_2: 'При переходе на другой лист самопроверки все данные из текущего листа будут потеряны.',
			process_button_title: 'Перейти',
			cancel: 'Отмена',
		},
	},
	date_from_hint_tooltip: 'Дата начала работы должна быть в промежутке действия разрешения',
	date_to_hint_tooltip: 'Дата окончания действия договора должна быть в промежутке действия разрешения',
	electronic_contract: {
		register_date_hint:
			'Необходимо указать предполагаемую дату подписания договора работодателем (дата не должна быть позднее 14 календарных дней от текущей даты)',
		date_from_hint:
			'Необходимо указать предполагаемую дату подписания ЭТД работодателем (дата не должна быть раньше даты подписания договора)',
		contract_text_title: 'Текст договора',
		create_project_from_template: 'Создать проект ЭТД из шаблона',
		attach_file: 'Вложить файл проекта ЭТД',
		status_sign_eec: 'Статус подписи ЭТД',
		options: {
			employerType: 'Работодатель',
			0.1: 'Юридическое лицо',
			0.2: 'Индивидуальный Предприниматель (ИП)',
			0.3: 'Физическое лицо',
			employeeType: 'Работник',
			14.1: 'Резидент РК',
			14.2: 'Нерезидент РК',
			14.3: 'Нерезидент РК (трудовой иммигрант)',
			14.4: 'Несовершеннолетний',
			language: 'Язык Электронного трудового договора',
			1.1: 'Казахский язык',
			1.2: 'Русский язык',
			1.3: 'Двуязычный',
			jobType: 'Работа по трудовому договору является',
			2.1: 'Основной (основное место работы)',
			2.2: 'По совместительству',
			workCondition: 'Работа по трудовому договору относится к',
			3.1: 'Нормальным условиям труда',
			3.2: 'Тяжелым и/или выполняется во вредных и/или опасных условиях труда',
			workBeginning: 'Начало работы',
			4.1: 'Со дня подписания сторонами трудового договора',
			4.2: 'С установленной в трудовом договоре даты',
			term: 'Срок трудового договора',
			5.1: 'На неопределенный срок',
			5.2: 'На определенный срок не менее одного года',
			5.3: 'На определенный срок (для субъектов малого предпринимательства)',
			5.4: 'На время выполнения определенной работы',
			5.5: 'На время замещения временно отсутствующего работника',
			5.6: 'На время выполнения сезонной работы',
			5.7: 'В пределах срока ИРС',
			5.9: 'В пределах срока ТИ',
			probitionary: 'Условие об испытательном сроке определяется трудовым договором',
			6.1: 'Да',
			6.2: 'Да и при этом работник принимается на должность руководителя организации, или заместителя, главного бухгалтера или его заместителя, руководителя филиалов, представительства организации',
			6.3: 'Да, но без указания испытательного срока',
			6.4: 'Нет',
			workingTime: 'Работнику устанавливается рабочее время',
			7.1: 'Пятидневная (сорокочасовая) рабочая неделя с двумя выходными днями',
			7.2: 'Сменная',
			7.3: 'Пятидневная (36-часовая рабочая неделя с двумя выходными днями). Для возраста от 16-18 лет',
			7.4: 'Пятидневная (24-часовая рабочая неделя с двумя выходными днями). Для возраста до 16 лет.',
			salary: 'Заработная плата',
			8.1: 'Фиксированный размер (должностной оклад)',
			8.2: 'Часовая ставка',
			bonus: 'Предусматриваются стимулирующие выплаты (премии, бонусы и т.д.)',
			9.1: 'Да (подробно)',
			9.2: 'Да (кратко)',
			9.3: 'Нет',
			mandatory: 'Обязательные удержания',
			10.1: 'до обязательных удержаний',
			10.2: 'после обязательных удержаний',
			downtime: 'Информация об оплате простоя работ',
			11.1: 'Да - (Оплата простоя)',
			overtime: 'Информация об оплате работы в сверхурочное, ночное время, в праздничные и выходные дни',
			12.1: 'Да - (Оплата сверхурочных)',
			paymentMethod: 'Способ оплаты',
			13.1: 'Безналичный платеж',
			13.2: 'Наличными деньгами',
			employeeRights: 'Дополнительные права работника',
			34: 'Да (Дополнительные права Работника)',
			employeeResp: 'Дополнительные обязанности работника',
			35: 'Да (Дополнительные обязанности Работника)',
			employerRights: 'Дополнительные права работодателя',
			36: 'Да (Дополнительные права работодателя)',
			employerResp: 'Дополнительные обязанности работодателя',
			37: 'Да (Дополнительные обязанности работодателя)',
		},
		new_template: 'Новый шаблон',
		new_template_select_options: 'Выбор опций Электронного трудового договора',
		open_contract_project: 'Открыть проект договора',
		open_add_contract_project: 'Открыть проект доп.соглашения',
		employee_rights_placeholder: 'Укажите дополнительные права работника в этом поле',
		employee_works_placeholder: 'Укажите дополнительные обязанности работника в этом поле',
		employer_rights_placeholder: 'Укажите дополнительные права работодателя в этом поле',
		employer_works_placeholder: 'Укажите дополнительные обязанности работодателя в этом поле',
		open_contract_project_title: 'Проект электронного трудового договора',
		created: 'создан',
		sure_delete_template: 'Вы действительно хотите удалить шаблон?',
		resert_values: 'Сбросить внесённые изменения',
		role: 'Роль',
		parties_requisites: 'Реквизиты сторон',
		name_fio: 'Наименование, ФИО',
		sign_date: 'Дата подписи',
		reset: 'Сбросить',
		reset_question: 'Вы действительно хотите сбросить все изменения?',
		project: 'Проект внесения изменений в действующий ЭТД',
		terminate: 'Вы расторгаете электронный трудовой договор! После подписания ваш договор будет расторгнут.',
		status_sign_eds: 'Статус подписи ЭДС',
	},
	update_companies_list: 'Обновить список предприятий',
	should_update_companies_list:
		'В случае добавления нового предприятия на портале enbek.kz, необходимо обновить список предприятий',
	error: 'Произошла ошибка',
	last_update: 'последнее обновление',
	role_select_warning: 'Для перехода в профиль Работодателя необходимо указать почту в настройках аккаунта',
	go_to_settings: 'Перейти в настройки',
	hint_oked_code: 'Начните вводить первые 3 буквы вида деятельности для получения вариантов для выбора',

	warning_company_title: 'Одно или несколько предприятий из Вашего профиля уже зарегистрировано на портале!',
	warning_company_title_left: 'Предприятие',
	warning_company_title_right: 'Контактная информация',
	date_error: 'Дата расторжения договора не должна быть позже текущего дня',
	phone_error: 'Указанный номер телефона не принадлежит казахстанским операторам сотовой связи!',
	phone_error_equal: 'Вы указали одинаковые значения в полях "Рабочий телефон" и "Мобильный телефон"!',
	request_employee_ld: 'Запрос на личное дело работника',
	request_id: 'ID запроса',
	form_date: 'Дата формирования',
	employee_data_ld: 'Данные о работнике',
	employer_data_ld: 'Данные о работодателе',
	employer_iin_bin: 'БИН/ИИН работодателя',
	enter_bin_or_name: 'Введите БИН или Наименование предприятия',
	ld_requests: 'Запросы на личное дело',
	ld_medicine_error_1: 'В базе Министерства здравоохранения',
	ld_medicine_error_2: ' Республики Казахстан данные по справке отсутствуют',
	labor_activities_tab: 'ТРУДОВАЯ ДЕЯТЕЛЬНОСТЬ',
	correction_requests_tab: 'ЗАПРОСЫ НА КОРРЕКТИРОВКУ',
	unsigned_records_tab: 'НЕПОДПИСАННЫЕ ЗАПИСИ',
	labor_records: {
		info_no_records: 'У Вас нет записей о трудовой деятельности.',
		title: 'Электронная\n' + 'трудовая книжка',
		titlePage: 'Электронная трудовая книжка',
		add_record: 'Добавить запись',
		searchInput: 'Введите БИН либо наименование предприятия',
		dateFrom: 'Период с',
		dateTo: 'Период по',
		bin_iin_placeholder: 'Введите БИН/ИИН',
		orgName: 'Введите наименование предприятия',
		export: 'Выгрузить',
		cancel_text: 'Отменить',
		export_text: 'Вы собираетесь выгрузить электронную трудовую книгу',
		with_photo: 'С фото',
		without_photo: 'Без фото',
		work_experience: 'Общий стаж работы -',
		count_records: 'Количество записей по трудовой деятельности - ',
		until_now: 'по настоящее время',
		open: 'Открыть',
		edit: 'Редактировать',
		terminate: 'Расторгнуть',
		remove: 'Удалить',
		contract_data: 'Данные по договору из ЕСУТД',
		labor: 'ТД',
		el_labor: 'ЭТК',
		laborDigitalization: 'Оцифрованные данные по трудовой книжке',
		bin_iin: ' (БИН/ИИН: ',
		detail: 'Подробно ',
		short: 'Кратко ',
		reason_termination: 'Причина расторжения',
		date: 'Дата',
		record_type: 'Тип записи',
		establishedPost: 'Должность',
		requestType: 'Тип запроса',
		action: 'Действия',
		revoke: 'Отозвать',
		confirm: 'Подтвердить',
		reject: 'Отклонить',
		loading: 'Идет загрузка данных...',
		no_data: 'У Вас нет запросов на корректировку',
		actions: 'Действия',
		request_edit: 'редактирование ',
		request_terminate: 'прекращение/расторжение ',
		request_remove: 'удаление ',
		title_request: 'Запрос на ',
		contract_request: 'трудового договора № {{contractNumber}} от {{contractDate}}',
		request_data: 'Дата запроса {{ requestDate }} ',
		request_status: 'Статус запроса: ',
		view_contract: 'Открыть договор',
		hint_information: '*Для корректировки БИН/ИИН сторон необходимо обратиться с  официальным письмом в МТСЗН.',
		contract_terminate_info: 'Информация о прекращении/расторжении договора',
		terminate_date: 'Дата расторжения',
		contract_termination_reason: 'Причина расторжения',
		confirming_document: 'Подтверждающие документы',
		full_size: 'Общий размер',
		additional_information: 'Дополнительная информация',
		phone: 'Контактный номер',
		email: 'Почта',
		placeholder_phone: 'Введите номер телефона',
		placeholder_email: 'Введите Ваш email',
		comment: 'Комментарий',
		placeholder_comment: 'Введите причину по которой Вы хотите произвести прекращение/расторжение трудового договора',
		note: 'Решение',
		register_data: 'Дата регистрации договора в ЕСУТД: ',
		max_size_photo_error: 'Максимальный размер изображения 10 МБ',
		error_size: 'Превышен допустимый общий размер файлов',
		download: 'Скачать',
		cancel: 'Отмена',
		max_size_all: 'Общий размер всех файлов не должен превышать 10 МБ',
		max_size_by_var: 'Общий размер всех файлов не должен превышать {{maxSize}} МБ',
		specify_reason: 'Необходимо указать причину расторжения, либо, при необходимости, несколько причин расторжения',
		sign_and_send: 'Подписать и отправить',
		send_adjustments: 'Вы отправляете запрос на внесение сведений о прекращении/расторжении трудового договора',
		sign_adjustments: 'Подписав запрос с помощью ЭЦП, Вы несёте ответственность за предоставленные данные',
		title_send_revoke: 'Вы собираетесь отозвать запрос на корректировку',
		body_sign_revoke:
			'Вы действительно хотите отозвать запрос на корректировку? В этом случае запрос не будет рассмотрен уполномоченным государственным органом по труду.',
		confirming_document_no_required: 'Подтверждающие документы (не обязательно)',
		title_send_remove: 'Вы отправляете запрос на удаление данных трудового договора',
		title_send_edit: 'Вы отправляете запрос на внесение корректировки в данные по трудовому договору',
		instruction: 'ИНСТРУКЦИЯ!',
		info_box_title: 'Как изменить информацию в трудовом договоре?',
		contract_info: 'Информация о договоре',
		position_by_nkz: 'Должность на основе НКЗ',
		contract_employer_number: 'Номер трудового договора',
		hint_termination_reason:
			'При необходимости Вы можете удалить одну или несколько причин расторжения, либо добавить новые',
		additional_contract: 'Информация о дополнительных соглашениях',
		add_contract_num: 'Доп.соглашение №{{contractNumber}} от {{registerDate}}',
		view_contract_num: 'Доп.соглашение №{{contractNumber}}',
		social_leave: 'Информация о социальных отпусках',
		weekend: 'Выходные дни',
		vacation_date_start: 'Не работал(а) с',
		vacation_date_end: 'Не работал(а) по',
		social_leave_num: 'Социальный отпуск',
		info: {
			availability_fields: 'Ни одно из полей договора не было изменено',
			max_end_date: '"Не работал(а) по" не должно быть более 184 дня от поля "Не работал с"',
		},
		title_sign_confirm: 'Вы собираетесь подтвердить запрос на корректировку',
		body_sign_confirm:
			'Вы действительно хотите подтвердить запрос на корректировку? В этом случае в договоре будут произведены соответствующие изменения.',
		title_sign_reject: 'Вы собираетесь отклонить запрос на корректировку',
		body_sign_reject:
			'Вы действительно хотите отклонить запрос на корректировку? В этом случае в договоре не будут произведены соответствующие изменения.',
		note_placeholder: 'Введите комментарий ответа на запрос',
		note_text: 'В Единой системе учета трудовых договоров были внесены изменения согласно данных в запросе',
	},
	banners: {
		text: 'Узнайте в Национальном докладе «Рынок труда Казахстана: на пути к цифровой реальности»',
		transition: 'Перейти     ',
	},
	choose_employment_contract: 'Выберите трудовой договор',
	unsigned_documents_will_removed_your_account: 'Неподписанные документы будут удалены из вашего кабинета',
	selected_documents_will_signed: 'Выбранные документы будут подписаны',
	sure_sign_selected_documents: 'Вы уверены, что хотите подписать выбранные документы?',
	sign_subscription: 'Признак подписки',
	digitization: {
		modal_title: {
			create: 'Внесение записей по трудовой деятельности',
			edit: 'Редактирование записей по трудовой деятельности',
		},
		form: {
			titleCreate: 'Создание новой записи о трудовой деятельности',
			titleEdit: 'Редактирование записи о трудовой деятельности',
			laborTypeCode: 'Тип перемещения',
			bin: 'БИН/ИИН',
			choose: 'Выбрать из данных ОПВ',
			orgName: 'Наименование',
			establishedPost: {
				1: 'Должность',
				2: 'Должность',
				3: 'Должность после реорганизации/перевода',
			},
			eventDate: {
				1: 'Дата приема',
				2: 'Дата вступления в должность',
				3: 'Дата реорганизации/перевода',
				4: 'Дата расторжения',
			},
			termReasonCodes: 'Причина расторжения',
			choosePeriod: 'Выберите период из данных обязательных пенсионных взносов',
		},
		table: {
			text: 'Добавьте все перемещения в рамках одного трудового периода (начиная с приёма на работу, вплоть до увольнения, при наличии)',
			headers: {
				date: 'Дата',
				moving: 'Перемещение',
				bin: 'БИН/ИИН',
				name: 'Наименование',
				position: 'Должность',
				period: 'Период',
				actions: 'Действия',
			},
		},
		sign_all: 'Подписать всё',
		sign_checked: 'Подписать выделенные записи',
		remove_checked: 'Удалить выделенные записи',
		sign_and_remove: 'Подписать и удалить',
		yes_remove: 'Да,удалить',
		confirm: {
			sign_contract: {
				title: 'Запись по трудовой деятельности будет подписана',
				data: 'Вы уверены, что хотите подписать запись по трудовой деятельности и отправить в Единую систему учета трудовых договоров?',
			},
			remove_contract: {
				title: 'Запись о трудовой деятельности будет удалена',
				data: 'Вы уверены, что хотите удалить запись о трудовой деятельности?',
			},
			sign_chosen: {
				title: 'Вы собираетесь подписать выделенные записи',
				data: 'Вы действительно хотите подписать выделенные записи по трудовой деятельности? В случае подписания, данные будут отправлены в Единую систему учета трудовых договоров и будут отображаться в разделе «Электронная трудовая книжка»',
			},
			remove_chosen: {
				title: 'Вы собираетесь удалить выделенные записи',
				data: 'Вы действительно хотите удалить выделенные записи по трудовой деятельности без возможности восстановления?',
			},
			sign_and_send_all: {
				title: 'Вы собираетесь подписать все сохраненные записи',
				data: 'Вы действительно хотите подписать все сохраненные записи по трудовой деятельности? В случае подписания, данные будут отправлены в Единую систему учета трудовых договоров и будут отображаться в разделе «Электронная трудовая книжка»',
			},
			buttons: {
				sign_and_send: 'Подписать и отправить',
				yes_remove: 'Да, удалить',
			},
		},
	},
	person_not_found: 'ИИН не найден',
	membersSearchInput: 'Введите ИИН члена профсоюза',
	ncalayer_info:
		'Произошла ошибка подключения к NCALayer или соединение прервано. Запустите NCALayer если не запущено или продолжайте работу, при следующем подписании соединение будет восстановлено автоматически.',
	pension: {
		searchInput: 'Введите ИИН или ФИО контрагента',
		status_request: 'Статус заявки',
		state: 'Состояние',
		request_date: 'Дата заявки',
		birthday: 'Дата рождения',
		actions: 'Действия',
		loading: 'Идет загрузка данных...',
		no_data: 'У Вас отсутствуют сформированные заявки на назначение пенсионных выплат',
		has_error: 'Произошла ошибка, повторите попытку позже!',
		contractor: 'Контрагент',
		persons: 'Выберите работника предпенсионного возраста',
		gender: 'Пол',
		out_day_work: 'Осталось дней',
		no_pension_workers: 'У Вас нет работников предпенсионного возраста',
		modal: {
			title: 'Запрос на согласие',
			data: 'Получение согласия на сбор и обработку персональных данных работника',
			send_more: 'Отправить и продолжить',
			close: 'Закрыть',
		},
		create_request: 'Создать заявку',
		payments: {
			tables_empty: 'Обязательно должен быть добавлен стаж и подтверждающий документ',
			code_valid:
				'Отправка проактивной услуги доступна только после получения согласия от заявителя на доступ к персональным данным.',
			checkbox: {
				employee:
					'Сотрудник кадровой службы подтверждает, что внесенные сведения в заявке на проактив проверены и заполнены в надлежащем виде с согласием работника.',
				seniority: 'Получено подтверждение работника о том, что сведения по трудовому стажу внесены верно.',
				message:
					'Необходимо подтвердить, что внесенные сведения в заявке на проактив проверены и заполнены в надлежащем виде.',
			},
			no_number: 'Отсутствует номер в БМГ',
			alert_no_number:
				'Отправка проактивной услуги невозможна, так как номер телефона заявителя отсутствует в базе мобильных граждан, Заявителю необходимо зарегистрировать номер телефона в БМГ.',
			hints: {
				update_status:
					'Обновить статус согласия на сбор и обработку персональных данных возможно если статус «Согласие не получено» или «Согласие получено»',
				request_again:
					'Запросить повторное согласие на сбор и обработку персональных данных возможно если статус «Согласие не получено» или «Согласие получено»',
				experience:
					'Стаж вносят за весь период трудовой деятельности с момента ее начала до даты достижения пенсионного возраста, включая периоды обучения, военной службы, трудовой деятельности (трудовая книжка, трудовой договор, архивная справка, выписка из приказа), ухода неработающей матери за малолетними детьми до достижения ими возраста трех лет.',
				type_of_experience:
					'Тип стажа подтверждается сканированными оригиналами документов (диплом об образовании, военный билет, свидетельства о рождении детей) и документов о трудовой деятельности для назначения пенсионных выплат по возрасту, участия в пенсионной системе и назначении государственной базовой пенсионной выплаты',
				benefit_type:
					'Тип льготного стажа подтверждается сканированными оригиналами документов о трудовой деятельности для назначения пенсионных выплат по возрасту',
				period_start_date: 'Дата начала периода трудовой деятельности с момента ее начала',
				period_end_date:
					'Дата окончания периода трудовой деятельности заполняется до даты достижения пенсионного возраста ',
				name_of_experience:
					'Укажите наименование, например: места работы, обучения, военной службы, трудовой деятельности',
				document_type:
					'Выбирая тип документа система проверяет прикрепленный документ с одинаковым типом файла, наименованием, расширением и весом файла',
				attach_file:
					'Документ необходимо отсканировать в цветном варианте обеспечивающий возможность свободного чтения текста, всех реквизитов, дат, виз, резолюций, иных надписей, печатей и штампов. Размер одного файла не должен превышать более 13 МБ. Допустимые форматы прикрепляемых файлов JPG, JPEG, PNG, PDF.',
				pension_persons:
					'В списке выходят работники, которым осталось до пенсии от 3 месяцев до 11 дней до наступления пенсионного возраста',
			},
			form: {
				title: 'Заявка на назначение пенсионной выплаты работнику',
				labels: {
					app_info: 'Информация о заявке',
					app_id: 'ID заявки',
					app_creation_date: 'Дата создания заявки',
					app_last_modified_date: 'Дата последнего изменения',
					app_status: 'Статус заявки',
					note: 'Примечание',
					app_state: 'Состояние заявки',
					app_consent: 'Согласие заявителя',
					applicant_info: 'Информация о заявителе',
					iin: 'ИИН',
					fio: 'ФИО',
					date_of_birth: 'Дата рождения',
					sex: 'Пол',
					phone: 'Мобильный телефон',
					place_of_work: 'Наименование места работы',
					personnel_officer: 'Информация о сотруднике кадровой службы',
					employee_name: 'ФИО сотрудника*',
					employee_position: 'Должность сотрудника*',
					employee_phone: 'Номер телефона*',
					experience: 'Стаж',
					documents: 'Подтверждающие документы',
					add_document: 'Добавить документ',
					submit_app: 'Отправить заявку',
					update_status: 'Обновить статус',
					request_again: 'Запросить повторно',
				},
				placeholder: {
					enter_name: 'Введите ФИО',
					enter_position: 'Введите должность',
					enter_phone: 'Введите номер',
				},
				table: {
					date_from: 'Дата с',
					date_by: 'Дата по',
					name_of_experience: 'Наименование стажа',
					type_of_experience: 'Тип стажа',
					benefit_type: 'Тип льготного стажа',
					actions: 'Действия',
					document_type: 'Тип документа',
					document_name: 'Наименование документа',
					add_entries: 'Необходимо добавить записи',
				},
				exp_form: {
					adding_seniority: 'Добавление стажа',
					type_of_experience: 'Тип стажа*',
					choose_type_of_experience: 'Выберите тип стажа',
					benefit_type: 'Тип льготного стажа',
					select_benefit_type: 'Выберите тип льготного стажа',
					start_date: 'Дата начала периода*',
					date_format: 'дд.мм.гггг',
					end_date: 'Дата окончания периода*',
					name_of_experience: 'Наименование стажа*',
					enter_name: 'Введите наименование стажа',
				},
				doc_form: {
					add_document: 'Добавление документа',
					document_type: 'Тип документа*',
					choose_type_experience: 'Выберите тип стажа',
					max_file_size_error: 'Максимальный размер файла 13 МБ',
					file_added: 'Данный файл уже добавлен',
				},
				diff_form: {
					diff1:
						'Для типа стажа «Работа по трудовой книжке» необходимо предоставить один из следующих типов документов: трудовая книжка, архивная справка, выписка из приказов, документ, подтверждающий факт проживания в зонах чрезвычайного и максимального радиационного риска с 29 августа 1949 года по 5 июля 1963 года',
					diff2: 'Для типа стажа «Воинская служба» необходимо предоставить тип документа «Военный билет»',
					diff7:
						'Для типа стажа «Уход за ребенком - инвалидом в возрасте до 16 лет» необходимо предоставить тип документа «Свидетельство о рождении»',
					diff8:
						'Для типа стажа «Уход за 1-м ребенком» необходимо предоставить тип документа «Свидетельство о рождении»',
					diff9:
						'Для типа стажа «Уход за 2-м ребенком» необходимо предоставить тип документа «Свидетельство о рождении»',
					diff10:
						'Для типа стажа «Уход за 3-м ребенком» необходимо предоставить тип документа «Свидетельство о рождении»',
					diff11:
						'Для типа стажа «Уход за 4-м ребенком» необходимо предоставить тип документа «Свидетельство о рождении»',
					diff12:
						'Для типа стажа «Время содержания под стражей, отбытия наказания в местах лишения свободы» необходимо предоставить тип документа «Решение суда»',
					diff17:
						'Для типа стажа «Учеба в учебных заведениях» необходимо предоставить тип документа «Диплом об окончании средне - специального или высшего учебного заведения»',
					diff21:
						'Для типа стажа «Уход за 5-м ребенком» необходимо предоставить тип документа «Свидетельство о рождении»',
					diff22:
						'Для типа стажа «Уход за 6-м ребенком» необходимо предоставить тип документа «Свидетельство о рождении»',
					diff23:
						'Для типа стажа «Уход за 7-м ребенком» необходимо предоставить тип документа «Свидетельство о рождении»',
					diff24:
						'Для типа стажа «Уход за 8-м ребенком» необходимо предоставить тип документа «Свидетельство о рождении»',
				},
			},
		},
		instructions: 'Инструкция по работе с заявками на проактив',
		video_instructions: 'Видеоинструкция:',
	},
	portal_employment_contracts: 'Enbek HR - трудовые договоры',
	available: 'Доступно в {{type}}',
	available_google: 'Доступно в {{type}}',
	dark_day: '29 октября 2023 года - День общенационального траура в Республике Казахстан',
	unread_notifications: 'Непрочитанные уведомления',
	absence_notifications: 'Уведомления отсутствуют!',
	error_checks: 'По данным параметрам документ отсутствует',
	error_checks_system: 'Ошибка системы, попробуйте проверить документ позже',
	document_verification: 'Проверка документа',
	document_checks_name: 'Название документа',
	document_ID: 'ID документа',
	e_ad_contract: 'Электронное дополнительное соглашение',
	e_term_contract: 'Информация о расторжении',
	document_status_sign: 'Статус подписи документа',
	document_number_date: 'Номер и дата документа',
	document_sign_employer: 'Подпись работодателя',
	document_sign_employee: 'Подпись работника',
	document_time_sign: 'Время подписи',
	document_note_title: 'ПРИМЕЧАНИЕ!',
	document_note:
		'Согласно пункта 1 статьи 33 Трудового Кодекса Республики Казахстан Трудовой, договор заключается в письменной форме не менее чем в двух экземплярах и подписывается сторонами. По одному экземпляру трудового договора хранится у работника и работодателя.\n' +
		'Заключение трудового договора, внесение в него изменений и дополнений могут производиться в форме электронного документа, удостоверенного посредством электронной цифровой подписи.',
	replace_eds_file: 'Заменить файл ЭДС',
	replace_eds_project_file: 'Заменить файл проекта ЭТД',
	question_delete_project_etd:
		'Вы действительно хотите удалить проект ЭТД? В этом случае процесс заключения ЭТД прекратится',
	include_file_etd: 'Вложить файл проекта ЭТД',
	file_info_size: 'Размер не должен превышать 5МБ',
	success_save: 'Успешно сохранено',
	sign_all_title: 'Все неподписанные документы будут подписаны',
	sign_all_body: 'Вы уверены, что хотите подписать?',
	add_file_eds: 'Вложить файл проекта ЭДС',
	replace_file_eds: 'Заменить файл проекта ЭДС',
	oppv_count_unikey_period: 'Количество перечисленных ОППВ работодателем в месяцах',
	oppv_spectial: 'Специальное профессиональное государственное пособие, тенге',
	oppv_money: 'Выплата из Компании по страхованию жизни, тенге',
	oppv_money_employer: 'Выплата от работодателя, тенге',
	oppv_money_enpf: 'Пенсионная выплата из ЕНПФ за счет накоплений ОПВ и ОППВ',
	oppv_all: 'Общая сумма ежемесячных выплат, тенге',
	oppv_calculate: 'Рассчитать',
	oppv_last_update: 'Последнее обновление: ',
	oppv_hint1:
		'С 1 января 2024 года лицам, занятым во вредных условиях труда, при достижении 55-летнего возраста и факте уплаты за них ОППВ  не менее 84 –х месяцев, осуществляется специальная социальная выплата до 63/61 лет.',
	oppv_hint2: 'ОППВ - Обязательные профессиональные пенсионные взносы',
	oppv_hint3:
		'ЕНПФ - Единый накопительный пенсионный фонд\n' +
		'ОПВ - Обязательные пенсионные взносы\n' +
		'ОППВ - Обязательные профессиональные пенсионные взносы',
	hierarchy_categories: 'Раздел должности на основе НКЗ',
	dangerous_working_document: 'Подтверждающий документ *',
	conditions1: 'Тип работ по списку 1 *',
	conditions2: 'Тип работ по списку 2 *',
	conditions3: 'Тип работ по списку ОППВ *',
	conditions_hint1:
		'Необходимо выбрать тип работы, утвержденный согласно Постановлению Правительства Республики Казахстан от 19 декабря 1999 года № 1930',
	conditions_hint2:
		'Необходимо выбрать тип работы, утвержденный согласно Постановлению Правительства Республики Казахстан от 19 декабря 1999 года № 1930',
	conditions_hint3:
		'Необходимо выбрать тип работы, утвержденный согласно Приказу Министра труда и социальной защиты населения РК от 24 мая 2023 года № 170',
	download_button_hint:
		'Необходимо прикрепить подтверждающий файл (Общий размер всех файлов не должен превышать 10 МБ)',
	oppv_comment: '* Данный расчет является ориентировочным и носит информационный характер',
	enter_iin: 'Введите ИИН',
	tel_bmg: 'Ваш номер телефона в Базе мобильных граждан (БМГ)',
	send_sms: 'Отправить смс-код на номер телефона, зарегистрированный в БМГ?',
	error_bmg: 'По данному ИИН отсутствует номер в БМГ. Зарегистрировать номер мобильного телефона можно через egov.kz',
	error_bmg_service: 'Ошибка, попробуйте повторно.',
	code_bmg: 'Код из СМС',
	code_bmg_placeholder: 'Введите код из СМС',
	title_employeeRequest_1:
		'Вы регистрируете расторжение трудового договора с работником, занятым во вредных условиях труда. В случае если работник изъявил желание на получение специальной социальной выплаты и написал заявление о прекращении трудовой деятельности на работах с вредными условиями труда согласно ',
	title_employeeRequest_2: 'правилам',
	title_employeeRequest_3: ', вам следует подтвердить следующие условия:',
	additional_employeeRequest_1:
		'Вы регистрируете дополнительное соглашение на изменение условий труда с “Вредных” на “Нормальные”. В случае если работник изъявил желание на получение специальной социальной выплаты и написал заявление о переводе на другую работу, исключающую воздействие вредных производственных факторов согласно ',
	additional_employeeRequest_3: ', вам следует подтвердить следующие условия:',
	hr_manager_phone: 'Номер телефона отдела кадров*',
	employee_phone: 'Номер телефона работника*',
	employee_phone_harmful: 'Номер телефона работника*',
	employeeRequest: 'Наличие заявления работника',
	employeeConsent: 'Согласие работника на обработку персональных данных',
	employerApprove: 'Согласие работодателя на выплату социальной выплаты в размере 1 ПМ',
	employeeIban: 'Наличие банковского счета, указанного в заявлении работника',
	important_comment_1:
		'* Важно! Для назначения работнику специальной социальной выплаты, работник должен быть зарегистрирован в Базе мобильных граждан и работодатель должен заключить договор предпенсионного аннуитетного страхования в соответствии со статьей 23-1 Закона Республики Казахстан «Об обязательном страховании работника от несчастных случаев при исполнении им трудовых (служебных) обязанностей». ',
	important_comment_2: 'Скачать ',
	important_comment_3: 'методику расчета профессиональной выплаты',
	error_message_button: 'Дата не должна быть ранее 2024 года',
	enpf: 'Без выплаты ЕНПФ',
	enpf_oppv: 'Выплата из ЕНПФ за счет накоплений ОППВ',
	enpf_oppv_opv: 'Выплата из ЕНПФ за счет накоплений ОППВ и ОПВ',
	iban_placeholder: 'KZ введите 18 знаков',
	col_contract: {
		protocolDisagreement: 'Протокол разногласий',
		supplement_surcharge: 'Надбавка (Доплата)',
		inter_digit_coefficients: 'Межразрядные коэфиценты',
		industry: 'Отрасль',
		date_end_col_contract: 'Срок действия коллективного договора',
		info_tariff_rates: 'Информация о размерах тарифных ставок, оклада и надбавок(доплат)',
		add_info_work_place: 'Добавить информацию  по рабочему месту',
		add_rank: 'Добавить разряд',
		info_by_work_place: 'Информация по рабочему месту {{ count }}',
		tariff_rate_salary: 'Тарифная ставка(оклад)',
		inter_digit_coefficient: 'Межразрядный коэффициент',
		rank_by_count: 'Разряд {{ count }}',
		rank: 'Разряд',
		set_count: 'Введите кол-во',
		set_supplement_surcharge: 'Введите надбавку/доплату',
		set_coefficient: 'Введите коэффициент',
		protocol_disagreements: 'Протокол разногласий',
		set_ecd_doc: 'Вложить файл проекта ЭКД',
		update_ecd_doc: 'Заменить файл проекта ЭКД',
		typeEnterprise: 'Тип предприятия',
		typeOwnership: 'Форма собственности',
		contract_short_information: 'Договор № {{contractNumber}} от {{dateFrom}}',
		bin: 'БИН работодателя',
		name: 'Наименование работодателя',
		firstUnion: 'Первичный профсоюз',
		localUnion: 'Локальный профсоюз',
		union_name: 'Наименование профсоюза',
		union_bin: 'БИН профсоюза',
		representativeIin: 'ИИН представителя',
		representativeFIO: 'Фамилия, имя и отчество представителя',
		info: 'Информация о коллективном договоре',
		number: 'Номер коллективного договора',
		placeholder_number: 'Укажите номер',
		dateFrom: 'Дата заключения',
		dateTo: 'Дата окончания действия',
		pay_info: 'Информация о системе оплаты труда',
		pay: 'Оплата сверхурочной работы',
		placeholder_amount: 'Введите размер ставки',
		placeholder_percent: 'Введите процент',
		placeholder_size_rate: 'Укажите размер тарифной ставки',
		placeholder_rate: 'Укажите коэффициент',
		placeholder_one_or_more_values: 'Выберите одно или несколько значений',
		placeholder_amount_text: 'Введите объем финансирования мероприятий',
		amount: 'Укажите сумму',
		holiday_pay: 'Оплата работы в праздничные и выходные дни',
		night_time_pay: 'Оплата труда в ночное время',
		combination_position_pay:
			'Оплата труда при совмещении должностей, расширении зоны обслуживания и исполнении (замещении) обязанностей временно отсутствующего работника',
		term_compensation_pay:
			'Компенсационная выплата в случае расторжения трудового договора по инициативе работодателя при достижении работником пенсионного возраста',
		way_compensation_pay:
			'Компенсационная выплата за время нахождения работников в пути от местонахождения работодателя или от пункта сбора до места работы и обратно',
		wage_index_procedure: 'Порядок индексации заработной платы',
		information_tariff_rates: 'Информация о размерах тарифных ставок,оклада и надбавок(доплат)',
		tariff_rate_category_workers: 'Размер тарифной ставки работников 1 разряда',
		industry_agreement_coefficient: 'Коэффициент в отраслевом соглашении',
		min_coefficient: 'Минимальный коэффициент',
		max_coefficient: 'Максимальный коэффициент',
		different_coefficient: 'Об установлении межразрядных коэффициентов',
		grade_min: 'Минимальный коэффициент для работников {{number}} разряда',
		grade_max: 'Максимальный коэффициент для работников {{number}} разряда',
		grade: ' разряда',
		duration_working_hours_and_rest_time_holidays:
			'О продолжительности рабочего времени и времени отдыха, трудовых отпусках',
		working_time: 'Рабочее время',
		relax_time: 'Время отдыха',
		safe_working_protection:
			'О создании здоровых и безопасных условий труда и быта, об объеме финансирования мероприятий по безопасности и охране труда, об улучшении охраны здоровья',
		amount_funding: 'Объем финансирования мероприятий по безопасности и охране труда',
		funding_amount: 'Сумма финансирования',
		scanned_col_contract: 'Скан-копия коллективного договора *',
		searchInput: 'Введите БИН или наименование предприятия',
		table: {
			employer: 'Работодатель',
			bin: 'БИН работодателя',
			name: 'Наименование работодателя',
			union_name: 'Наименование профсоюза',
			date_from: 'Дата заключения',
			date_to: 'Дата окончания',
			actions: 'Действия',
		},
		forWorkers: 'Для работников {{number}} разряда',
		colDownload: 'Скачать коллективный договор',
		tradeUnion: 'Профсоюз',
		representativeTradeUnion: 'Представитель профсоюза',
		fromTo: 'с {{min}} по {{max}}',
		scan: 'Скан-копия коллективного договора',
		hint: {
			pay: 'Необходимо указать размер оплаты сверхурочной работы',
			holiday_pay: 'Необходимо указать размер оплаты в праздничные и выходные дни',
			night_time_pay: 'Необходимо указать размер оплаты труда в ночное время',
			combination_position_pay: 'Необходимо указать размер при совмещении должностей',
			term_compensation_pay: 'Необходимо указать процент компенсационной выплаты в случае расторжения',
			way_compensation_pay:
				'Необходимо указать процент компенсационной выплаты в случае за время нахождения работников в пути',
			wage_index_procedure: 'Необходимо указать процент индексации заработной платы',
		},
		col_union: 'Тип объединения',
		add_representative: 'Добавить представителя',
		add_union: 'Добавить объединение',
		guarantee_title: 'Дополнительные гарантии и льготы для работников, предусмотренные коллективными договорами',
		type_guarantees: 'Вид доп.гарантии и льгот',
		type_benefits: 'Доп. гарантии и льготы',
		additional_guarantees: 'Вид дополнительных гарантий и льгот',
		add_guarantees: 'Добавить гарантии',
		trade_union_data: 'Данные профсоюза',
		type_union_data: 'Тип профсоюза',
		union: 'Объединение',
		additional_information: 'Информация о дополнительной гарантии и льготы для работников',
		create_draft: 'Создать проект колл.договора',
		electronic_agreement: 'Электронный коллективный договор',
		info_for_create:
			'Если Вы представляете профессиональный союз и намерены заключить коллективный договор, необходимо заполнить информацию в разделе  ',
		language: 'Язык электронного коллективного договора',
		kz: 'Казахский',
		rus: 'Русский',
		send_to_sign_employer: 'Отправить на подпись работодателю',
		contracts: 'Коллективные договоры',
		return: 'Вернуться',
		project_title: 'Проект электронного коллективного договора',
		collective_contract: 'Коллективный договор № {{contractNumber}} от {{dateFrom}}',
		status_sign: 'Статус подписи ЭКД',
		trade_union_representative: 'Представитель профсоюза',
		employer_representative: 'Представитель работодателя',
		text_ecd_sign_employer: 'Я согласен с условиями договора и хочу подписать электронный коллективный договор',
		text_ecd_sign_trade_union:
			'Вы заключаете коллективный  договор с работодателем! После подписания данные договора будут автоматически направлены в систему Охраны труда и безопасности',
		title_decline:
			'Вы отклоняете подписание договора. Вы уверены, что хотите прекратить заключение электронного коллективного договора?',
		comment_employer: 'Комментарий работодателя',
		decline_title_trade_union:
			'Вы отклоняете подписание договора. Вы уверены что хотите прекратить заключение электронного коллективного договора?',
		revert_title:
			'Вы действительно хотите отозвать подписание электронного коллективного договора? В этом случае процесс заключения электронного коллективного договора прекратится',
	},
	contractDuration: {
		base: 'Основание для привлечения иностранца',
		permit_number: 'Номер разрешения',
		permit_number_placeholder: 'Введите номер разрешения',
		dateOfPermit: 'Дата выдачи разрешения',
		education: 'Образование',
		speciality: 'Специальность',
		qualification: 'Квалификация',
		hint: {
			base: 'Выберите из справочника основание для привлечения иностранца',
			permit_number: 'Укажите номер разрешения',
			dateOfPermit: 'Укажите дату выдачи разрешения',
			education: 'Выберите образование из списка',
			speciality: 'Выберите специальность из списка',
			qualification: 'Выберите квалификацию из списка',
		},
	},
	welfare: {
		tab: 'ПОРТРЕТ РАБОТНИКОВ',
		general: 'Общая информация по предприятию',
		totalEmployees: 'Всего работников',
		menWomen: 'Мужчин / Женщин',
		calculated: 'Данные рассчитываются раз в сутки, последнее обновление',
		info: 'Данные рассчитываются раз в сутки, последнее обновление: ',
		structure: 'Структура по статусам',
		pensioners: 'Пенсионеров',
		largeFamilies: 'Многодетных',
		disabilities: 'Лиц с инвалидностью',
		guardians: 'Опекунов за ЛСИ',
		chronic: 'С хроническими заболеваниями',
		recipients: 'Получателей АСП',
		hazardous: 'Занятых во вредных условиях',
		welfare: 'Благосостояние семьи работников',
		incomeSituation: 'Ситуация по доходам в семьях работников',
		monthlyMinimum: 'С доходом ниже прожиточного минимума (на члена семьи)',
		minimumWage: 'С доходом ниже минимальной заработной платы (на члена семьи)',
		lifeSituation: 'Жизненная ситуация в семьях работников',
		prosperous: 'Благополучная',
		satisfactory: 'Удовлетворительная',
		dysfunctional: 'Неблагополучная',
		crisis: 'Кризисная',
		emergency: 'Экстренная',
		nodata: 'По вашему предприятию отсутствует информация о благосостоянии работников',
		tabs: {
			general: 'ОБЩАЯ ИНФОРМАЦИЯ',
			employeeList: 'СПИСОК НУЖДАЮЩИХСЯ СОТРУДНИКОВ',
			requestButton: 'Запросить список работников из категорий: Кризисная, Экстренная',
			table: {
				iin: 'ИИН',
				fio: 'Положено выплатить (тг.)',
				status: 'Жизненная ситуация в семьях работников',
			},
			search: {
				enterIIN: 'Введите ИИН или фамилию сотрудника',
				total: 'Всего нуждающихся',
				sendRequestCnt: 'Запрошено согласий',
				consentCnt: 'Предоставили согласие',
			},
			tabs: {
				all: 'ВСЕ',
				c: 'С (Неблагополучная)',
				d: 'D (Кризисная)',
				e: 'Е (Экстренная)',
			},
			modal: {
				button: 'Отправить запросы на согласие',
			},
			list: 'Посмотреть список нуждающихся работников',
			hint: 'В списке будут отображаться работники из категорий Кризисная и Экстренная, которые предоставят согласие на сбор и обработку персональных данных',
		},
	},
	payment: {
		tab: 'Спец.Соц.Выплата',
		title: 'Информация по специальной социальной выплате',
		calendarTab: 'КАЛЕНДАРЬ ПЛАТЕЖЕЙ',
		paymentTab: 'ЗАПРОСЫ НА СПЕЦ.СОЦ.ВЫПЛАТУ',
		transferTab: 'ДЕТАЛИЗАЦИЯ ПО ТРАНСФЕРТАМ',
		assignedForPayment: 'Назначено к выплате',
		dueToBePaid: 'Положено выплатить',
		paidToPersons: 'Выплачено лицам',
		refund: 'Возврат средств',
		employersDebt: 'Задолжность работодателя',
		table: {
			assignedForPayment: 'Назначено к выплате',
			appointmentDate: 'Дата назначения',
			dueToBePaid: 'Положено выплатить (тг.)',
			paidToPerson: 'Выплачено человеку (тг.)',
			refund: 'Возврат средств (тг.)',
			employersDebt: 'Задолжность работодателя (тг.)',
		},
		briefly: 'Кратко',
		details: 'Подробно',
		sectionUnderDevelopment: 'Раздел в разработке',
		event: 'Событие',
		status_history: 'История статусов',
		request_from_ESUTD: 'Запросить из ЕСУТД',
	},
	transfer: {
		emplCount: 'Назначено к выплате',
		errorCount: 'Количество ошибок по трансфертам',
		table: {
			fio: 'Назначено к выплате',
			docDate: 'Дата отправки платежного поручения',
			payDate: 'Дата валютирования',
			refer: 'Референс платежа',
			amount: 'Сумма платежа (тг.)',
			period: 'Период',
			error: 'Описание ошибки',
			retDate: 'Дата возврата',
			retRefer: 'Референс возврата',
			retAmount: 'Возврат средств (тг.)',
		},
	},
	staff: {
		status: 'Статус ЕСУТД:',
		refreshStatus: 'Обновить статус',
		stop: 'Подождите!',
		info_no_staff: 'Нет утверждённого штатного расписания.',
		staff_units: 'Штатных единиц',
		staff_units_placeholder: 'Введите кол.-во',
		actual_salary_placeholder: 'Введите оклад факт',
		count_bets: 'Количество ставок',
		substitute_yin: 'ИИН замещаемого сотрудника',
		version: 'Версия: ',
		remove_staffing_project: 'Вы удаляете проект Штатного расписания. Действие невозможно будет отменить.',
		remove_struct: 'Вы удаляете структурное подразделение. Действие невозможно будет отменить.',
		bold_question_remove: ' Вы уверены, что хотите продолжить?',
		del_current_position: 'Вы действительно хотите удалить текущую должность',
		information_workplace_position: 'Просмотр сведений о рабочем месте и должности',
		staff_units_required: 'Штатных единиц *',
		staff_units_count_hint: 'Введите количество копий, которое необходимо создать для данной должности',
		errors: 'Ошибки',
		order_no: 'Приказ №',
		reason: 'Основание/Причина',
		version_history: 'Версия',
		error_info: 'Ошибка: нажмите просмотр',
		error_struct_or_wp: 'Имеются ошибки в Штатном расписании',
		error_status: 'Ошибка!',
		error_number: 'Ошибка: ',
		question: 'Имеется новая версия Штатного расписания. Хотите ее загрузить?',
		sign_and_request: 'Подписать и запросить',
		status_get_new_version_error:
			'Вы используете устаревшую версию штатного расписания, Вам не доступны некоторые действия',
		error_position_nkz:
			'"Должность на основе НКЗ" не соответствует "Должности на основе НКЗ" из Трудового договора. Назначение невозможно. Отредактируйте договор или штатное расписание.',
		error_position:
			'"Должность" не совпадает с "Должностью" из трудового договора. Назначение невозможно. Отредактируйте договор или штатное расписание.',
		error_empty_contract: 'У работника не найдено трудовых договоров',
		error_no_contract: 'Договор не найден',
		substitute_fio: 'Фамилия, имя и отчество замещаемого сотрудника',
		group_crate: 'Создать группу профессий',
		create_group: 'Создание группы профессий',
		edit_group: 'Редактирование группы профессий',
		info_no_group: 'Не создано не одной группы профессий',
		remove_group:
			'Вы удаляете группу профессий. Действие невозможно будет отменить. Вы уверены, что хотите продолжить?',
		remove_workplace:
			'Вы удаляете рабочее место. Действие невозможно будет отменить. Вы уверены, что хотите продолжить?',
		count_tariff_rate_all: 'Количество единиц (всего/свободно)',
	},
	profUnions: {
		name: 'Профсоюзы',
		generalInformation: 'Общие сведения',
		addGeneralInformation: 'Добавить сведения о профсоюзе',
		info: 'В случае если вы являетесь отраслевым или локальным профессиональным союзом, необходимо заполнить обязательные сведения',
		createTitle: 'Создание личного кабинета профсоюза',
		editTitle: 'Редактирование личного кабинета профсоюза',
		approveProfUnionsField: 'Необходимо подтвердить информацию, внесенную членской организацией.',
		unionInfo: 'Информация о профсоюзе',
		createDate: 'Дата создания профсоюза',
		unionType: 'Тип профсоюза',
		industry: 'Отрасль',
		descriptionUnion: 'Описание деятельности профессионального союза',
		placeholderUnion: 'Введите описание профсоюза',
		titleGoverning: 'Состав профсоюзного органа',
		managerGoverning: 'Член профсоюзного органа',
		innChairman: 'ИИН Председателя',
		manager: 'Член руководящего органа',
		managersList: 'Список членов профсоюзного органа',
		position: 'Должность',
		addMember: 'Добавить члена руководящего органа',
		charter: 'Устав профсоюза',
		protocol: 'Протокол совещания',
		registration: 'Справка о государственной регистрации',
		cannotUpload: 'Вы не можете загрузить больше файлов',
		information: 'Сведения о профсоюзе',
		industryUnion: 'Отраслевой профсоюз',
		tradeUnions: 'Список профсоюзов',
		addProfUnion: 'Добавить профсоюз',
		docs: 'Документы',
		infoList:
			'У вас отсутствуют структурные подразделения. Вы можете добавить их самостоятельно, либо подтвердить вступление по запросу локального или первичного профсоюза',
		employee_info_list: 'В вашей организации нет профсоюзов',
		personsEmptyInfo:
			'У данного профсоюза отсутствуют члены профсоюза. Профсоюз может добавить их самостоятельно, либо подтвердить вступление по запросу.',
		tradeUnionRegulations: 'Положение профсоюза',
		structuralUnit: 'Является структурным подразделением:',
		memberUnit: 'Является членской организацией:',
		addMemberUnit: 'Добавить членскую организацию',
		structInfoUnit: 'Входит в состав',
		count_manager: 'Количество членов',
		approved: 'Подтверждено',
		excluded: 'Исключен из профсоюза',
		not_approved: 'Не подтвержден',
		not_approved_prof: 'Не подтвержден профсоюзом',
		rejected_prof: 'Отклонен профсоюзом',
		rejected_prof_unions: 'Отклонен членской организацией',
		not_approved_prof_unions: 'Не подтвержден членским профсоюзом',
		placeholder_primary: 'Введите наименование профсоюза',
		info_list_employee:
			'В случае если вы являетесь первичным профессиональным союзом, необходимо заполнить обязательные сведения',
		employee_trade_unions: 'Мои профсоюзы',
		trade_members: 'Члены профсоюза',
		add_prof_union_member: 'Добавить члена профсоюза',
		info_members: 'В вашем профессиональном союзе еще нет членов',
		add_members_title: 'Добавление членов профсоюза',
		date_in: 'Дата вступления',
		fio: 'Фамилия Имя Отчество',
		chairman_trade_union: 'Председатель профсоюза',
		noDataTradeUnion: 'Нет данных о профсоюзе',
		unionStatus: 'Статус',
		approved_members: 'Состоит',
		not_members: 'Не состоит',
		not_approved_members: 'Ожидает утверждение',
		status_members: 'Статус членства',
	},
	contactPhone: 'Контактный телефон',
	contactPhonePlaceholder: 'Введите контактный телефон',
	laborProtection: 'Охрана труда',
	accidents: 'Несчастные случаи',
	gender: 'Пол',
	day: 'день',
	day1: 'дней',
	day2: 'дня',
	accidentsPage: {
		registerAccident: 'Зарегистрировать несчастный случай',
		accidentDate: 'Дата несчастного случая',
		victimFullName: 'ФИО пострадавшего',
		victimSurname: 'Фамилия',
		victimFirstname: 'Имя',
		victimSecondName: 'Отчество',
		placeholderSurname: 'Введите фамилию',
		placeholderFirstname: 'Введите имя',
		placeholderSecondName: 'Введите отчество',
		victimIin: 'ИИН пострадавшего',
		senderIin: 'ИИН заявителя',
		severity: 'Степень тяжести',
		state: 'Состояние',
		executionPeriod: 'Срок исполнения',
		noAccidents: 'Не зарегистрировано ни одного несчастного случая',
		groupAccident: 'Групповой',
		registration_new_accident: 'Регистрация несчастного случая',
		accidentReport: 'Сообщение о несчастном случае',
		register: {
			accidentDate: 'Дата и время несчастного случая',
			incidentScene: 'Место происшествия',
			circumstances: 'Обстоятельства несчастного случая',
			selectRegion: 'Выберите регион',
			selectDistrict: 'Выберите район',
			victim: 'Пострадавший',
			resident: 'Резидент РК',
			icd10Code: 'Код диагноза по МКБ 10',
			icd10NameProf: 'Диагноз (указать профзаболевание)',
			selectIcd10: 'Введите диагноз',
			addVictim: 'Добавить пострадавшего',
			responsibleFromGovernment: 'Ответственный от ГО',
			applicant: 'Заявитель',
			birthday: 'Дата рождения',
			passport: 'Паспорт',
			issuer: 'Кем выдан',
			takenDate: 'Когда выдан',
			issuerName: 'Наименование органа',
			number: 'Номер',
			positionNkz: 'Должность по НКЗ',
			position: 'Должность',
			incidentSceneHint: 'Необходимо указать полный адрес происшествия'
		},
		view: {
			accidentShortDate: 'Дата и время НС',
			circumstances: 'Обстоятельства НС',
			victims: 'Пострадавшие',
			diagnosis: 'Диагноз (профзаболевание)',
			issued: ' выдан ',
			responsiblePerson: 'Ожидается назначение ответственного от ГО (инспектор труда)',
			personCharge: 'Отвественный от ГО',
			organization: 'Организация',
		},
		icd: 'Код МКБ-10',
		boss: 'Руководитель /и.о рукодовителя',
		send_data_value: 'Дата отправки сообщения о несчастном случае: {{date}}',
		icd_diagnosis: 'Диагноз (МКБ-10)',
		fio_condition_error: 'Введите одно из трех значений',
		conclusionSeverity: {
			title: 'Заключение о степени тяжести',
			category: 'Категория происшествия',
			category_placeholder: 'Выберите категорию происшествия',
			med_doc: 'Справка из медицинского учреждения',
			doc_date: 'Дата документа'
		},
		doc: 'Справка',
		startDate: 'Дата отправки данных о степени тяжести: {{date}}',
		investigationAccidents: {
			title: 'Расследование несчастного случая'
		}
	},
	grading_of_government_employees: 'Грейдирование государственных служащих',
	position_evaluation: 'Оценка должности',
	grading: 'Грейдирование',
	rate_position: 'Оценить должность',
	position_evaluation_page: {
		sphere: 'Сфера',
		number: '№',
		jobTitle: 'Должность',
		description: 'Описание должности',
		factorCode: 'Код фактора',
		factors: 'Факторы ',
		explanations: 'Пояснения',
		finalScore: 'Итоговый балл',
		actions: 'Действия',
		noData: 'Не добавлено ни одной оценки',
		loading: 'Загрузка',
		totalPointsAre: 'Итоговый балл составляет',
		mrpOn: 'МРП на {{year}} г.',
		pointCost: 'Стоимость балла (2% от МРП)',
		grade: 'Грейд должности',
		coef: 'Попр коэф.',
		salary: 'Должностной оклад',
		gradePoint: 'Балл за грейд',
		educationPoint: 'Балл за образование',
		experiencePoint: 'Балл за опыт работы (стаж)',
		categoryPoint: 'Балл за категорию',
		form: {
			occupation: 'Сфера деятельности',
			group: 'Группа',
			bin: 'БИН организации',
			organization: 'Организация',
			position_by_nkz: 'Должность НКЗ, согласно штатному расписанию',
			functionalBlock: 'Функциональный блок',
			education: 'Образование',
			workExperience: 'Стаж работы',
			category: 'Категория',
			increaseForRuralWork: 'Повышение за работу в сельской местности',
			calculate: 'Рассчитать',
			number: 'Номер',
			functions: 'Функции',
			featurePoints: 'Баллы функций',
			subfactorCode: 'Код подфактора',
			subfactors: 'Подфакторы',
			factorScores: 'Баллы факторов',
			selectFunction: 'Выберите функцию',
			functionsAndFactors: 'Функции и факторы',
		},
	},
	notification_open_my_unions: 'Перейти',
	industryAgreement: {
		title: 'Отраслевые соглашения',
		create: 'Зарегистрировать отраслевое соглашение',
		edit: 'Редактировать',
		titleCreate: 'Регистрация отраслевого соглашения',
		titleEdit: 'Редактирование отраслевого соглашения',
		info: 'Отраслевые соглашения не зарегистрированы',
		agreement_data: 'Данные соглашения',
		industryAgreementName: 'Наименование отраслевого соглашения',
		industryAgreementNameKz: 'Наименование отраслевого соглашения на казахском языке',
		industryAgreementNameRu: 'Наименование отраслевого соглашения на русском языке',
		placeholder_name: 'Введите наименование',
		authStateName: 'Наименование уполномоченного государственного органа соответствующей сферы деятельности',
		authStateNameKz:
			'Наименование уполномоченного государственного органа соответствующей сферы деятельности на казахском языке',
		authStateNameRu:
			'Наименование уполномоченного государственного органа соответствующей сферы деятельности на русском языке',
		industryAgreement: 'Вид отрасли(ей)',
		information_industry: 'Информация об отраслевых Профсоюзах',
		union: 'Профсоюз №',
		tradeUnionNameKz: 'Наименование отраслевого профсоюза на казахском языке',
		tradeUnionNameRu: 'Наименование отраслевого профсоюза на русском языке',
		add_union: 'Добавить отраслевой профсоюз',
		information_associations: 'Информация об отраслевых объединениях работодателей',
		associations: 'Объединение работодателей №',
		employerAssociationNameKz: 'Наименование отраслевого объединения работодателей на казахском языке',
		employerAssociationNameRu: 'Наименование отраслевого объединения работодателей на русском языке',
		add_association: 'Добавить отраслевое объединение работодателей',
		information: 'Информация об отраслевом соглашении',
		createDate: 'Дата регистрации',
		dateFrom: 'Дата заключения',
		dateTo: 'Дата окончания действия',
		coefficients: 'Об установлении межразрядных коэффициентов',
		industrialCoef: 'Отраслевой коэффициент, классифицирующих условия труда по степени вредности и опасности',
		baseSalary: 'Минимальная тарифная ставка (оклад)',
		oneToTwoGradeCoef: 'Минимальное значение межразрядного коэффициента между I и II разрядами',
		twoToThreeGradeCoef: 'Минимальное значение межразрядного коэффициента между II и III разрядами',
		threeToFourGradeCoef: 'Минимальное значение межразрядного коэффициента между III и IV разрядами',
		fourToFiveGradeCoef: 'Минимальное значение межразрядного коэффициента между IV и V разрядами',
		fiveToSixGradeCoef: 'Минимальное значение межразрядного коэффициента между V и VI разрядами',
		sixToSevenGradeCoef: 'Минимальное значение межразрядного коэффициента между VI и VII разрядами',
		sevenToEightGradeCoef: 'Минимальное значение межразрядного коэффициента между VII и VIII разрядами',
		scanned: 'Скан-копия отраслевого соглашения',
		bin: 'БИН отраслевого профсоюза',
		bin_employer: 'БИН отраслевого объединения работодателей',
		error_message: 'Отраслевой профсоюз не найден, проверьте БИН',
		guarantee_title: 'Дополнительные гарантии и льготы для работников, предусмотренные отраслевыми соглашениями',
		view: {
			title: 'Отраслевое соглашение',
			tradeUnions: 'Информация об отраслевых профсоюзах',
			employers: 'Информация об отраслевых объединениях работодателей',
		},
		table: {
			note: 'Примечание (изменение)',
			copy: 'Скан-копия соглашения',
			name: 'История отраслевого соглашения',
		},
		edit_info: 'Информация об изменениях',
		updateDateTime: 'Дата изменений',
		updateTextKz: 'Примечание к изменениям на казахском языке',
		updateTextRu: 'Примечание к изменениям на русском языке',
		updateText_placeholder: 'Введите информацию по изменениям',
		labelKz: ' (на казахском языке)',
		labelRu: ' (на русском языке)',
		confirm_modal: 'Данные по отраслевому соглашению будут сохранены. <br /> Подтвердите действие',
		edit_add: 'Внесение изменений или дополнений',
	},
	ckp_enterprise_passport: 'Паспорт предприятия',
	ckp_no_info_on_your_enterprise: 'По вашему предприятию информация отсутствует',
	ckp_general_data: 'Общие данные',
	ckp_objects: 'Объекты',
	ckp_OSRNS: 'ОСРНС',
	ckp_organizational_form: 'Организационная форма',
	ckp_BIN_IIN: 'БИН/ИИН',
	ckp_registration_date: 'Дата регистрации',
	ckp_ownership_right: 'Право собственности',
	ckp_legal_address: 'Юр. Адрес',
	ckp_region: 'Регион',
	ckp_phone: 'Телефон',
	ckp_manager: 'Руководитель',
	ckp_statistics: 'Статистика',
	ckp_risk_level: 'Уровень риска',
	ckp_average_rating: 'Средняя оценка',
	ckp_employees: 'Сотрудников',
	ckp_citizens_foreigners: 'Граждан РК/ Иностранцев',
	ckp_salary_for_12_24_months: 'СМЗ за 12 мес./ за 24 мес.',
	ckp_salary_by_region_and_OKED: 'СМЗ по региону и ОКЭД/ СМЗ',
	ckp_median_for_12_24_months: 'Медиана за 12 мес./ за 24 мес.',
	ckp_salary_at_enterprise: 'СМЗ на предприятии',
	ckp_salary_for_citizens_foreigners: 'СМЗ у граждан РК/ У иностранцев',
	ckp_full_enterprise_passport: 'Полный паспорт предприятия',
	ckp_high: 'Высокий',
	ckp_absent: 'Отсутствует',
	ckp_medium: 'Средний',
	ckp_low: 'Низкий',
	ckp_object_data_in_this_tab:
		'В данной вкладке данные об объектах субъекта по данным с Комитета по правовой статистике и специальным учетам Генеральной прокуратуры Республики Казахстан',
	ckp_status: 'Статус',
	ckp_active: 'Действующий',
	ckp_inactive: 'Недействующий',
	ckp_total_OSRNS_contracts: 'Всего договоров ОСРНС',
	ckp_total_employees_insured_uninsured: '(застрахованных/ незастрахованных)',
	ckp_contract_number_series: '№ кода ЕСБД',
	ckp_conclusion_date: 'Дата заключения',
	ckp_start_date: 'Начало действия',
	ckp_end_date: 'Дата завершения',
	ckp_insurance_company: 'Страховая компания',
	ckp_insured_employees_count: 'Количество застрахованных работников',
	ckp_validity_period: 'Срок действия',
	ckp_insurer_BIN_IIN: 'ИИН/БИН страховщика',
	ckp_insurance_company_name: 'Страховая компания (наименование)',
	ckp_total_annual_payroll: 'Общий годовой ФОТ',
	ckp_version_number: '№ версии',
	ckp_version_date: 'Дата версии',
	ckp_insurance_premium: 'Страховая премия',
	ckp_total_employees: 'Всего работников',
	ckp_branch_BIN: 'БИН филиала',
	ckp_number_of_workers: 'Кол-во рабочих (без учета типа персонала)',
	ckp_inspections: 'Проверки',
	ckp_total_professional_control: 'Всего (проф. контроль/ внеплановые/ поручения)',
	ckp_active_completed: 'Дейcтвующие/ завершенные',
	ckp_active_completed_osrns: '(действующих/ прекращенных)',
	ckp_instructions_issued: 'Внесено предписаний',
	ckp_administrative_cases_initiated: 'Возбуждено административных дел',
	ckp_measures_taken: 'Принятые меры',
	ckp_KPSU_number: '№ КПСиСУ',
	ckp_inspection_type: 'Вид проверки',
	ckp_execution_period: 'Срок проведения',
	ckp_inspector: 'Инспектор',
	ckp_unscheduled: 'Внеплановая',
	ckp_preventive_control: 'Профилактический контроль',
	ckp_violations_monitoring: 'Мониторинг нарушений',
	ckp_employment_contracts: 'Трудовых договоров',
	ckp_total_OPV: 'Всего ОПВ',
	ckp_discrepancy_OPV_TD: 'Расхождение ОПВ и ТД',
	ckp_discrepancy_TD_OPV: 'Расхождение ТД и ОПВ',
	ckp_IRS_permissions: 'Разрешения ИРС',
	ckp_labor_migrants: 'Трудовых мигрантов',
	ckp_detection_date: 'Дата выявления',
	ckp_violation_type: 'Тип нарушения',
	ckp_description: 'Описание',
	ckp_info_on_violations_updated_monthly: 'Информация о действующих нарушениях обновляется раз в месяц',
	ckp_workers: 'Работников',
	ckp_source: 'Источник',

	ckp_general_info: 'Общая информация',
	ckp_name: 'Наименование',
	ckp_BIN: 'БИН',
	ckp_address: 'Адрес',
	ckp_contact_info: 'Контактная информация',
	ckp_OKED: 'ОКЭД',
	ckp_Keitz_index: 'Индекс Кейтца',
	ckp_risk_map_indicators: 'Показатели карты трудовых рисков',
	ckp_labor_risks: 'Трудовые риски',
	ckp_financial_risks: 'Финансовые риски',
	ckp_social_risks: 'Социальные риски',
	ckp_moderate_severe_injuries: 'Средний и тяжелый травматизм',
	ckp_staff_growth_percentage: '% прирост штата',
	ckp_staff_turnover_percentage: '% текучести кадров',
	ckp_dismissed_for_negative_reasons_percentage: 'Доля уволенных по отрицательным мотивам',
	ckp_management_foreigners_vs_citizens_ratio: 'Соотношение в руководстве иностранцев и граждан РК',
	ckp_ERSON_inspections: 'Проверки ЕРСОП',
	ckp_foreigners_in_staff_percentage: '% иностранцев в штате',
	ckp_city_forming_enterprise: 'Признак градообразующего предприятия',
	ckp_salary_difference_foreign_vs_citizens_management: 'Разница в оплате труда руководителей иностранцев и граждан РК',
	ckp_current_salary_below_30_percent: 'Текущая СМЗ меньше на 30% чем в регионе и ОКЭД',
	ckp_salary_disproportion_max_vs_min: 'Диспропорция между максимальной и минимальной СМЗ',
	ckp_salary_growth_rate: 'Темп роста ЗП',
	ckp_overdue_credit_percentage: 'Доля с просрочкой по кредиту более 90 дней',
	ckp_harmful_production_staff_percentage: 'Доля сотрудников с вредным производством',
	ckp_large_family_staff_percentage: 'Доля многодетных сотрудников',
	ckp_non_local_staff_percentage: 'Доля неместных',
	ckp_young_staff_percentage: 'Доля сотрудников до 30 лет',
	ckp_group_DE_percentage: 'Доля сотрудников относящихся к группе D, E',
	ckp_enterprise_portrait: 'Портрет предприятия',
	ckp_total_staff: 'Общее количество работников',
	ckp_total_OPV_staff_last_3_months: 'Общее количество работников по ОПВ за последние 3 месяца',
	ckp_average_salary_per_month: 'Среднемесячная заработная плата, тг',
	ckp_median_salary_per_month: 'Медианная заработная плата, тг',
	ckp_last_12_months: 'Последние 12 мес.',
	ckp_last_24_months: 'Последние 24 мес.',
	ckp_employment_dismissal: 'Трудоустройство/ увольнение',
	ckp_employed: 'Трудоустроившихся',
	ckp_dismissed: 'Уволенных',
	ckp_dismissed_negative_reasons: 'По отрицательным мотивам',
	ckp_total_inspections: 'Количество проверок',
	ckp_prof_control: 'Проф. Контроль',
	ckp_unscheduled_inspections: 'Внеплановые',
	ckp_active_cases: 'Действующие',
	ckp_completed_cases: 'Завершенные',
	ckp_measures_on_inspections: 'Меры по проверкам',
	ckp_instructions_given: 'Выдано предписаний',
	ckp_administrative_cases_opened: 'Возбуждено адм. дел',
	ckp_OSRNS_contracts: 'Договора ОСРНС',
	ckp_available_documents: 'Имеется',
	ckp_not_available_documents: 'Не имеется',
	ckp_active_contracts: 'Действующих',
	ckp_terminated_contracts: 'Расторгнутых',
	ckp_injury_cases: 'Травматизм',
	ckp_light_moderate_injuries: 'Легкая/Средняя степень',
	ckp_severe_injuries: 'Тяжелая степень',
	ckp_fatalities: 'Погибших',
	ckp_violations: 'Нарушения',
	ckp_workers_portrait: 'Портрет работников',
	ckp_status_based: 'По статусам',
	ckp_welfare_based: 'По благосостоянию',
	ckp_hazardous_conditions: 'Во вредных условиях труда (по ОППВ)',
	ckp_local_workers: 'Местных',
	ckp_non_local_workers: 'Неместных',
	ckp_seasonal_workers: 'Сезонных',
	ckp_large_family_percentage: 'Многодетных',
	ckp_ASP_recipients: 'Получателей АСП',
	ckp_LSI_percentage: 'ЛСИ',
	ckp_chronic_conditions_percentage: 'С хроническими заболеваниями',
	ckp_income_per_family_member: 'Доходность (на члена семьи)',
	ckp_indebtedness: 'Закредитованность',
	ckp_category_A: 'Категория A',
	ckp_category_B: 'Категория B',
	ckp_category_C: 'Категория C',
	ckp_category_D: 'Категория D',
	ckp_category_E: 'Категория E',
	ckp_below_poverty_line: 'Ниже прожиточного минимума',
	ckp_below_minimum_wage: 'Ниже минимальной заработной платы',
	ckp_has_loans: 'Имеют кредиты',
	ckp_loan_overdue_90_days: 'С просрочкой более 90 дней',
	ckp_ERSON_registration: 'Регистрация в ЕРСОП',
	ckp_ERSON_registration_denied: 'Отказано в регистрации ЕРСОП',
	ckp_ERSON_refinement_in_GO: 'На доработку в ГО',
	ckp_ERSON_registered: 'Зарегистрирована в ЕРСОП',
	ckp_suspended: 'Приостановлена',
	ckp_resumed: 'Возобновлена',
	ckp_canceled_inspection: 'Отменена проверка',
	ckp_completed: 'Завершена',
	ckp_checks: 'Проверки',
	ckp_foreginers: 'Иностранцев',
	ckp_download_pdf: 'Скачать PDF',
	ckp_from: 'с',
	ckp_to: 'по',
	ckp_check_title: 'Сведения о проверках',
	ckp_abbreviations:
		'КПСИСУ - Комитет по правовой статистике и специальным учетам\n' +
		'ЕРСОП - Единый реестр субъектов и объектов проверок\n' +
		'ГГИТ - Главный государственный инспектор труда\n' +
		'ГО - Государственный орган\n',
	reviews: {
		title: 'Отзывы',
		employee_review: 'Отзыв о сотруднике',
		employee_rating: 'Оценка работника',
		employer_rating: 'Оценка работодателя',
		set_review_employer: 'Оставить отзыв работодателю',
		set_review_employee: 'Оставить отзыв работнику',
		edit_answer: 'Редактировать ответ',
		delete_answer: 'Удалить ответ',
		edit_review: 'Редактировать отзыв',
		delete_review: 'Удалить отзыв',
		employee_answer: 'Ответ работника',
		employer_answer: 'Ответ работодателя',
		set_review: 'Оставить отзыв',
		set_review_employee_agreement: 'Вы действительно хотите оставить отзыв о работнике?',
		set_review_employer_agreement: 'Вы действительно хотите оставить отзыв о работодателе?',
		delete_review_employee_agreement:
			'Вы действительно хотите удалить отзыв о работнике? В случае внесения изменений, у работодателей, которые запрашивали отзывы по работнику ранее, останется старый отзыв.',
		delete_review_employer_agreement: 'Вы действительно хотите удалить отзыв о работодателе?',
		edit_review_employee_agreement: 'Вы действительно хотите отредактировать отзыв о работодателе?',
		edit_review_employer_agreement:
			'Вы действительно хотите отредактировать отзыв о работнике? В случае внесения изменений, у работодателей, которые запрашивали отзывы по работнику ранее, останется старый отзыв.',
		set_answer: 'Оставить ответ',
		set_answer_agreement: 'Вы действительно хотите оставить ответ на отзыв?',
		edit_answer_employee_agreement: 'Вы действительно хотите отредактировать ответ?',
		edit_answer_employer_agreement:
			'Вы действительно хотите отредактировать ответ? В случае внесения изменений, у работодателей, которые запрашивали отзывы по работнику ранее, останется старый отзыв.',
		delete_answer_agreement:
			'Вы действительно хотите удалить ответ на отзыв? В случае внесения изменений, у работодателей, которые запрашивали отзывы по работнику ранее, останется старый отзыв.',
		answer: 'Ответить',
		my_reviews: 'Мои отзывы',
		reviews_about_me: 'Отзывы обо мне',
		mark: 'Оценка',
		count: 'Кол-во',
		marks: 'Оценок',
		avg_ball: 'Средний балл',
		success_payload: 'Успешно подписан!',
		review_deleted_employer: 'Отзыв удален работодателем',
		review_deleted_employee: 'Отзыв удален работником',
		review_text_null: '(Без отзыва)',
		placeholder_text: 'Введите текст',
		terminate_alert_text:
			'При внесении отзыва о контрагенте, пользователь несет полную ответственность за предоставленную информацию. В случае внесения недостоверной информации на онлайн-платформах предусмотрена юридическая ответственность. Согласно пункту 1 статьи 14 Закона Республики Казахстан «О средствах массовой информации», а также статье 456-2 Кодекса Республики Казахстан «Об административных правонарушениях», распространение ложной информации влечет административную ответственность.',
		view_alert_text_employee:
			'При внесении отзыва о работнике, пользователь несет полную ответственность за предоставленную информацию. В случае внесения недостоверной информации на онлайн-платформах предусмотрена юридическая ответственность. Согласно пункту 1 статьи 14 Закона Республики Казахстан «О средствах массовой информации», а также статье 456-2 Кодекса Республики Казахстан «Об административных правонарушениях», распространение ложной информации влечет административную ответственность.',
		view_alert_text_employer:
			'При внесении отзыва о работодателе, пользователь несет полную ответственность за предоставленную информацию. В случае внесения недостоверной информации на онлайн-платформах предусмотрена юридическая ответственность. Согласно пункту 1 статьи 14 Закона Республики Казахстан «О средствах массовой информации», а также статье 456-2 Кодекса Республики Казахстан «Об административных правонарушениях», распространение ложной информации влечет административную ответственность.',
		star1: 'Очень плохо',
		star2: 'Плохо',
		star3: 'Удовлетворительно',
		star4: 'Хорошо',
		star5: 'Отлично',
	},
	administration: {
		title: 'Администрирование',
		query: 'Запрос',
		set_access: 'Предоставление доступа',
		sign_changes: 'Подписать изменения',
		view_register_emp_contracts: 'Просмотр и регистрация трудовых договоров',
		view_staffing_schedule: 'Просмотр штатного расписания',
		register_staffing_schedule: 'Регистрация штатного расписания',
		requested_with_view_staffing_schedule: '(Запрашивается вместе с просмотром штатного расписания)',
		canAccess: 'Есть доступ',
		request_send: 'Запрос направлен',
		noAccess: 'Нет доступа',
		request: 'Запросить',
		revoke: 'Отозвать',
		default_alert: 'Запрос рассматривается в течение 3 рабочих дней, после чего можно отправить его повторно.',
		isSelected_alert: 'Для сохранения, изменения необходимо подписать с помощью ЭЦП',
		you_set_access: 'Вы предоставили доступ',
		you_revoke_access: 'Вы отозвали доступ',
		set_request_from_you: 'У вас запросили доступ',
		get_access_warning:
			'Для запроса прав доступа по иной организации из филиальной сети, перейдите на страницу «Администрирование»',
	},
	sickLeave: {
		title: 'Больничные листы',
		open_date: 'Дата открытия',
		closed_date: 'Дата закрытия',
		med_org: 'Медицинское учреждение',
		open: 'Открыт',
		continue: 'Продлен',
		close: 'Закрыт',
		deleted: 'Удален',
		number: 'Больничный лист №{{number}}',
		information: 'Сведения',
		date_end_work: 'Период освобождения от работы',
		start_date_work: 'Приступить к работе',
		diagnosis: 'Диагноз',
		type_temporary_disability: 'Вид временной нетрудоспособности',
		mode_type: 'Тип режима',
		send_employer: 'Отправление работодателю',
		choose_employer: 'Выберите работодателя',
		approve_personal_data: 'Даю согласие на обработку персональных данных',
		employee_alert:
			'В данном разделе отображается электронные больничные листы, поступающие из информационной системы Министерства здравоохранения РК. Вы можете оповестить работодателя о временной нетрудоспособности, отправив сведения в личный кабинет работодателя.',
		employer_alert:
			'В данном разделе отображается электронные больничные листы работников, поступающие из информационной системы Министерства здравоохранения РК, направленные вам работниками из личного кабинета или мобильного приложения HR Enbek для оповещения о временной нетрудоспособности.',
	},
	ecollective_contract: {
		approved_status: 'Согласовано',
		rejected_status: 'Не согласовано',
		pending_status: 'Ожидает согласования',
		labor_inspectorate_officer: 'Сотрудник инспекции по труду',
		comment_from_the_labor_inspectorate: 'Комментарий инспекции труда',
	},
	requirement_labor_resources: {
		title: 'Потребность трудовых ресурсов',
		agroProducer: 'Паспорт сельхозтоваропроизводителя',
		cropCultivation: 'Возделывание сельскохозяйственных культур',
		animalHusbandry: 'Содержание скота',
		land_fund: 'Земельный фонд',
		sowing_area: 'Посевная площадь',
		livestock_headcount: 'Поголовье скота',
		area_ha: 'Площадь, га',
		cadastral_number: 'Кадастровый номер',
		crop: 'Культура',
		animals: 'Животные',
		headcount: 'Поголовье',
		work_name: 'Наименование работ',
		profession_name: 'Наименование профессий',
		standart_number: 'Нормируемая численность, чел',
		sowingArea: 'Площадь посевов, га',
		stages_of_agricultural_work: 'Этапы сельскохозяйственных работ',
		labor_intensity_person_hours: 'Трудоемкость, чел-час',
		optimal_agrotechnical_terms: 'Оптимальные агротехнические сроки',
		regulated_number_of_workers_persons: 'Нормируемая численность, чел',
		works: 'Работы',
		total: 'Итого',
		norm_count_season: 'Нормируемая численность на сезон, чел',
		worker_count: 'Количество работников',
		empty_alert: 'По вам нет сведений в системе, либо Вы не являетесь сельхозпроизводителем.',
	},
	faq: {
		agreement: 'Cоглашения',
		choose_theme_question: 'Выбор темы вопроса',
		labelKz: 'казахский',
		labelRu: 'русский',
		export: 'Скачать',
		gen_agreement: 'Генеральное соглашение',
		reg_agreement: 'Региональные соглашения',
	},
	staff_alert:
		'Функционал "Штатное расписание" предназначен для управления структурой организации, штатным составом и численностью работников. Включает возможность указания заработной платы, надбавок, доплат, а также назначение действующих работников по зарегистрированным трудовым договорам на рабочие места.' +
		'<br/><strong>Примечание</strong>: <i>Законодательство не предусматривает обязательного внесения штатного расписания в Единую систему учета трудовых договоров, предоставляя работодателям свободу выбора в использовании данного инструмента по своему усмотрению.</i>',
	medical_card: {
		lmk_series: 'Серия ЛМК',
		workplace: 'Место работы',
		position: 'Должность',
		doctor_total: 'Допуск к работе (заключение терапевта)',
		period: 'Период допуска',
		doctor: 'Врач',
		medical_org: 'Медицинская организация',
		target_group: 'Целевая группа',
		status_approved: 'ДОПУЩЕН',
		status_disapproved: 'НЕ ДОПУЩЕН',
		status_expired: 'ПРОСРОЧЕН',
	},
	contract_alert:
		'Регистрируя трудовой договор, вы подтверждаете соблюдение норм <strong>подпункта 24 пункта 2 статьи 23 Трудового кодекса Республики Казахстан</strong>.',
	login_employer: 'Войти как работодатель',
	login_employee: 'Войти как работник',
	show_all_notifications: 'Показать все уведомления',
	hint_page_role: 'Здесь отображаются уведомления по всем предприятиям, добавленным к учетной записи.',
	flData_alert_add_contract:
		'<i>Вы собираетесь заключить электронное дополнительное соглашение с несовершеннолетним. Просим ознакомиться со списком работ на которые запрещено трудоустройство несовершеннолетних.</i>',
	alert_term_contract:
		'<i>Вы собираетесь расторгнуть электронный трудовой договор с несовершеннолетним. Если у несовершеннолетнего изменился представитель, необходимо ввести ИИН нового представителя.</i>',
	flData_Checkbox: 'Ознакомлен со ',
	flData_Checkbox_ref:
		'Списком работ, на которых запрещается применение труда работников, не достигших восемнадцатилетнего возраста',
	fl16_alert:
		'<i>Согласно Трудовому Кодексу РК статьи 31, пункта 3 наряду с несовершеннолетним, не достигшим шестнадцатилетнего возраста, трудовой договор должен подписываться одним из его законных представителей. Просим подтвердить, что Вы являетесь законным представителем для заключения электронного трудового договора. При нажатии на "Подтвердить данные представителя" Вам будет выслано СМС с запросом на доступ к данным. Просим дать согласие.</i>',
	errorTeenager16:
		'<i>Невозможно подписать электронный трудовой договор: проект договора создан для несовершеннолетнего.<i>',
	errorTeenager14:
		'<i>Согласно подпункту 3 пункта 2 статьи 31 Трудового Кодекса Республики Казахстан трудовой договор может быть заключен с лицами, не достигшими четырнадцатилетнего возраста в организациях кинематографии, театрах, театральных и концертных организациях, цирках для участия в создании и (или) исполнении произведений без ущерба здоровью и нравственному развитию с соблюдением условий<i>',
	fl16_button: 'Подтвердить данные представителя',
	approve_teenager: 'Согласовать',
	approve_title:
		'Для подписания электронного трудового договора необходимо согласие несовершеннолетнего с помощью СМС. Введите номер телефона несовершеннолетнего для получения согласия',
	send_sms_button: 'Отправить СМС',
	representative: 'Представитель несовершеннолетнего',
	isRepresentative: 'Я являюсь опекуном данного работника',
	success_get_representatives:
		'Запрос на получение данных успешно отправлен. Необходимо подтвердить согласие на обработку персональных данных.',
	isChildren: 'ТД по детям',
	representative_role: 'Представитель',
	error_bin_or_iin: 'БИН/ИИН работодателя не найден',
	info_contract_form: 'Заполните текстовые поля!',
	info_status_request: 'Статус подтверждения данных представителя успешно обновлён.',
	representative_requests: 'Запросы представителя',
	successfully_subscribed: 'Успешно подписано!',
	level: 'Ступень',
	experience: 'Стаж',
	unit: 'Уровень',
}
